// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/api.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PaginationRequest, PaginationResponse } from "../common/grpc";
import { Timestamp } from "../google/protobuf/timestamp";
import { CableModel, DeviceModel, DevicePSu } from "../models/bom";
import { ClaimResult } from "../models/claim";
import { Command } from "../models/commands";
import { Dashboard, DashboardFolder, Panel } from "../models/dashboard";
import { DciConfig, FabricMultisite } from "../models/dci";
import { Endpoint, NotificationSettings } from "../models/endpoints";
import {
  AirflowType,
  airflowTypeFromJSON,
  airflowTypeToJSON,
  BgpPolicyType,
  bgpPolicyTypeFromJSON,
  bgpPolicyTypeToJSON,
  CableType,
  cableTypeFromJSON,
  cableTypeToJSON,
  CandidateType,
  candidateTypeFromJSON,
  candidateTypeToJSON,
  EstimateStatus,
  estimateStatusFromJSON,
  estimateStatusToJSON,
  FabricTopology,
  fabricTopologyFromJSON,
  fabricTopologyToJSON,
  NodeRole,
  nodeRoleFromJSON,
  nodeRoleToJSON,
  ServerPortGroupType,
  serverPortGroupTypeFromJSON,
  serverPortGroupTypeToJSON,
  TaskStatusType,
  taskStatusTypeFromJSON,
  taskStatusTypeToJSON,
  TopologyGroupType,
  topologyGroupTypeFromJSON,
  topologyGroupTypeToJSON,
} from "../models/fabric";
import {
  FabricDesign,
  HwSet,
  NodePortConnectivityRule,
  NodePortOverrideRule,
  Rail,
  RailGroup,
  ServerGroup,
  ServerGroupConnectivityRule,
  SwitchGroup,
  SwitchGroupConnectivityRule,
  Tier,
} from "../models/fabric_design";
import {
  ClaimStatus,
  claimStatusFromJSON,
  claimStatusToJSON,
  ObjectType,
  objectTypeFromJSON,
  objectTypeToJSON,
  Operation,
  operationFromJSON,
  operationToJSON,
  OsType,
  osTypeFromJSON,
  osTypeToJSON,
} from "../models/global";
import { FabricSoftwareConfig } from "../models/image";
import {
  DhcpRelay,
  Fabric,
  Loopback,
  NetworkPort,
  Node,
  PortBreakout,
  PortChannel,
  ServerMgmtPort,
  StaticRoutes,
  SubInterface,
  Vlan,
  Vni,
  Vrf,
} from "../models/models";
import { OrgProperty } from "../models/policy";
import { ArsConfig, DscpConfig, IpmConfig, IpSlaConfig, PacketMirroring } from "../models/qos";
import { BgpPeer, BgpPolicy, PerVlanStp, PrefixList } from "../models/routing";
import { Certificates, PortConnection } from "../models/types";
import { WorkflowFeedback } from "../onprem/onprem";
import { WorkflowType, workflowTypeFromJSON, workflowTypeToJSON } from "../onprem/workflow";
import { ResourceReservation } from "./rest_resource_reservation";

export const protobufPackage = "configd";

/** PartStatus encapsulates status of a specific part. */
export enum PartStatus {
  PART_STATUS_UNSPECIFIED = 0,
  /** PART_STATUS_NEW - item needs to be purchased */
  PART_STATUS_NEW = 1,
  /** PART_STATUS_DEPLOYED - item is currently running in fabric */
  PART_STATUS_DEPLOYED = 2,
  /** PART_STATUS_DETECTED - item detected running in fabric */
  PART_STATUS_DETECTED = 3,
  UNRECOGNIZED = -1,
}

export function partStatusFromJSON(object: any): PartStatus {
  switch (object) {
    case 0:
    case "PART_STATUS_UNSPECIFIED":
      return PartStatus.PART_STATUS_UNSPECIFIED;
    case 1:
    case "PART_STATUS_NEW":
      return PartStatus.PART_STATUS_NEW;
    case 2:
    case "PART_STATUS_DEPLOYED":
      return PartStatus.PART_STATUS_DEPLOYED;
    case 3:
    case "PART_STATUS_DETECTED":
      return PartStatus.PART_STATUS_DETECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PartStatus.UNRECOGNIZED;
  }
}

export function partStatusToJSON(object: PartStatus): string {
  switch (object) {
    case PartStatus.PART_STATUS_UNSPECIFIED:
      return "PART_STATUS_UNSPECIFIED";
    case PartStatus.PART_STATUS_NEW:
      return "PART_STATUS_NEW";
    case PartStatus.PART_STATUS_DEPLOYED:
      return "PART_STATUS_DEPLOYED";
    case PartStatus.PART_STATUS_DETECTED:
      return "PART_STATUS_DETECTED";
    case PartStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** BomType encapsulates type of a Bom Item. */
export enum BomType {
  BOM_TYPE_UNSPECIFIED = 0,
  /** BOM_TYPE_HARDWARE - item type is Device/Switch */
  BOM_TYPE_HARDWARE = 1,
  /** BOM_TYPE_SERVICE - item type is Service */
  BOM_TYPE_SERVICE = 2,
  /** BOM_TYPE_CHASSIS - item type is Chassis */
  BOM_TYPE_CHASSIS = 3,
  /** BOM_TYPE_OPTICS - item type is optics pluggable */
  BOM_TYPE_OPTICS = 4,
  /** BOM_TYPE_FAN - item type is Fan */
  BOM_TYPE_FAN = 5,
  /** BOM_TYPE_PSU - item type is Power supply Unit */
  BOM_TYPE_PSU = 6,
  /** BOM_TYPE_ENTITLEMENT - item type is Entitlement */
  BOM_TYPE_ENTITLEMENT = 7,
  /** BOM_TYPE_MLB - item type is Major Line Bundle */
  BOM_TYPE_MLB = 8,
  /** BOM_TYPE_CABLE - item type is Cable */
  BOM_TYPE_CABLE = 9,
  /** BOM_TYPE_AIRFLOW - item type is Airflow */
  BOM_TYPE_AIRFLOW = 10,
  /** BOM_TYPE_OTHER - item type is Other */
  BOM_TYPE_OTHER = 20,
  UNRECOGNIZED = -1,
}

export function bomTypeFromJSON(object: any): BomType {
  switch (object) {
    case 0:
    case "BOM_TYPE_UNSPECIFIED":
      return BomType.BOM_TYPE_UNSPECIFIED;
    case 1:
    case "BOM_TYPE_HARDWARE":
      return BomType.BOM_TYPE_HARDWARE;
    case 2:
    case "BOM_TYPE_SERVICE":
      return BomType.BOM_TYPE_SERVICE;
    case 3:
    case "BOM_TYPE_CHASSIS":
      return BomType.BOM_TYPE_CHASSIS;
    case 4:
    case "BOM_TYPE_OPTICS":
      return BomType.BOM_TYPE_OPTICS;
    case 5:
    case "BOM_TYPE_FAN":
      return BomType.BOM_TYPE_FAN;
    case 6:
    case "BOM_TYPE_PSU":
      return BomType.BOM_TYPE_PSU;
    case 7:
    case "BOM_TYPE_ENTITLEMENT":
      return BomType.BOM_TYPE_ENTITLEMENT;
    case 8:
    case "BOM_TYPE_MLB":
      return BomType.BOM_TYPE_MLB;
    case 9:
    case "BOM_TYPE_CABLE":
      return BomType.BOM_TYPE_CABLE;
    case 10:
    case "BOM_TYPE_AIRFLOW":
      return BomType.BOM_TYPE_AIRFLOW;
    case 20:
    case "BOM_TYPE_OTHER":
      return BomType.BOM_TYPE_OTHER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BomType.UNRECOGNIZED;
  }
}

export function bomTypeToJSON(object: BomType): string {
  switch (object) {
    case BomType.BOM_TYPE_UNSPECIFIED:
      return "BOM_TYPE_UNSPECIFIED";
    case BomType.BOM_TYPE_HARDWARE:
      return "BOM_TYPE_HARDWARE";
    case BomType.BOM_TYPE_SERVICE:
      return "BOM_TYPE_SERVICE";
    case BomType.BOM_TYPE_CHASSIS:
      return "BOM_TYPE_CHASSIS";
    case BomType.BOM_TYPE_OPTICS:
      return "BOM_TYPE_OPTICS";
    case BomType.BOM_TYPE_FAN:
      return "BOM_TYPE_FAN";
    case BomType.BOM_TYPE_PSU:
      return "BOM_TYPE_PSU";
    case BomType.BOM_TYPE_ENTITLEMENT:
      return "BOM_TYPE_ENTITLEMENT";
    case BomType.BOM_TYPE_MLB:
      return "BOM_TYPE_MLB";
    case BomType.BOM_TYPE_CABLE:
      return "BOM_TYPE_CABLE";
    case BomType.BOM_TYPE_AIRFLOW:
      return "BOM_TYPE_AIRFLOW";
    case BomType.BOM_TYPE_OTHER:
      return "BOM_TYPE_OTHER";
    case BomType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FabricConfExportType {
  FABRIC_CONF_EXPORT_TYPE_UNSPECIFIED = 0,
  FABRIC_CONF_EXPORT_TYPE_TEMPLATE = 1,
  FABRIC_CONF_EXPORT_TYPE_INTERNAL = 2,
  FABRIC_CONF_EXPORT_TYPE_EXTERNAL = 3,
  UNRECOGNIZED = -1,
}

export function fabricConfExportTypeFromJSON(object: any): FabricConfExportType {
  switch (object) {
    case 0:
    case "FABRIC_CONF_EXPORT_TYPE_UNSPECIFIED":
      return FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_UNSPECIFIED;
    case 1:
    case "FABRIC_CONF_EXPORT_TYPE_TEMPLATE":
      return FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_TEMPLATE;
    case 2:
    case "FABRIC_CONF_EXPORT_TYPE_INTERNAL":
      return FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_INTERNAL;
    case 3:
    case "FABRIC_CONF_EXPORT_TYPE_EXTERNAL":
      return FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_EXTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricConfExportType.UNRECOGNIZED;
  }
}

export function fabricConfExportTypeToJSON(object: FabricConfExportType): string {
  switch (object) {
    case FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_UNSPECIFIED:
      return "FABRIC_CONF_EXPORT_TYPE_UNSPECIFIED";
    case FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_TEMPLATE:
      return "FABRIC_CONF_EXPORT_TYPE_TEMPLATE";
    case FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_INTERNAL:
      return "FABRIC_CONF_EXPORT_TYPE_INTERNAL";
    case FabricConfExportType.FABRIC_CONF_EXPORT_TYPE_EXTERNAL:
      return "FABRIC_CONF_EXPORT_TYPE_EXTERNAL";
    case FabricConfExportType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Tag encapsulates a tag and identifiers of objects associated with the tag. */
export interface Label {
  /**
   * The label name. Tag name must comply with following rules.
   *  a) Name must be a string of fewer than 64 characters.
   *  b) Name must not begin with ##.
   *  c) Name must not have comma "," in it.
   */
  name: string;
  /**
   * Indicates if tag is enabled or not. Enabled flag is useful in SetTags API.
   * SetTags adds new tag when Enabled is true, and deletes existing tag when
   * Enabled is false.
   */
  enabled: boolean;
  /** A set of fabrics associated with the label. */
  fabricIds: string[];
  /** A set of nodes associated with the label. */
  nodeIds: string[];
  /** A set of network ports associated with the label. */
  networkPortIds: string[];
  /** A set of port channels associated with the label. */
  portChannelIds: string[];
  /** A set of Loopback devices associated with the label. */
  loopbackIds: string[];
  /** A set of Vrfs associated with the label. */
  vrfIds: string[];
  /** A set of Vnis associated with the label. */
  vniIds: string[];
  /** A set of StaticRoutes associated with the label. */
  staticRouteIds: string[];
  /** A set of DhcpRelays associated with the label. */
  dhcpRelayIds: string[];
  /** A set of SubInterfaces associated with the label. */
  subInterfaceIds: string[];
  /** A set of BgpPolicy associated with the label. */
  bgpPolicyIds: string[];
  /** A set of BgpPeer objects associated with the label. */
  bgpPeerIds: string[];
  /** A set of PortBreakout objects associated with the label. */
  portBreakoutIds: string[];
  /** A set of PrefixList objects associated with the label. */
  prefixListIds: string[];
  /** A set of NotificationEndpoint objects associated with the label. */
  endpointIds: string[];
  /** A set of IpmConfig objects associated with the label. */
  ipmConfigIds: string[];
  /** A set of DscpConfig objects associated with the label. */
  dscpConfigIds: string[];
  /** A set of PacketMirroring objects associated with the label. */
  packetMirroringIds: string[];
  /** A set of IpSlaConfig objects associated with the label. */
  ipSlaConfigIds: string[];
  /** A set of DciConfig objects associated with the label. */
  dciConfigIds: string[];
  /** A set of ArsConfig objects associated with the label. */
  arsConfigIds: string[];
}

/** ProvisionSettings encapsulates organization settings and org level policies. */
export interface ProvisionSettings {
  /** A set of organization properties. */
  setOrgProperties: OrgProperty[];
  /** A set of IP prefix lists. */
  setPrefixLists: PrefixList[];
  /** A ser of IP prefix list identifiers. */
  delPrefixLists: string[];
  /** A set of DciConfig objects, */
  setDciConfigs: DciConfig[];
  /** A set of DciConfig object identifiers to delete. */
  delDciConfigs: string[];
  /** A set of labels to be set or unset for a number of objects. */
  setLabels: Label[];
  /** A set of certificates. */
  setOrgCertificates: Certificates[];
  /** A set of OrgCertificates identifiers. */
  delOrgCertificates: string[];
  /** A set of notification endpoint objects. */
  setEndpoints: Endpoint[];
  /** A list of notification endpoint identifiers. */
  delEndpoints: string[];
  /** A set of fabrics which are subscribed to notifications. */
  setNotificationSettings: NotificationSettings[];
  /** A list of fabrics which are subscribed to notifications. */
  delNotificationSettings: string[];
}

/**
 * ProvisionTenants encapsulates request messages to create/modify/delete tenants
 * and tenant objects.
 */
export interface ProvisionTenants {
  /** A set of ArsConfig objects, */
  setArsConfigs: ArsConfig[];
  /** A set of ArsConfig object identifiers to delete. */
  delArsConfigs: string[];
  /** A set of Loopback objects. */
  setLoopbacks: Loopback[];
  /** A ser of Loopback identifiers. */
  delLoopbacks: string[];
  /** A set of Vrf objects, */
  setVrfs: Vrf[];
  /** A set of Vrf names to delete. */
  delVrfs: string[];
  /** A set of port channel (LAG) objects. */
  setPortChannels: PortChannel[];
  /** A set of port channel identifiers. */
  delPortChannels: string[];
  /** A set of Vni objects, */
  setVnis: Vni[];
  /** A set of Vni object identifiers to delete. */
  delVnis: string[];
  /** A set of StaticRoutes objects, */
  setStaticRoutes: StaticRoutes[];
  /** A set of StaticRoutes object identifiers to delete. */
  delStaticRoutes: string[];
  /** A set of DhcpRelay objects, */
  setDhcpRelays: DhcpRelay[];
  /** A set of DhcpRelay object identifiers to delete. */
  delDhcpRelays: string[];
  /** A set of SubInterface objects, */
  setSubInterfaces: SubInterface[];
  /** A set of SubInterface object identifiers to delete. */
  delSubInterfaces: string[];
  /** A set of BgpPolicy objects. */
  setBgpPolicies: BgpPolicy[];
  /** A set of BgpPolicy object identifiers to delete. */
  delBgpPolicies: string[];
  /** A set of BgpPeer objects, */
  setBgpPeers: BgpPeer[];
  /** A set of BgpPeer object identifiers to delete. */
  delBgpPeers: string[];
  /** A set of IpmConfig objects, */
  setIpmConfigs: IpmConfig[];
  /** A set of IpmConfig object identifiers to delete. */
  delIpmConfigs: string[];
  /** A set of DscpConfig objects, */
  setDscpConfigs: DscpConfig[];
  /** A set of DscpConfig object identifiers to delete. */
  delDscpConfigs: string[];
  /** A set of PacketMirroring objects, */
  setPacketMirrorings: PacketMirroring[];
  /** A set of PacketMirroring object identifiers to delete. */
  delPacketMirrorings: string[];
  /** A set of IpSlaConfig objects, */
  setIpSlaConfigs: IpSlaConfig[];
  /** A set of IpSlaConfig object identifiers to delete. */
  delIpSlaConfigs: string[];
}

/**
 * DeleteTenantChildrenRequest encapsulates tenant_id to delete the children of a tenant.
 * children over here refer to all the things that get attached to a tenant.
 */
export interface DeleteTenantChildrenRequest {
  /** The identifier of tenant. */
  tenantId: string[];
}

/**
 * BindDevice represents a message to bind a device to a blueprint node.
 * NOTES:
 *  - An empty device_id results in device getting unbound from node.
 */
export interface BindDevice {
  /** The fabric identifier. */
  fabricId: string;
  /** The identifier of blueprint node. */
  nodeId: string;
  /** The identifier of inventory device. */
  deviceId: string;
}

/**
 * ProvisionFabrics encapsulates request messages to create/modify/delete Fabric
 * and Fabric child objects such as Node, NetworkPort etc.
 */
export interface ProvisionFabrics {
  /** A set of fabrics to create/update. */
  setFabrics: Fabric[];
  /** A set of fabrics identifiers to delete. */
  delFabrics: string[];
  /** A set of port connections. */
  setConnections: PortConnection[];
  /** A set of connection identifiers. */
  delConnections: string[];
  /** A set of PortBreakout objects, */
  setPortBreakouts: PortBreakout[];
  /** A set of PortBreakout object identifiers to delete. */
  delPortBreakouts: string[];
  /** A set of nodes to create/update. */
  setNodes: Node[];
  /** A set of node identifiers to delete. */
  delNodes: string[];
  /** A set of messages to bind a device to a node. */
  bindDevices: BindDevice[];
  /** A set of node identifiers to unbind devices from nodes. */
  unbindDevices: string[];
  /** PerVlanStp config of the fabric, */
  setPerVlanStps: PerVlanStp[];
  /** Multisite config of the fabric. */
  setMultisites: FabricMultisite[];
  /** The identifier of Multisite config of the fabric. */
  delMultisites: string[];
  /** A set of network ports to be modified. */
  setNetworkPorts: NetworkPort[];
  /** Reset configs of a set of network ports. */
  resetNetworkPorts: string[];
  /** A set of fabric software configurations to set */
  setFabricSwConf: FabricSoftwareConfig[];
  /** a set of fabric software configurations to delete */
  delFabricSwConf: FabricSoftwareConfig[];
  /** flag to skip checking the device reboot status during image updates */
  skipDeviceReadinessCheck: boolean;
  /** create or update the design of a fabric */
  setFabricDesigns: FabricDesign[];
  /** A set of fabric identifiers for the designs to delete */
  deleteFabricDesigns: string[];
  /** A set of fabric design objects to delete. */
  delFabricDesignObjects: DeleteFabricDesignObjects[];
  /** A set of fabric design objects to set. */
  setFabricDesignObjects: SetFabricDesignObjects[];
  /** A set of server management ports to be modified. */
  setServerMgmtPorts: ServerMgmtPort[];
  /** A set of inventory switch identifiers. */
  delInventories: string[];
  /** A set of dashboard folder objects. */
  setDashboardFolders: DashboardFolder[];
  /** A list of dashboard folder identifiers. */
  delDashboardFolders: string[];
  /** A set of dashboard objects. */
  setDashboards: Dashboard[];
  /** A list of dashboard identifiers. */
  delDashboards: string[];
  /** A set of dashboard panel objects. */
  setDashboardPanels: Panel[];
  /** A list of dashboard panel identifiers. */
  delDashboardPanels: string[];
  /** A set of ResourceReservation objects. */
  setResourceReservations: ResourceReservation[];
  /** A set of ResourceReservation object identifiers to delete. */
  delResourceReservations: string[];
  /** The deleted fabric identifier to restore. */
  restoreFabric: string;
}

export interface DeleteFabricDesignObjects {
  DeleteTiers: Tier[];
  DeleteSwitchGroups: SwitchGroup[];
  DeleteServerGroups: ServerGroup[];
  DeleteRailGroups: RailGroup[];
  DeleteRails: Rail[];
  DeleteHwSets: HwSet[];
  DelSwitchGrpConnRules: SwitchGroupConnectivityRule[];
  DelServerGrpConnRules: ServerGroupConnectivityRule[];
  DelNodePortConnRules: NodePortConnectivityRule[];
  DelNodePortOverRules: NodePortOverrideRule[];
}

export interface HwSetWithGroupType {
  groupType: TopologyGroupType;
  hwSet: HwSet | undefined;
}

export interface SetFabricDesignObjects {
  /** Only top level tiers can be set, no nested switch/server groups */
  SetTiers: Tier[];
  /** Only switch groups can be set, no nested hw sets */
  SetSwitchGroups: SwitchGroup[];
  /** Only server groups can be set, no nested hw sets */
  SetServerGroups: ServerGroup[];
  /** Rail groups can be set, rails are auto-generated from Count */
  SetRailGroups: RailGroup[];
  SetHwSets: HwSetWithGroupType[];
  SetSwitchGrpConnRules: SwitchGroupConnectivityRule[];
  SetServerGrpConnRules: ServerGroupConnectivityRule[];
  SetNodePortConnRules: NodePortConnectivityRule[];
  SetNodePortOverRules: NodePortOverrideRule[];
}

/**
 * ProvisionRequest encapsulates provisioning requests. ProvisionRequest
 * guarantees atomic (transactional) update of all objects contained in the
 * request.
 */
export interface ProvisionRequest {
  /** Is dry run or test-flight? (Return results, do not commit). */
  dryRun: boolean;
  /** The global fabric identifier. FabricId is required for deletes. */
  fabricId: string;
  /** The candidate name. */
  candidate: string;
  /** Candidate creation comments. */
  comments: string;
  /** The expected candidate revision identifier. */
  revisionId: string;
  /** Controls whether or not cabling needs to be re-run */
  runCabling: boolean;
  /** The expected fabric commit identifier. When non-zero, the request is rejected with 409 if the fabric's CommitId has changed. */
  commitId: string;
  /** Organization configs. */
  settings:
    | ProvisionSettings
    | undefined;
  /** Fabrics provisioning request. */
  fabrics:
    | ProvisionFabrics
    | undefined;
  /** Tenants provisioning request. */
  tenants: ProvisionTenants | undefined;
}

export interface ProvisionResponse {
  /** Is dry run or test-flight? */
  dryRun: boolean;
  /** Organization configs. */
  settings:
    | ProvisionSettings
    | undefined;
  /** Fabrics provisioning request. */
  fabrics:
    | ProvisionFabrics
    | undefined;
  /** Tenants provisioning request. */
  tenants: ProvisionTenants | undefined;
}

export interface ProvisionSettingsRequest {
  /** Is dry run or test-flight? */
  dryRun: boolean;
  settings: ProvisionSettings | undefined;
}

export interface ProvisionSettingsResponse {
  /** Is dry run or test-flight? */
  dryRun: boolean;
  settings: ProvisionSettings | undefined;
}

/**
 * GetFabricsFilters defines supported filters for GetFabrics gRPC API.
 * NOTES:
 *  LoadChildren means load full fabric tree.
 */
export interface GetFabricsFilters {
  /** Use partial match on names. */
  partialMatch: boolean;
  /** Load child objects such as nodes and ports. */
  loadChildren: boolean;
  /** The candidate name. */
  candidate: string;
  /** Get the fabric blueprint design */
  loadDesign: boolean;
  /** A set of fabric identifiers. */
  fabricIds: string[];
  /** A set of fabric names. */
  names: string[];
  /** A set of tags. */
  labels: string[];
  /** A set of node identifiers. */
  nodeIds: string[];
  /** flag of showing parking lot fabrics */
  isParkingLot: boolean;
  /** optional start timestamp to query the modified fabrics */
  modifiedStart:
    | Date
    | undefined;
  /** optional end timestamp to query the modified fabrics */
  modifiedEnd:
    | Date
    | undefined;
  /** optional user ids associated with the fabric modifications */
  modifiedUsers: string[];
}

/** GetFabricsRequest defines protobuf message used for querying fabrics. */
export interface GetFabricsRequest {
  /** Query filters. */
  filters: GetFabricsFilters | undefined;
  pagination: PaginationRequest | undefined;
}

export interface GetFabricsResponse {
  fabrics: Fabric[];
  /** The candidate name. */
  candidate: string;
  pagination: PaginationResponse | undefined;
}

/** GetFabricDesignRequest defines the protobuf message used for querying a fabric design. */
export interface GetFabricDesignRequest {
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** The fabric id or name. */
  fabricId: string;
}

export interface GetFabricDesignResponse {
  design: FabricDesign | undefined;
  candidate: string;
}

/** GetNodesFilters defines supported filters for GetNodes gRPC API. */
export interface GetNodesFilters {
  /** Use partial match on names. */
  partialMatch: boolean;
  /** Load child objects. */
  loadChildren: boolean;
  /** The candidate name. */
  candidate: string;
  /** The fabric id or name. */
  fabricId: string;
  /** Filter by one or more node ids. */
  nodeIds: string[];
  /** Filter by node names. */
  names: string[];
  /** Filter by tags. */
  labels: string[];
  /** Filter by roles. */
  roles: NodeRole[];
  /** Filter by serial numbers. */
  serialNumbers: string[];
  /** Filter by model name. */
  modelNames: string[];
  /** Filter by device identifiers. */
  deviceIds: string[];
}

export interface GetNodesRequest {
  /** Query filters. */
  filters: GetNodesFilters | undefined;
  pagination: PaginationRequest | undefined;
}

export interface GetNodesResponse {
  nodes: Node[];
  /** The candidate name. */
  candidate: string;
  pagination: PaginationResponse | undefined;
}

export interface GetNodesPortsRequest {
  /** The transaction name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** The node identifiers; must have exactly one identifier. */
  nodeIds: string[];
  /** A set of port names. */
  ports: string[];
}

export interface GetNodesPortsResponse {
  nodes: Node[];
}

export interface GetPortBreakoutsRequest {
  /** The transaction name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of node identifiers. */
  nodeIds: string[];
  /** A set of object identifiers. */
  ids: string[];
  /** A set of object names. */
  names: string[];
}

export interface GetPortBreakoutsResponse {
  breakouts: PortBreakout[];
}

/** TenantObjects defines an envelope to hold tenant objects. */
export interface TenantObjects {
  id: string;
  name: string;
  enabled: boolean;
  /** The transaction name. */
  candidate: string;
  vlans: Vlan[];
  vrfs: Vrf[];
  portChannels: PortChannel[];
  vnis: Vni[];
  staticRoutes: StaticRoutes[];
  dhcpRelays: DhcpRelay[];
  loopbacks: Loopback[];
  subInterfaces: SubInterface[];
  bgpPolicies: BgpPolicy[];
  bgpPeers: BgpPeer[];
  ipmConfigs: IpmConfig[];
  dscpConfigs: DscpConfig[];
  packetMirrorings: PacketMirroring[];
  ipSlaConfigs: IpSlaConfig[];
  arsConfigs: ArsConfig[];
}

/** TenantsObjectsResponse encapsulates fabric's tenant objects. */
export interface TenantsObjectsResponse {
  tenants: TenantObjects[];
}

/** GetVnisRequest encapsulates parameters to query L2/L3 Vni objects. */
export interface GetVnisRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of Vni object identifiers. */
  ids: string[];
  /** A set of Vni names. */
  names: string[];
  /** A set of VNIs. */
  vnis: number[];
  /** A set of VLAN identifiers. */
  vlanIds: number[];
  /** Query only L3 VNIs. */
  l3Only: boolean;
}

/** GetMaterializedVniRequest materializes a set of VNIs for a given node. */
export interface GetMaterializedVniRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** VNI identifier. */
  vni: number;
  /** The node identifier. */
  nodeId: string;
}

/** GetVrfsRequest encapsulates properties to query Vrf objects. */
export interface GetVrfsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of Vrf identifiers. */
  ids: string[];
  /** A set of Vrf names. */
  names: string[];
  /** Include interface IP addresses in the response message. Must set exactly one identifier in the ID list. */
  needIps: boolean;
  /**
   * A set of IPv4 addresses to filter interfaces. Must set exactly one identifier in the Ids list.
   * IPv4 addresses maybe either host addresses or network addresses.
   */
  ipv4Addresses: string[];
  /**
   * A set of IPv6 addresses to filter interfaces. Must set exactly one identifier in the Ids list.
   * IPv6 addresses maybe either host addresses or network addresses.
   */
  ipv6Addresses: string[];
  /**
   * Use supernet filter instead of subnet filter. For example, if a VRF has an interface
   * with IP 1.1.1.1/24 and if the user has provided 1.1.0.0/16 as the input, then GetVrfs
   * will return that interface. If supernet = false (subnet filter), then GetVrfs will
   * not return that interface.
   */
  supernet: boolean;
}

/** GetPortChannelsRequest encapsulates parameters to query PortChannel objects. */
export interface GetPortChannelsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of PortChannel identifiers (required). */
  ids: string[];
  /** A set of names. */
  names: string[];
}

/** GetSubInterfacesRequest encapsulates parameters to query SubInterface objects. */
export interface GetSubInterfacesRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of node identifiers (required). */
  nodeIds: string[];
  /** A set of SubInterface identifiers. */
  ids: string[];
  /** A set of names. */
  names: string[];
  /** A set of parent interface names. */
  parents: string[];
}

/** GetStaticRoutesRequest encapsulates properties to query StaticRoutes objects. */
export interface GetStaticRoutesRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of StaticRoutes identifiers. */
  ids: string[];
  /** A set of StaticRoutes names. */
  names: string[];
  /** A set of VRF identifiers. */
  vrfIds: string[];
}

/** GetDhcpRelaysRequest encapsulates properties to query DhcpRelay objects. */
export interface GetDhcpRelaysRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of DhcpRelay identifiers. */
  ids: string[];
  /** A set of DhcpRelay names. */
  names: string[];
  /** A set of Vrf identifiers. */
  vrfIds: string[];
}

/** GetLoopbacksRequest encapsulates properties to query Loopback objects. */
export interface GetLoopbacksRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of node identifiers. */
  nodeIds: string[];
  /** A set of Loopback identifiers. */
  ids: string[];
  /** A set of Loopback names. */
  names: string[];
  /** A set of VRF identifiers. */
  vrfIds: string[];
}

/** GetPerVlanStpRequest encapsulates properties to query PerVlanStp config of a fabric */
export interface GetPerVlanStpRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
}

/** GetPerVlanStpsResponse encapsulates current PerVlanStp config of a fabric. */
export interface GetPerVlanStpResponse {
  perVlanStp: PerVlanStp | undefined;
}

/** GetBgpPeersRequest encapsulates properties to query BgpPeer objects. */
export interface GetBgpPeersRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of BgpPeer identifiers. */
  ids: string[];
  /** A set of BgpPeer names. */
  names: string[];
  /** A set of VRF identifiers. */
  vrfIds: string[];
}

/** GetBgpPoliciesRequest encapsulates properties to query BgpPolicy objects. */
export interface GetBgpPoliciesRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of BgpPolicy identifiers. */
  ids: string[];
  /** A set of BgpPolicy names. */
  names: string[];
  /** A set of BgpPolicy types. */
  types: BgpPolicyType[];
}

/** GetPrefixListsRequest encapsulates properties to query PrefixList objects. */
export interface GetPrefixListsRequest {
  /** A set of PrefixList identifiers. */
  ids: string[];
  /** A set of PrefixList names. */
  names: string[];
  pagination: PaginationRequest | undefined;
}

/** GetPrefixListsResponse encapsulates response of PrefixList query. */
export interface GetPrefixListsResponse {
  lists: PrefixList[];
  pagination: PaginationResponse | undefined;
}

/**
 * DeviceClaim encapsulates information needed to claim a node. Organization
 * must provide either a serial number or device identifier to claim a device.
 * In addition to that, organization must provide a claim code as well.
 */
export interface DeviceClaim {
  /** The serial number of device. */
  serialNumber: string;
  /** The model name of device. */
  modelName: string;
  /** The device identifier (or MAC address). */
  deviceId: string;
  /** The claim code ???. */
  claimCode: string;
  /** The claim status */
  claimStatus: ClaimStatus;
}

export interface DeviceClaimRequest {
  /** Devices to be claimed. */
  claims: DeviceClaim[];
}

export interface DeviceClaimResponse {
  /** Devices that are successfully claimed. */
  claims: DeviceClaim[];
}

export interface ClaimDevicesRequest {
  /** Claim code mode */
  claimCodes: string[];
  /** spider claim mode */
  deviceIds: string[];
  /** USB token claim mode */
  serialNumbers: string[];
}

export interface ClaimDevicesResponse {
  claims: ClaimResult[];
}

export interface ClaimDeviceSecondCommitRequest {
  deviceId: string;
  targetOrgId: string;
  targetFabId: string;
  claimCode: string;
  serialNumber: string;
  osType: OsType;
  monitored: boolean;
}

export interface ClaimDeviceSecondCommitResponse {
  claimStatus: ClaimStatus;
}

export interface CleanClaimedDeviceRequest {
  deviceId: string;
  sourceOrgId: string;
}

export interface UnclaimDeviceRequest {
  deviceId: string;
}

export interface BuildDeviceThreadlistRequest {
  deviceId: string;
}

export interface RemoveDeviceFromInstanceRequest {
  deviceId: string;
  sourceFabId: string;
  sourceOrgId: string;
  targetOrgId: string;
  targetFabId: string;
}

export interface AddDeviceToInstanceRequest {
  deviceId: string;
  sourceFabId: string;
  sourceOrgId: string;
  targetOrgId: string;
  targetFabId: string;
}

export interface DeviceRMAUnclaimRequest {
  deviceId: string;
  orgId: string;
  fabricId: string;
  supportUser: string;
}

export interface DeviceRMAUnbindRequest {
  deviceId: string;
  orgId: string;
  fabricId: string;
  supportUser: string;
}

export interface DeviceRMAUnbindResponse {
  parkingLotFabricId: string;
}

/**
 * GetWorkflowFeedbacksRequest encapsulates properties to query workflow
 * execution feedback messages.
 */
export interface GetWorkflowFeedbacksRequest {
  /** A set of node identifier. Caller must provide at least one node identifier. */
  nodeIds: string[];
  /** Include task feedback messages. */
  details: boolean;
  /** Start timestamp for range query. Both StartTime and EndTime are required properties. */
  startTime:
    | Date
    | undefined;
  /** End timestamp for range query. Both StartTime and EndTime are required properties. */
  endTime:
    | Date
    | undefined;
  /** Fingerprint of the Fabric config. ConfigFp is optional. */
  configFp: string;
  /** An optional set of task names. */
  taskNames: string[];
  /** An optional set of workflow types. */
  workflowTypes: WorkflowType[];
  /** The fabric identifier. */
  fabricId: string;
}

/** GetConfigFeedbacksResponse encapsulates response to feedback query. */
export interface GetWorkflowFeedbacksResponse {
  nodeIds: string[];
  feedbacks: WorkflowFeedback[];
  names: string[];
}

/**
 * A candidate review is a record created when a user add review comments to a candidate configuration.
 *
 * INTERNAL
 *
 * CandidateReview represents a candidate review record.
 * CandidateReview records are created when users add review comments.
 */
export interface CandidateReview {
  /** The comments about the candidate configuration. */
  comments: string;
  /** The identity provider and email of the user that added the comments. */
  createdBy: string;
  /**
   * The timestamp when the comments were added in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  createdAt:
    | Date
    | undefined;
  /** The type of the user operation. */
  operation: Operation;
}

/**
 * A candidate configuration represents a staging area for changes to a fabric and its
 * children to be compiled before being reviewed and commited. Once commited, the candidate
 * configuration becomes the running configuration and the candidate configuration is emptied.
 */
export interface FabricCandidate {
  /** The unique identifier of the fabric to which the candidate is associated to. */
  fabricId: string;
  /**
   * The name of the candidate configuration. Only the `default` candidate configuration is
   * currently support.
   */
  name: string;
  /** The flag that indicates if the candidate configuration has pending changes or not. */
  active: boolean;
  /** The transaction sequence number of the candidate configuration. */
  txnId: string;
  /** An integer that represents the current revision identifier of the candidate configuration. */
  revisionId: string;
  /** The identity provider and email of the user that created the candidate configuration. */
  createdBy: string;
  /**
   * The timestamp when this object was created in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  createdAt:
    | Date
    | undefined;
  /** The identity provider and email of the user that modified the candidate configuration last. */
  modifiedBy: string;
  /**
   * The timestamp when this object was last modified in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  modifiedAt:
    | Date
    | undefined;
  /** A list of the reviews of the candidate configuration. */
  reviews: CandidateReview[];
  /** A list of the activity events of the candidate configuration. */
  events: ActivityEvent[];
  /** The type of the candidate configuration. */
  type: CandidateType;
  /** A list of validation errors for active candidate. */
  errors: string[];
}

/**
 * The request for the list of pending candidate configurations of a specific fabric.
 *
 * INTERNAL
 *
 * GetFabricCandidatesRequest encapsulates properties to query
 * pending candidates for a fabric.
 */
export interface GetFabricCandidatesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. */
  name: string;
  /** The transaction sequence number of the candidate configuration. */
  txnId: string;
  /** Include committed/reverted candidate configurations. */
  needInactive: boolean;
  /** Include the list of reviews of the candidate configurations. */
  needReviews: boolean;
  /** Include the list of activity events of the candidate configurations. */
  needEvents: boolean;
  /**
   * Start value of the time range in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  startTime:
    | Date
    | undefined;
  /**
   * End value of the time range in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  endTime: Date | undefined;
  pagination:
    | PaginationRequest
    | undefined;
  /** The max number of candidates to return in the response. */
  max: number;
  /** An optional cursor for pagination. */
  cursor: string;
}

/**
 * The request for a specific candidate configuration of a fabric.
 *
 * INTERNAL
 *
 * GetFabricCandidateRequest returns a single named candidate configuration object.
 */
export interface GetFabricCandidateRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. */
  name: string;
  /** Include committed/reverted candidate configuration. */
  needInactive: boolean;
  /** Include the list of reviews of the candidate configuration. */
  needReviews: boolean;
  /** Include the list of activity events of the candidate configuration. */
  needEvents: boolean;
}

/**
 * The response to a request for a list of candidate configurations of a specific fabric.
 *
 * INTERNAL
 *
 * GetFabricCandidatesResponse encapsulates query response for
 * fabric candidates.
 */
export interface GetFabricCandidatesResponse {
  /** A list of candidate configurations of a specific fabric */
  candidates: FabricCandidate[];
  /** An optional cursor for pagination. */
  cursor: string;
  pagination: PaginationResponse | undefined;
}

/**
 * The request to commit a specific candidate configuration of a fabric.
 *
 * INTERNAL
 *
 * CommitFabricCandidateRequest encapsulates properties to commit a
 * pending fabric candidate. Candidates commit may require special
 * user privileges.
 */
export interface CommitFabricCandidateRequest {
  /**
   * The fabric id or name.
   *
   * INTERNAL
   *
   * Fabric identifier is mandatory.
   */
  fabricId: string;
  /** The candidate configuration name. */
  name: string;
  /** The reasons for the candidate configuration commit. */
  comments: string;
  /**
   * The candidate configuration revision identifier.
   *
   * The commit request will be rejected if the provided revision identifier is
   * not the same than the most recent one known to the Hyperfabric service.
   */
  revisionId: string;
  /** Indicates the caller wants to merge current multisite config into fabric config. */
  mergeDci: boolean;
}

/** The response to a request to commit a specific candidate configuration of a fabric. */
export interface CommitFabricCandidateResponse {
  /** The fabric identifier. */
  fabricId: string;
  /** Indicates that the pending candidate configuration was committed. */
  committed: boolean;
}

/**
 * The request to discard a specific candidate configuration of a fabric.
 *
 * INTERNAL
 *
 * RevertFabricCandidateRequest encapsulates properties to revert or rollback
 * a pending transaction of a Fabric.
 */
export interface RevertFabricCandidateRequest {
  /**
   * The fabric id or name.
   *
   * INTERNAL
   *
   * Fabric identifier is mandatory.
   */
  fabricId: string;
  /** The candidate configuration name. */
  name: string;
  /** The reasons to discard the candidate configuration. */
  comments: string;
  /**
   * The candidate configuration revision identifier.
   *
   * The discard request will be rejected if the provided revision identifier is
   * not the same than the most recent one known to the Hyperfabric service.
   */
  revisionId: string;
}

export interface RevertFabricCandidateResponse {
  /** The fabric identifier. */
  fabricId: string;
  /** Indicates that pending transaction have been reverted. */
  reverted: boolean;
}

/** FabricConfig encapsulates entire config of a fabric. */
export interface FabricConfig {
  /** Fabric object. */
  fabric:
    | Fabric
    | undefined;
  /** Tenant objects. */
  tenants: TenantObjects[];
  /** PerVlanStp of the fabric. */
  perVlanStp:
    | PerVlanStp
    | undefined;
  /** DCI/Multisite configs. There will only be one objects in the following lists. */
  dciConfigs: DciConfig[];
  /** Fabric's multisite config objects. */
  multisites: FabricMultisite[];
  /**
   * Following properties do not affect configs for switches. They are handled
   * out-of-band. Fingerprint of FabricConfig is calculated using these properties.
   */
  revisionId: string;
  /** Fingerprint of FabricConfig. */
  configFp: string;
  /** Commit comments. */
  comments: string;
  /** The user who triggered fabric grind. */
  createdBy: string;
  /** Tortuga's current timestamp. */
  createdAt:
    | Date
    | undefined;
  /** Fabric software configurations */
  swConf: FabricSoftwareConfig | undefined;
}

/**
 * The request for the entire configuration of a specific fabric.
 *
 * INTERNAL
 *
 * GetFabricsRunningConfigRequest defines a request message to query
 * running configs of a fabric.
 */
export interface GetFabricConfigRequest {
  /**
   * The candidate configuration name.
   * If not set the default candidate configuration is returned.
   * Use `running` to request the currently deployed configuration.
   */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** Exclude the tenants configuration. */
  noTenants: boolean;
}

/** The response to a request for the entire configuration of a specific fabric. */
export interface GetFabricConfigResponse {
  /** The candidate configuration name. */
  candidate: string;
  /** The fabric configuration. */
  config: FabricConfig | undefined;
}

/**
 * The request to add review comments to a specific candidate configuration of a fabric.
 *
 * INTERNAL
 *
 * ReviewFabricCandidateRequest encapsulates properties to add a comment
 * to an existing candidate.
 */
export interface ReviewFabricCandidateRequest {
  /**
   * The fabric id or name.
   *
   * INTERNAL
   *
   * Fabric identifier is mandatory.
   */
  fabricId: string;
  /** The candidate configuration name. */
  name: string;
  /** The comments to be added as a review to the candidate configuration. */
  comments: string;
}

/**
 * The response to a request to add review comments to a specific candidate configuration
 * of a fabric.
 */
export interface ReviewFabricCandidateResponse {
  /** The fabric identifier. */
  fabricId: string;
}

/**
 * GetFabricInventoriesRequest encapsulates properties required to query fabric inventories.
 * See StreamFabricInventories and GetFabricInventories gRPC APIs for details.
 * NOTES:
 * - The service does not support streaming all inventories. Caller must provide a identifier
 *   of a blueprint Fabric to stream inventories.
 * - Only one stream per user is supported.
 */
export interface GetFabricInventoriesRequest {
  /**
   * Query inventories of a given Fabric. This is valid only when at least one of the
   * discovered device is bound to a blueprint Fabric. Fabric identifier must be of
   * the blueprint Fabric.
   */
  fabricId: string;
  /** Query inventories that matches a specific topology. */
  topology: FabricTopology;
  /** Query inventories that include a set of node identifiers. */
  nodeIds: string[];
}

export interface GetFabricInventoriesResponse {
  fabrics: Fabric[];
}

/** ActivityEvent encapsulates an activity log event. */
export interface ActivityEvent {
  /** The monotonically increasing event identifier. */
  eventId: string;
  /** The activity event timestamp. */
  timestamp:
    | Date
    | undefined;
  /** The user who triggered the activity event. */
  username: string;
  /** The type of the object that triggered the event. */
  objectType: ObjectType;
  /** The object identifier. */
  objectId: string;
  /** The object name (maybe empty). */
  objectName: string;
  /** The type of parent object. */
  parentType: ObjectType;
  /** The object identifier of parent object. */
  parentId: string;
  /** The type of user operation. */
  operation: Operation;
  /** The child object identifier (maybe empty). */
  childId: string;
}

/** GetActivityEventsRequest is the input message for querying activity events. */
export interface GetActivityEventsRequest {
  /** Optional start time of the query time range. */
  startTime:
    | Date
    | undefined;
  /** Optional end time of the query time range. */
  endTime:
    | Date
    | undefined;
  /** Filter by object types. */
  objectTypes: ObjectType[];
  /** Filter by object identifier. */
  objectIds: string[];
  /** Filter by username. */
  usernames: string[];
  /** Filter by timestamp. */
  objectNames: string[];
  /** The type of user operation. */
  operations: Operation[];
  pagination: PaginationRequest | undefined;
}

export interface GetActivityEventsResponse {
  events: ActivityEvent[];
  pagination: PaginationResponse | undefined;
}

/** GetTagsRequest is the input message for querying object labels. */
export interface GetLabelsRequest {
  /** Optional start time of the query time range. */
  startTime:
    | Date
    | undefined;
  /** Optional end time of the query time range. */
  endTime:
    | Date
    | undefined;
  /** Filter by object labels. */
  labels: string[];
  /** Filter by object types. */
  objectTypes: ObjectType[];
  /** Filter by object identifiers. */
  objectIds: string[];
  /** Do not include object identifiers in the response. */
  tagsOnly: boolean;
  pagination: PaginationRequest | undefined;
}

/** GetLabelsResponse is the output of GetLabels API. */
export interface GetLabelsResponse {
  /** list of tag objects. */
  labels: Label[];
  pagination: PaginationResponse | undefined;
}

/** GetDeviceModelsRequest encapsulates properties to query device models. */
export interface GetDeviceModelsRequest {
  /** A set of model names or PIDs. */
  modelNames: string[];
  /** A set of descriptive names (E.g. Siren). */
  names: string[];
  /** Device roles (E.g LEAF/SPINE). */
  roles: NodeRole[];
}

/** GetDeviceModelsResponse encapsulates query response for device models. */
export interface GetDeviceModelsResponse {
  devices: DeviceModel[];
}

/** GetCableModelsRequest encapsulates properties to query cable models. */
export interface GetCableModelsRequest {
  /** A set of model names or PIDs. */
  modelNames: string[];
  /** A set of speeds  (E.g. 100G, 40G etc.). */
  speeds: string[];
  /** A set of connector type names (E.g. SFP+). */
  connectors: string[];
  /** A set of cable types (E.g. DAC, SMF etc.) */
  cableTypes: CableType[];
}

/** GetCableModelsResponse encapsulates query response of a cable models. */
export interface GetCableModelsResponse {
  cables: CableModel[];
}

/** GetDevicePsuModelsRequest encapsulates properties to query a device psu models. */
export interface GetDevicePsuModelsRequest {
  /** A set of device model names or PIDs. */
  modelNames: string[];
  /** Airflow type of the psu. */
  airflowType: AirflowType;
}

/**
 * GetServerMgmtCsvTemplateRequest encapsulates properties to download a
 * management auth CSV template for a given server device model and port group
 * type.
 */
export interface GetServerMgmtCsvTemplateRequest {
  /** Server device model name (PID). */
  modelName: string;
  /** Optional, narrows template to slots of this port group. */
  portGroupType: ServerPortGroupType;
}

/** GetDevicePsuModelsResponse encapsulates query response of a device psu models. */
export interface GetDevicePsuModelsResponse {
  devicePsus: DevicePSu[];
}

/** Item encapsulates information for a given Hardware item. */
export interface HwPart {
  /** name of the hardware item part */
  name: string;
  /** ModelName(or)PID of the item */
  modelName: string;
  /** Status of the part */
  partStatus: PartStatus;
  /** serial number of the part */
  serialNumber: string;
  /** number of the items */
  quantity: number;
}

/** HwPart encapsulates the hardware items for a specific hardware type. */
export interface HwParts {
  /** total quantity of this specific hardware part */
  totalQuantity: number;
  /** list of items of the specific type */
  parts: HwPart[];
  /** description about the hardware part */
  description: string;
}

/** NodePart encapsulates information related to Node Hardware parts. */
export interface NodeHwPart {
  /** node name in the fabric */
  nodeName: string;
  /** model name(or)pid of the node */
  modelName: string;
  description: string;
  /** status of the node */
  partStatus: PartStatus;
  /** serial number of the node if already bound */
  serialNumber: string;
  /** port optics pluggable parts of the node */
  opticsHwParts: HwParts[];
  /** Fan supply related parts of the node */
  fanParts: HwParts[];
  /** Power supply related parts of the node */
  powerSupplyParts: HwParts[];
  /** true if node belongs to a monitored switch group */
  monitored: boolean;
}

/** GetFabricAssemblyRequest encapsulates properties to query Fabric assembly List. */
export interface GetFabricAssemblyRequest {
  /** Fabric UUID */
  fabricId: string;
  /** The candidate name. */
  candidate: string;
}

/** GetFabricAssemblyResponse encapsulates query response of Fabric assembly. */
export interface GetFabricAssemblyResponse {
  /** list of node hardware parts */
  nodeHwParts: NodeHwPart[];
  /** creation time of Fabric */
  creationTime:
    | Date
    | undefined;
  /** Last updated time of Fabric */
  updatedTime: Date | undefined;
}

export interface BomItem {
  /** Model Name(or) Pid of the item */
  modelName: string;
  /** description of the item */
  description: string;
  /** number of items deployed */
  quantityDeployed: number;
  /** number of items required */
  quantityRequired: number;
  /** total number of items */
  quantityTotal: number;
  /** type of the Bom item */
  itemType: BomType;
  /** tags for the BOM item */
  tags: string[];
  /** Sub items represent items that are part of parent item */
  subItems: BomItem[];
}

/** GetFabricAssemblyRequest encapsulates properties to query Fabric BOM list. */
export interface GetFabricBomRequest {
  /** Fabric UUID */
  fabricId: string;
  /** The candidate name. */
  candidate: string;
}

/** GetFabricAssemblyResponse encapsulates query response of Fabric BOM. */
export interface GetFabricBomResponse {
  /** list of product items in BOM */
  mainItems: BomItem[];
  /** creation time of Fabric */
  creationTime:
    | Date
    | undefined;
  /** Last updated time of Fabric */
  updatedTime: Date | undefined;
}

/** Creates Bom Estimate on CCW for the given Fabric. */
export interface CreateFabricBomEstimateRequest {
  /** Fabric UUID */
  fabricId: string;
  /** The candidate name. */
  candidate: string;
  /** email of user who created the estimate */
  createdBy: string;
  /** list of product items in BOM */
  mainItems: BomItem[];
}

/**
 * CreateFabricBomEstimateResponse encapsulates response of Fabric BOM
 * Estimate creation.
 */
export interface CreateFabricBomEstimateResponse {
  /** Fabric UUID */
  fabricId: string;
  /** Estimated Id for BOM created in CCW */
  estimateId: string;
}

/**
 * GetFabricBomEstimatesRequest encapsulates properties to query
 * list of Estimates for the given Fabric.
 */
export interface GetFabricBomEstimatesRequest {
  fabricId: string;
}

/**
 * Estimate encapsulates various attributes associated with
 * Fabric BOM Estimate
 */
export interface Estimate {
  estimateId: string;
  createdBy: string;
  createdAt: Date | undefined;
  status: EstimateStatus;
}

/**
 * GetFabricBomEstimateResponse encapsulates response of Fabric Bom
 * Estimates.
 */
export interface GetFabricBomEstimatesResponse {
  fabricId: string;
  estimates: Estimate[];
}

/**
 * GetFabricBomForEstimateRequest encapsulates properties to get
 * Bom data of a Fabric for an estimate id.
 */
export interface GetFabricBomForEstimateRequest {
  fabricId: string;
  estimateId: string;
}

/**
 * GetFabricBomForEstimateResponse encapsulates response of Fabric
 * Bom data for the given estimate Id.
 */
export interface GetFabricBomForEstimateResponse {
  fabricId: string;
  estimateId: string;
  bomData: Uint8Array;
}

/** Add one or more nodes to a specific fabric. */
export interface AddNodesToFabricRequest {
  /** The fabric UUID. */
  fabricId: string;
  /** A list of one or more nodes to add to the fabric. */
  nodes: Node[];
}

export interface AddNodesToFabricResponse {
  nodes: Node[];
}

/** Delete a specific node in a fabric. */
export interface DeleteNodeFromFabricRequest {
  /** The fabric id. */
  fabricId: string;
  /** The node id. */
  nodeId: string;
}

export interface DeleteNodeFromFabricResponse {
  fabricId: string;
  nodeId: string;
}

/** The request to bind a specific device to a node in a fabric. */
export interface BindDeviceRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The node id or name of the node. */
  nodeId: string;
  /** The device id or name of the device to bind to the node. */
  deviceId: string;
}

/** The response to a request to bind a specific device to a node in a fabric. */
export interface BindDeviceResponse {
  /** The node id or name of the node. */
  nodeId: string;
  /** The device id or name of the device to bind to the node. */
  deviceId: string;
}

/** The request to unbind the bound device from a specific node in a fabric. */
export interface UnbindDeviceRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The node id or name from which a device is bound. */
  nodeId: string;
}

/** The response to a request to unbind the bound device from a specific node in a fabric. */
export interface UnbindDeviceResponse {
  /** The node id or name. */
  nodeId: string;
}

/** Get the list of connections configuration information for a specific node in a fabric. */
export interface GetNodeConnectionsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The node id or name. */
  nodeId: string;
  /** The candidate configuration name. If not set the running configuration values are returned. */
  candidate: string;
}

export interface GetNodeConnectionsResponse {
  /** The node id. */
  nodeId: string;
  connections: PortConnection[];
}

/** GetLimitsRequest defines message to query limits and restrictions. */
export interface GetLimitsRequest {
  /** Return verified scale limits from Cisco documentation. */
  verifiedLimits: boolean;
}

/** GetLimitsResponse encapsulates limits and restriction values. */
export interface GetLimitsResponse {
  /** Maximum number of spines per fabric. */
  maxSpines: number;
  /** Maximum number of leaves per fabric. */
  maxLeaves: number;
  /** Maximum value of port index. */
  maxPortIndex: number;
  /** Maximum number of annotations per object. */
  maxAnnotations: number;
  /** Minimum value of user-defined VlanId. */
  minUserVlanId: number;
  /** Maximum value of user-defined VlanId. */
  maxUserVlanId: number;
  /** Minimum value of user-defined VNI. */
  minUserVni: number;
  /** Maximum value of user-defined VNI. */
  maxUserVni: number;
  /** Minimum value of IPv4 CIDR mask. */
  minIpv4Mask: number;
  /** Minimum value of IPv6 CIDR mask. */
  minIpv6Mask: number;
  /** Maximum number of breakouts per port. */
  maxBreakoutsPerPort: number;
  /** Maximum number of breakouts per node. */
  maxBreakoutsPerNode: number;
  /** Maximum number of L3/L2 VNI per fabric. */
  maxVnisPerFabric: number;
  /** Maximum number of VRF objects per fabric. */
  maxVrfsPerFabric: number;
  /** Maximum number of members per Vni/Vlan. */
  maxVlanMembers: number;
  /** Maximum number of interfaces per VRF. */
  maxInterfacesPerVrf: number;
  /** Maximum number of SubInterfaces per port. */
  maxSubInfPerPort: number;
  /** Maximum number of SubInterfaces per node. */
  maxSubInfPerNode: number;
  /** Maximum number of static routes per route group. */
  maxStaticRoutesPerGroup: number;
  /** Maximum number of static routes per route VRF. */
  maxStaticRoutesPerVrf: number;
  /** Maximum number of static route group per fabric. */
  maxRouteGroupsPerFabric: number;
  /** Maximum number of DHCP relay objects per VRF. */
  maxDhcpRelaysPerVrf: number;
  /** Maximum number of PortChannel objects per fabric. */
  maxPortChannelsPerFabric: number;
  /** Maximum number of Loopback objects per node. */
  maxLoopbacksPerNode: number;
  /** Maximum number of IP prefixes per prefix list. */
  maxPrefixesPerList: number;
  /** Maximum number of BgpPeer objects per VRF. */
  maxBgpPeersPerVrf: number;
  /** Maximum number of BgpPolicy objects per org. */
  maxBgpPolicies: number;
  /** Maximum number of prefix lists per org. */
  maxPrefixLists: number;
  /** Maximum number of notification endpoints per org. */
  maxEndpoints: number;
  /** Minimum identifier of a user-defined Loopback (Loopback10). */
  minLoopbackId: number;
  /** Maximum identifier of a user-defined Loopback (Loopback99). */
  maxLoopbackId: number;
  /** Minimum identifier of a PortChannel (PortChannel1). */
  minPortChannelId: number;
  /** Maximum identifier of a PortChannel (PortChannel999). */
  maxPortChannelId: number;
  /** Maximum number of notification endpoints permitted per fabric. */
  maxNotificationEndpoints: number;
  /** Maximum number of fabrics that can subscribe to notifications. */
  maxNotificationSettings: number;
  /** Maximum number of Loopback interfaces per BGP peer. */
  maxBgpLoopbacks: number;
  /** Maximum number of DHCP relay objects per fabric. */
  maxDhcpRelaysPerFabric: number;
  /** Maximum number of PortChannel objects per node. */
  maxPortChannelsPerNode: number;
  /** Maximum number of fabrics per org. */
  maxFabrics: number;
  /** Maximum number of Vlan objects per node. */
  maxVlansPerNode: number;
  /** Maximum number of servers per fabric (includes GPU and C225 servers) */
  maxServers: number;
  /** Maximum number of cable connections per fabric */
  maxPortConnections: number;
  /** Maximum number of switches per fabric */
  maxSwitches: number;
  /** Maximum number of tiers per fabric */
  maxTiers: number;
  /** Maximum number of switch groups per tier */
  maxSwitchGroupsPerTier: number;
  /** Maximum number of server groups per tier */
  maxServerGroupsPerTier: number;
  /** Maximum number of panels per dashboard */
  maxPanelsPerDashboard: number;
  /**
   * Verified scale limits
   * These are populated when verified_limits=true in the request.
   */
  verified: VerifiedScaleLimits | undefined;
}

export interface VerifiedScaleLimits {
  /** Layer 2 scale per fabric. */
  maxVlans: number;
  /** Maximum MAC, IPv4/MAC, and IPv6/MAC endpoints (EVPN type-2 routes) per fabric */
  maxType2Routes: number;
  /** IP scale per fabric. */
  maxVrfs: number;
  /** Maximum SVIs per fabric */
  maxSvis: number;
  /** Maximum IPv4 routes per fabric */
  maxIpv4Routes: number;
  /** Maximum IPv6 routes per fabric */
  maxIpv6Routes: number;
  /** Maximum static routes per fabric */
  maxStaticRoutes: number;
  /** Maximum BGP import and export policies per fabric */
  maxBgpPolicies: number;
  /** Maximum DHCP relay VLANs per fabric */
  maxDhcpRelayVlans: number;
  /** Device count limits. */
  maxSwitches: number;
  /** Maximum number of servers per fabric (includes GPU and C225 servers) */
  maxServers: number;
  /** Connectivity limits. */
  maxPortConnections: number;
  /** Maximum number of ports per switch (including breakouts) */
  maxNetworkPorts: number;
  /** Maximum number of BGP peers per switch */
  maxBgpPeersPerSwitch: number;
}

/**
 * SyncPortStateRequest encapsulates properties to temporarily change
 * admin state of a port. Port maybe a NetworkPort or a PortChannel.
 */
export interface SyncPortStateRequest {
  fabricId: string;
  nodeId: string;
  name: string;
  enabled: boolean;
}

export interface SyncPortStateResponse {
  fabricId: string;
  nodeId: string;
  name: string;
  enabled: boolean;
}

/** GetIpmConfigsRequest encapsulates properties to query IpmConfig objects. */
export interface GetIpmConfigsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of IpmConfig object identifiers. */
  ids: string[];
  /** A set of IpmConfig object names. */
  names: string[];
}

/** GetDscpConfigsRequest encapsulates properties to query DscpConfig objects. */
export interface GetDscpConfigsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of DscpConfig object identifiers. */
  ids: string[];
  /** A set of DscpConfig object names. */
  names: string[];
  /** Return default configs only. */
  defaultOnly: boolean;
}

/** GetPacketMirroringsRequest encapsulates properties to query PacketMirroring objects. */
export interface GetPacketMirroringsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of PacketMirroring object identifiers. */
  ids: string[];
  /** A set of DscpConfig object names. */
  names: string[];
  /** Return default configs only. */
  defaultOnly: boolean;
}

/** GetIpSlaConfigsRequest encapsulates properties to query IpSlaConfig objects. */
export interface GetIpSlaConfigsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of IpSlaConfig object identifiers. */
  ids: string[];
  /** A set of IpSlaConfig object names. */
  names: string[];
  /** A set of static routes identifiers. */
  prefixes: string[];
}

/** GetArsConfigsRequest encapsulates properties to query ArsConfig objects. */
export interface GetArsConfigsRequest {
  /** The candidate name. */
  candidate: string;
  /** The fabric identifier. */
  fabricId: string;
  /** A set of ArsConfig object identifiers. */
  ids: string[];
  /** A set of ArsConfig object names. */
  names: string[];
}

/**
 * Request an exported fabric configuration
 * with boolean flags to determine what to include.
 */
export interface ExportFabricConfigurationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate. */
  candidate: string;
  password: string;
}

/** An exported FabricConfiguration. */
export interface ExportedFabricConfiguration {
  /** The fabric id or name. */
  fabricId: string;
  /**
   * Fabric and node names must be unique within the organization. Importing a fabric will
   * fail if a fabric of the same name exists or there are nodes within the organization
   * which conflict with those within the imported fabric blueprint.
   *
   * The imported fabric can be renamed to avoid such a conflit. If provided, then that name
   * will be used in preference to the original name in the original document. Note that if
   * the fabric is to be renamed, it will impact the names the nodes in the imported fabric.
   *
   * The name must adhere to the same fabric naming requirements as other fabric nammes.
   */
  renameAs: string;
  /** The schema version of the exported configuration. */
  schema: string;
  /** The time at which the configuration was created. */
  createdAt:
    | Date
    | undefined;
  /** The exported fabric. */
  fabric:
    | Fabric
    | undefined;
  /** The exported port connections. */
  connections: PortConnection[];
  /** The exported port breakout object. */
  portBreakouts: PortBreakout[];
  /** The exported nodes. */
  nodes: Node[];
  /** The exported vlan stps. */
  perVlanStps: PerVlanStp[];
  /** The exported network ports. */
  networkPorts: NetworkPort[];
  /** The exported loopback objects. */
  loopbacks: Loopback[];
  /** The exported VRF objects. */
  vrfs: Vrf[];
  /** The exported port channel (LAG) objects. */
  portChannels: PortChannel[];
  /** The exported VNI objects. */
  vnis: Vni[];
  /** The exported static routes objects. */
  staticRoutes: StaticRoutes[];
  /** The exported dhcp relay objects. */
  dhcpRelays: DhcpRelay[];
  /** The exported subinterface objects. */
  subInterfaces: SubInterface[];
  /** The exported BGP policy objects. */
  bgpPolicies: BgpPolicy[];
  /** The exported BGP peer objects. */
  bgpPeers: BgpPeer[];
  /** The exported IPM config objects. */
  ipmConfigs: IpmConfig[];
  /** The exported DSCP config objects. */
  dscpConfigs: DscpConfig[];
  /** The exported PacketMirroring config objects. */
  packetMirrorings: PacketMirroring[];
  /** The exported Server Management Port objects. */
  serverMgmtPorts: ServerMgmtPort[];
  /** The exported IP SLA config objects. */
  ipSlaConfigs: IpSlaConfig[];
  /** The exported ARS config objects. */
  arsConfigs: ArsConfig[];
  /**
   * If true, the import operation is queued for background processing and the
   * response is returned immediately with a task_id that can be polled.
   */
  background: boolean;
  password: string;
  passwordHash: string;
}

/**
 * ImportFabricResponse wraps the result of an ImportFabricConfiguration call.
 * When background=false the config field is populated with the full FabricConfig.
 * When background=true only task_id and task_status are populated (HTTP 202).
 */
export interface ImportFabricResponse {
  /** The imported fabric configuration (populated when background=false). */
  config:
    | FabricConfig
    | undefined;
  /** The queued task identifier (populated when background=true). */
  taskId: string;
  /** The task status (populated when background=true). */
  taskStatus: TaskStatusType;
}

/** GetDciConfigsRequest encapsulates properties to query DciConfig objects. */
export interface GetDciConfigsRequest {
  /** The identifier or name of DciConfig object. */
  dciId: string;
  /** A set of fabric identifiers or names. */
  fabricIds: string[];
  /** A set of object names. */
  names: string[];
  /** Candidate name. */
  candidate: string;
}

/**
 * GetDciConfigsInternalRequest encapsulates properties to query DciConfig objects.
 * The internal version of this request supplies the org_id as a field instead of a claim.
 */
export interface GetDciConfigsInternalRequest {
  request: GetDciConfigsRequest | undefined;
  orgId: string;
}

export interface GetDciConfigsResponse {
  configs: DciConfig[];
}

/**
 * A candidate configuration represents a staging area for changes to a DCI and its
 * children to be compiled before being reviewed and commited. Once commited, the candidate
 * configuration becomes the running configuration and the candidate configuration is emptied.
 */
export interface DciCandidate {
  /** The unique identifier of the DCI to which the candidate is associated to. */
  dciId: string;
  /**
   * The name of the candidate configuration. Only the `default` candidate configuration is
   * currently support.
   */
  name: string;
  /** The flag that indicates if the candidate configuration has pending changes or not. */
  active: boolean;
  /** The transaction sequence number of the candidate configuration. */
  txnId: string;
  /** An integer that represents the current revision identifier of the candidate configuration. */
  revisionId: string;
  /** The identity provider and email of the user that created the candidate configuration. */
  createdBy: string;
  /**
   * The timestamp when this object was created in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  createdAt:
    | Date
    | undefined;
  /** The identity provider and email of the user that modified the candidate configuration last. */
  modifiedBy: string;
  /**
   * The timestamp when this object was last modified in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  modifiedAt:
    | Date
    | undefined;
  /** A list of the reviews of the candidate configuration. */
  reviews: CandidateReview[];
  /** A list of the activity events of the candidate configuration. */
  events: ActivityEvent[];
}

/**
 * The request for a specific candidate configuration of a DCI.
 *
 * INTERNAL
 *
 * GetDciCandidateRequest returns a single named candidate configuration object.
 */
export interface GetDciCandidatesRequest {
  /** The DCI identifier or name. */
  dciId: string;
  /** The candidate configuration name. */
  name: string;
  /** The transaction sequence number of the candidate configuration. */
  txnId: string;
  /** Include committed/reverted candidate configurations. */
  needInactive: boolean;
  /** Include the list of reviews of the candidate configurations. */
  needReviews: boolean;
  /** Include the list of activity events of the candidate configurations. */
  needEvents: boolean;
  /**
   * Start value of the time range in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  startTime:
    | Date
    | undefined;
  /**
   * End value of the time range in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  endTime: Date | undefined;
  pagination: PaginationRequest | undefined;
}

/**
 * The response to a request for a list of candidate configurations of a specific DCI.
 *
 * INTERNAL
 *
 * GetDciCandidatesResponse encapsulates query response for DCI candidates.
 */
export interface GetDciCandidatesResponse {
  /** A list of candidate configurations of a specific DCI */
  candidates: DciCandidate[];
  /** An optional cursor for pagination. */
  cursor: string;
  pagination: PaginationResponse | undefined;
}

/**
 * The request to commit a specific candidate configuration of a DCI.
 *
 * INTERNAL
 *
 * CommitDciCandidateRequest encapsulates properties to commit a pending
 * DCI candidate. Candidates commit may require special user privileges.
 */
export interface CommitDciCandidateRequest {
  /**
   * The fabric id or name.
   *
   * INTERNAL
   *
   * Fabric identifier is mandatory.
   */
  dciId: string;
  /** The candidate configuration name. */
  name: string;
  /** The reasons for the candidate configuration commit. */
  comments: string;
  /**
   * The candidate configuration revision identifier.
   *
   * The commit request will be rejected if the provided revision identifier is
   * not the same than the most recent one known to the Hyperfabric service.
   */
  revisionId: string;
}

/** The response to a request to commit a specific candidate configuration of a DCI. */
export interface CommitDciCandidateResponse {
  /** The DCI identifier. */
  dciId: string;
  /** Indicates that the pending candidate configuration was committed. */
  committed: boolean;
}

/**
 * The request to discard a specific candidate configuration of a DCI.
 *
 * INTERNAL
 *
 * RevertDciCandidateRequest encapsulates properties to revert or rollback
 * a pending transaction of a DCI.
 */
export interface RevertDciCandidateRequest {
  /**
   * The DCI id or name.
   *
   * INTERNAL
   *
   * DCI identifier is mandatory.
   */
  dciId: string;
  /** The candidate configuration name. */
  name: string;
  /** The reasons to discard the candidate configuration. */
  comments: string;
  /**
   * The candidate configuration revision identifier.
   *
   * The discard request will be rejected if the provided revision identifier is
   * not the same than the most recent one known to the Hyperfabric service.
   */
  revisionId: string;
}

/**
 * The request to add review comments to a specific candidate configuration of a DCI.
 *
 * INTERNAL
 *
 * ReviewDciCandidateRequest encapsulates properties to add a comment
 * to an existing candidate.
 */
export interface ReviewDciCandidateRequest {
  /**
   * The DCI id or name.
   *
   * INTERNAL
   *
   * DCI identifier is mandatory.
   */
  dciId: string;
  /** The candidate configuration name. */
  name: string;
  /** The comments to be added as a review to the candidate configuration. */
  comments: string;
}

/** The request for multisite configs of a fabric. */
export interface GetFabricMultisitesRequest {
  /** The fabric identifier or name. */
  fabricId: string;
  /** The candidate name. */
  candidate: string;
  /** A set og multisite identifiers. */
  multisiteIds: string[];
  /** A set of multisite names. */
  names: string[];
}

/** The response to a request for a list of fabric multisite configs. */
export interface GetFabricMultisitesResponse {
  multisites: FabricMultisite[];
}

/**
 * The request for a command to be run on device
 *
 * INTERNAL
 */
export interface RunCommandRequest {
  deviceId: string;
  command:
    | Command
    | undefined;
  /** The output stream of the command. */
  outputStream: number;
  /** The command time to live in seconds. */
  ttl: number;
  /** Whether to persist the command request to database. Defaults to true if not provided. */
  persist?: boolean | undefined;
}

/**
 * The response to a request for the session id.
 *
 * INTERNAL
 */
export interface RunCommandResponse {
  sessionId: string;
}

/**
 * The request for a command to be stopped on device
 *
 * INTERNAL
 */
export interface StopCommandRequest {
  deviceId: string;
  sessionId: string;
}

function createBaseLabel(): Label {
  return {
    name: "",
    enabled: false,
    fabricIds: [],
    nodeIds: [],
    networkPortIds: [],
    portChannelIds: [],
    loopbackIds: [],
    vrfIds: [],
    vniIds: [],
    staticRouteIds: [],
    dhcpRelayIds: [],
    subInterfaceIds: [],
    bgpPolicyIds: [],
    bgpPeerIds: [],
    portBreakoutIds: [],
    prefixListIds: [],
    endpointIds: [],
    ipmConfigIds: [],
    dscpConfigIds: [],
    packetMirroringIds: [],
    ipSlaConfigIds: [],
    dciConfigIds: [],
    arsConfigIds: [],
  };
}

export const Label: MessageFns<Label> = {
  encode(message: Label, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    for (const v of message.fabricIds) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.nodeIds) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.networkPortIds) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.portChannelIds) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.loopbackIds) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.vrfIds) {
      writer.uint32(90).string(v!);
    }
    for (const v of message.vniIds) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.staticRouteIds) {
      writer.uint32(106).string(v!);
    }
    for (const v of message.dhcpRelayIds) {
      writer.uint32(114).string(v!);
    }
    for (const v of message.subInterfaceIds) {
      writer.uint32(122).string(v!);
    }
    for (const v of message.bgpPolicyIds) {
      writer.uint32(130).string(v!);
    }
    for (const v of message.bgpPeerIds) {
      writer.uint32(138).string(v!);
    }
    for (const v of message.portBreakoutIds) {
      writer.uint32(146).string(v!);
    }
    for (const v of message.prefixListIds) {
      writer.uint32(154).string(v!);
    }
    for (const v of message.endpointIds) {
      writer.uint32(162).string(v!);
    }
    for (const v of message.ipmConfigIds) {
      writer.uint32(170).string(v!);
    }
    for (const v of message.dscpConfigIds) {
      writer.uint32(178).string(v!);
    }
    for (const v of message.packetMirroringIds) {
      writer.uint32(186).string(v!);
    }
    for (const v of message.ipSlaConfigIds) {
      writer.uint32(194).string(v!);
    }
    for (const v of message.dciConfigIds) {
      writer.uint32(202).string(v!);
    }
    for (const v of message.arsConfigIds) {
      writer.uint32(210).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Label {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLabel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.networkPortIds.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.portChannelIds.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.loopbackIds.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.vrfIds.push(reader.string());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.vniIds.push(reader.string());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.staticRouteIds.push(reader.string());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.dhcpRelayIds.push(reader.string());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.subInterfaceIds.push(reader.string());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.bgpPolicyIds.push(reader.string());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.bgpPeerIds.push(reader.string());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.portBreakoutIds.push(reader.string());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.prefixListIds.push(reader.string());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.endpointIds.push(reader.string());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.ipmConfigIds.push(reader.string());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.dscpConfigIds.push(reader.string());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.packetMirroringIds.push(reader.string());
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.ipSlaConfigIds.push(reader.string());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.dciConfigIds.push(reader.string());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.arsConfigIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Label {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      fabricIds: globalThis.Array.isArray(object?.fabricIds)
        ? object.fabricIds.map((e: any) => globalThis.String(e))
        : [],
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      networkPortIds: globalThis.Array.isArray(object?.networkPortIds)
        ? object.networkPortIds.map((e: any) => globalThis.String(e))
        : [],
      portChannelIds: globalThis.Array.isArray(object?.portChannelIds)
        ? object.portChannelIds.map((e: any) => globalThis.String(e))
        : [],
      loopbackIds: globalThis.Array.isArray(object?.loopbackIds)
        ? object.loopbackIds.map((e: any) => globalThis.String(e))
        : [],
      vrfIds: globalThis.Array.isArray(object?.vrfIds) ? object.vrfIds.map((e: any) => globalThis.String(e)) : [],
      vniIds: globalThis.Array.isArray(object?.vniIds) ? object.vniIds.map((e: any) => globalThis.String(e)) : [],
      staticRouteIds: globalThis.Array.isArray(object?.staticRouteIds)
        ? object.staticRouteIds.map((e: any) => globalThis.String(e))
        : [],
      dhcpRelayIds: globalThis.Array.isArray(object?.dhcpRelayIds)
        ? object.dhcpRelayIds.map((e: any) => globalThis.String(e))
        : [],
      subInterfaceIds: globalThis.Array.isArray(object?.subInterfaceIds)
        ? object.subInterfaceIds.map((e: any) => globalThis.String(e))
        : [],
      bgpPolicyIds: globalThis.Array.isArray(object?.bgpPolicyIds)
        ? object.bgpPolicyIds.map((e: any) => globalThis.String(e))
        : [],
      bgpPeerIds: globalThis.Array.isArray(object?.bgpPeerIds)
        ? object.bgpPeerIds.map((e: any) => globalThis.String(e))
        : [],
      portBreakoutIds: globalThis.Array.isArray(object?.portBreakoutIds)
        ? object.portBreakoutIds.map((e: any) => globalThis.String(e))
        : [],
      prefixListIds: globalThis.Array.isArray(object?.prefixListIds)
        ? object.prefixListIds.map((e: any) => globalThis.String(e))
        : [],
      endpointIds: globalThis.Array.isArray(object?.endpointIds)
        ? object.endpointIds.map((e: any) => globalThis.String(e))
        : [],
      ipmConfigIds: globalThis.Array.isArray(object?.ipmConfigIds)
        ? object.ipmConfigIds.map((e: any) => globalThis.String(e))
        : [],
      dscpConfigIds: globalThis.Array.isArray(object?.dscpConfigIds)
        ? object.dscpConfigIds.map((e: any) => globalThis.String(e))
        : [],
      packetMirroringIds: globalThis.Array.isArray(object?.packetMirroringIds)
        ? object.packetMirroringIds.map((e: any) => globalThis.String(e))
        : [],
      ipSlaConfigIds: globalThis.Array.isArray(object?.ipSlaConfigIds)
        ? object.ipSlaConfigIds.map((e: any) => globalThis.String(e))
        : [],
      dciConfigIds: globalThis.Array.isArray(object?.dciConfigIds)
        ? object.dciConfigIds.map((e: any) => globalThis.String(e))
        : [],
      arsConfigIds: globalThis.Array.isArray(object?.arsConfigIds)
        ? object.arsConfigIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Label): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.fabricIds?.length) {
      obj.fabricIds = message.fabricIds;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.networkPortIds?.length) {
      obj.networkPortIds = message.networkPortIds;
    }
    if (message.portChannelIds?.length) {
      obj.portChannelIds = message.portChannelIds;
    }
    if (message.loopbackIds?.length) {
      obj.loopbackIds = message.loopbackIds;
    }
    if (message.vrfIds?.length) {
      obj.vrfIds = message.vrfIds;
    }
    if (message.vniIds?.length) {
      obj.vniIds = message.vniIds;
    }
    if (message.staticRouteIds?.length) {
      obj.staticRouteIds = message.staticRouteIds;
    }
    if (message.dhcpRelayIds?.length) {
      obj.dhcpRelayIds = message.dhcpRelayIds;
    }
    if (message.subInterfaceIds?.length) {
      obj.subInterfaceIds = message.subInterfaceIds;
    }
    if (message.bgpPolicyIds?.length) {
      obj.bgpPolicyIds = message.bgpPolicyIds;
    }
    if (message.bgpPeerIds?.length) {
      obj.bgpPeerIds = message.bgpPeerIds;
    }
    if (message.portBreakoutIds?.length) {
      obj.portBreakoutIds = message.portBreakoutIds;
    }
    if (message.prefixListIds?.length) {
      obj.prefixListIds = message.prefixListIds;
    }
    if (message.endpointIds?.length) {
      obj.endpointIds = message.endpointIds;
    }
    if (message.ipmConfigIds?.length) {
      obj.ipmConfigIds = message.ipmConfigIds;
    }
    if (message.dscpConfigIds?.length) {
      obj.dscpConfigIds = message.dscpConfigIds;
    }
    if (message.packetMirroringIds?.length) {
      obj.packetMirroringIds = message.packetMirroringIds;
    }
    if (message.ipSlaConfigIds?.length) {
      obj.ipSlaConfigIds = message.ipSlaConfigIds;
    }
    if (message.dciConfigIds?.length) {
      obj.dciConfigIds = message.dciConfigIds;
    }
    if (message.arsConfigIds?.length) {
      obj.arsConfigIds = message.arsConfigIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Label>, I>>(base?: I): Label {
    return Label.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Label>, I>>(object: I): Label {
    const message = createBaseLabel();
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.fabricIds = object.fabricIds?.map((e) => e) || [];
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.networkPortIds = object.networkPortIds?.map((e) => e) || [];
    message.portChannelIds = object.portChannelIds?.map((e) => e) || [];
    message.loopbackIds = object.loopbackIds?.map((e) => e) || [];
    message.vrfIds = object.vrfIds?.map((e) => e) || [];
    message.vniIds = object.vniIds?.map((e) => e) || [];
    message.staticRouteIds = object.staticRouteIds?.map((e) => e) || [];
    message.dhcpRelayIds = object.dhcpRelayIds?.map((e) => e) || [];
    message.subInterfaceIds = object.subInterfaceIds?.map((e) => e) || [];
    message.bgpPolicyIds = object.bgpPolicyIds?.map((e) => e) || [];
    message.bgpPeerIds = object.bgpPeerIds?.map((e) => e) || [];
    message.portBreakoutIds = object.portBreakoutIds?.map((e) => e) || [];
    message.prefixListIds = object.prefixListIds?.map((e) => e) || [];
    message.endpointIds = object.endpointIds?.map((e) => e) || [];
    message.ipmConfigIds = object.ipmConfigIds?.map((e) => e) || [];
    message.dscpConfigIds = object.dscpConfigIds?.map((e) => e) || [];
    message.packetMirroringIds = object.packetMirroringIds?.map((e) => e) || [];
    message.ipSlaConfigIds = object.ipSlaConfigIds?.map((e) => e) || [];
    message.dciConfigIds = object.dciConfigIds?.map((e) => e) || [];
    message.arsConfigIds = object.arsConfigIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseProvisionSettings(): ProvisionSettings {
  return {
    setOrgProperties: [],
    setPrefixLists: [],
    delPrefixLists: [],
    setDciConfigs: [],
    delDciConfigs: [],
    setLabels: [],
    setOrgCertificates: [],
    delOrgCertificates: [],
    setEndpoints: [],
    delEndpoints: [],
    setNotificationSettings: [],
    delNotificationSettings: [],
  };
}

export const ProvisionSettings: MessageFns<ProvisionSettings> = {
  encode(message: ProvisionSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.setOrgProperties) {
      OrgProperty.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.setPrefixLists) {
      PrefixList.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.delPrefixLists) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.setDciConfigs) {
      DciConfig.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.delDciConfigs) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.setLabels) {
      Label.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.setOrgCertificates) {
      Certificates.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.delOrgCertificates) {
      writer.uint32(90).string(v!);
    }
    for (const v of message.setEndpoints) {
      Endpoint.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.delEndpoints) {
      writer.uint32(106).string(v!);
    }
    for (const v of message.setNotificationSettings) {
      NotificationSettings.encode(v!, writer.uint32(114).fork()).join();
    }
    for (const v of message.delNotificationSettings) {
      writer.uint32(122).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.setOrgProperties.push(OrgProperty.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.setPrefixLists.push(PrefixList.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.delPrefixLists.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.setDciConfigs.push(DciConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.delDciConfigs.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.setLabels.push(Label.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.setOrgCertificates.push(Certificates.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.delOrgCertificates.push(reader.string());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.setEndpoints.push(Endpoint.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.delEndpoints.push(reader.string());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.setNotificationSettings.push(NotificationSettings.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.delNotificationSettings.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionSettings {
    return {
      setOrgProperties: globalThis.Array.isArray(object?.setOrgProperties)
        ? object.setOrgProperties.map((e: any) => OrgProperty.fromJSON(e))
        : [],
      setPrefixLists: globalThis.Array.isArray(object?.setPrefixLists)
        ? object.setPrefixLists.map((e: any) => PrefixList.fromJSON(e))
        : [],
      delPrefixLists: globalThis.Array.isArray(object?.delPrefixLists)
        ? object.delPrefixLists.map((e: any) => globalThis.String(e))
        : [],
      setDciConfigs: globalThis.Array.isArray(object?.setDciConfigs)
        ? object.setDciConfigs.map((e: any) => DciConfig.fromJSON(e))
        : [],
      delDciConfigs: globalThis.Array.isArray(object?.delDciConfigs)
        ? object.delDciConfigs.map((e: any) => globalThis.String(e))
        : [],
      setLabels: globalThis.Array.isArray(object?.setLabels) ? object.setLabels.map((e: any) => Label.fromJSON(e)) : [],
      setOrgCertificates: globalThis.Array.isArray(object?.setOrgCertificates)
        ? object.setOrgCertificates.map((e: any) => Certificates.fromJSON(e))
        : [],
      delOrgCertificates: globalThis.Array.isArray(object?.delOrgCertificates)
        ? object.delOrgCertificates.map((e: any) => globalThis.String(e))
        : [],
      setEndpoints: globalThis.Array.isArray(object?.setEndpoints)
        ? object.setEndpoints.map((e: any) => Endpoint.fromJSON(e))
        : [],
      delEndpoints: globalThis.Array.isArray(object?.delEndpoints)
        ? object.delEndpoints.map((e: any) => globalThis.String(e))
        : [],
      setNotificationSettings: globalThis.Array.isArray(object?.setNotificationSettings)
        ? object.setNotificationSettings.map((e: any) => NotificationSettings.fromJSON(e))
        : [],
      delNotificationSettings: globalThis.Array.isArray(object?.delNotificationSettings)
        ? object.delNotificationSettings.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ProvisionSettings): unknown {
    const obj: any = {};
    if (message.setOrgProperties?.length) {
      obj.setOrgProperties = message.setOrgProperties.map((e) => OrgProperty.toJSON(e));
    }
    if (message.setPrefixLists?.length) {
      obj.setPrefixLists = message.setPrefixLists.map((e) => PrefixList.toJSON(e));
    }
    if (message.delPrefixLists?.length) {
      obj.delPrefixLists = message.delPrefixLists;
    }
    if (message.setDciConfigs?.length) {
      obj.setDciConfigs = message.setDciConfigs.map((e) => DciConfig.toJSON(e));
    }
    if (message.delDciConfigs?.length) {
      obj.delDciConfigs = message.delDciConfigs;
    }
    if (message.setLabels?.length) {
      obj.setLabels = message.setLabels.map((e) => Label.toJSON(e));
    }
    if (message.setOrgCertificates?.length) {
      obj.setOrgCertificates = message.setOrgCertificates.map((e) => Certificates.toJSON(e));
    }
    if (message.delOrgCertificates?.length) {
      obj.delOrgCertificates = message.delOrgCertificates;
    }
    if (message.setEndpoints?.length) {
      obj.setEndpoints = message.setEndpoints.map((e) => Endpoint.toJSON(e));
    }
    if (message.delEndpoints?.length) {
      obj.delEndpoints = message.delEndpoints;
    }
    if (message.setNotificationSettings?.length) {
      obj.setNotificationSettings = message.setNotificationSettings.map((e) => NotificationSettings.toJSON(e));
    }
    if (message.delNotificationSettings?.length) {
      obj.delNotificationSettings = message.delNotificationSettings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionSettings>, I>>(base?: I): ProvisionSettings {
    return ProvisionSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionSettings>, I>>(object: I): ProvisionSettings {
    const message = createBaseProvisionSettings();
    message.setOrgProperties = object.setOrgProperties?.map((e) => OrgProperty.fromPartial(e)) || [];
    message.setPrefixLists = object.setPrefixLists?.map((e) => PrefixList.fromPartial(e)) || [];
    message.delPrefixLists = object.delPrefixLists?.map((e) => e) || [];
    message.setDciConfigs = object.setDciConfigs?.map((e) => DciConfig.fromPartial(e)) || [];
    message.delDciConfigs = object.delDciConfigs?.map((e) => e) || [];
    message.setLabels = object.setLabels?.map((e) => Label.fromPartial(e)) || [];
    message.setOrgCertificates = object.setOrgCertificates?.map((e) => Certificates.fromPartial(e)) || [];
    message.delOrgCertificates = object.delOrgCertificates?.map((e) => e) || [];
    message.setEndpoints = object.setEndpoints?.map((e) => Endpoint.fromPartial(e)) || [];
    message.delEndpoints = object.delEndpoints?.map((e) => e) || [];
    message.setNotificationSettings = object.setNotificationSettings?.map((e) => NotificationSettings.fromPartial(e)) ||
      [];
    message.delNotificationSettings = object.delNotificationSettings?.map((e) => e) || [];
    return message;
  },
};

function createBaseProvisionTenants(): ProvisionTenants {
  return {
    setArsConfigs: [],
    delArsConfigs: [],
    setLoopbacks: [],
    delLoopbacks: [],
    setVrfs: [],
    delVrfs: [],
    setPortChannels: [],
    delPortChannels: [],
    setVnis: [],
    delVnis: [],
    setStaticRoutes: [],
    delStaticRoutes: [],
    setDhcpRelays: [],
    delDhcpRelays: [],
    setSubInterfaces: [],
    delSubInterfaces: [],
    setBgpPolicies: [],
    delBgpPolicies: [],
    setBgpPeers: [],
    delBgpPeers: [],
    setIpmConfigs: [],
    delIpmConfigs: [],
    setDscpConfigs: [],
    delDscpConfigs: [],
    setPacketMirrorings: [],
    delPacketMirrorings: [],
    setIpSlaConfigs: [],
    delIpSlaConfigs: [],
  };
}

export const ProvisionTenants: MessageFns<ProvisionTenants> = {
  encode(message: ProvisionTenants, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.setArsConfigs) {
      ArsConfig.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.delArsConfigs) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.setLoopbacks) {
      Loopback.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.delLoopbacks) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.setVrfs) {
      Vrf.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.delVrfs) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.setPortChannels) {
      PortChannel.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.delPortChannels) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.setVnis) {
      Vni.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.delVnis) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.setStaticRoutes) {
      StaticRoutes.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.delStaticRoutes) {
      writer.uint32(114).string(v!);
    }
    for (const v of message.setDhcpRelays) {
      DhcpRelay.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.delDhcpRelays) {
      writer.uint32(130).string(v!);
    }
    for (const v of message.setSubInterfaces) {
      SubInterface.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.delSubInterfaces) {
      writer.uint32(146).string(v!);
    }
    for (const v of message.setBgpPolicies) {
      BgpPolicy.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.delBgpPolicies) {
      writer.uint32(162).string(v!);
    }
    for (const v of message.setBgpPeers) {
      BgpPeer.encode(v!, writer.uint32(170).fork()).join();
    }
    for (const v of message.delBgpPeers) {
      writer.uint32(178).string(v!);
    }
    for (const v of message.setIpmConfigs) {
      IpmConfig.encode(v!, writer.uint32(186).fork()).join();
    }
    for (const v of message.delIpmConfigs) {
      writer.uint32(194).string(v!);
    }
    for (const v of message.setDscpConfigs) {
      DscpConfig.encode(v!, writer.uint32(202).fork()).join();
    }
    for (const v of message.delDscpConfigs) {
      writer.uint32(210).string(v!);
    }
    for (const v of message.setPacketMirrorings) {
      PacketMirroring.encode(v!, writer.uint32(218).fork()).join();
    }
    for (const v of message.delPacketMirrorings) {
      writer.uint32(226).string(v!);
    }
    for (const v of message.setIpSlaConfigs) {
      IpSlaConfig.encode(v!, writer.uint32(234).fork()).join();
    }
    for (const v of message.delIpSlaConfigs) {
      writer.uint32(242).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionTenants {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionTenants();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.setArsConfigs.push(ArsConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.delArsConfigs.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.setLoopbacks.push(Loopback.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.delLoopbacks.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.setVrfs.push(Vrf.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.delVrfs.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.setPortChannels.push(PortChannel.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.delPortChannels.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.setVnis.push(Vni.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.delVnis.push(reader.string());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.setStaticRoutes.push(StaticRoutes.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.delStaticRoutes.push(reader.string());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.setDhcpRelays.push(DhcpRelay.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.delDhcpRelays.push(reader.string());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.setSubInterfaces.push(SubInterface.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.delSubInterfaces.push(reader.string());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.setBgpPolicies.push(BgpPolicy.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.delBgpPolicies.push(reader.string());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.setBgpPeers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.delBgpPeers.push(reader.string());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.setIpmConfigs.push(IpmConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.delIpmConfigs.push(reader.string());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.setDscpConfigs.push(DscpConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.delDscpConfigs.push(reader.string());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.setPacketMirrorings.push(PacketMirroring.decode(reader, reader.uint32()));
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.delPacketMirrorings.push(reader.string());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.setIpSlaConfigs.push(IpSlaConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.delIpSlaConfigs.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionTenants {
    return {
      setArsConfigs: globalThis.Array.isArray(object?.setArsConfigs)
        ? object.setArsConfigs.map((e: any) => ArsConfig.fromJSON(e))
        : [],
      delArsConfigs: globalThis.Array.isArray(object?.delArsConfigs)
        ? object.delArsConfigs.map((e: any) => globalThis.String(e))
        : [],
      setLoopbacks: globalThis.Array.isArray(object?.setLoopbacks)
        ? object.setLoopbacks.map((e: any) => Loopback.fromJSON(e))
        : [],
      delLoopbacks: globalThis.Array.isArray(object?.delLoopbacks)
        ? object.delLoopbacks.map((e: any) => globalThis.String(e))
        : [],
      setVrfs: globalThis.Array.isArray(object?.setVrfs)
        ? object.setVrfs.map((e: any) => Vrf.fromJSON(e))
        : [],
      delVrfs: globalThis.Array.isArray(object?.delVrfs) ? object.delVrfs.map((e: any) => globalThis.String(e)) : [],
      setPortChannels: globalThis.Array.isArray(object?.setPortChannels)
        ? object.setPortChannels.map((e: any) => PortChannel.fromJSON(e))
        : [],
      delPortChannels: globalThis.Array.isArray(object?.delPortChannels)
        ? object.delPortChannels.map((e: any) => globalThis.String(e))
        : [],
      setVnis: globalThis.Array.isArray(object?.setVnis)
        ? object.setVnis.map((e: any) => Vni.fromJSON(e))
        : [],
      delVnis: globalThis.Array.isArray(object?.delVnis) ? object.delVnis.map((e: any) => globalThis.String(e)) : [],
      setStaticRoutes: globalThis.Array.isArray(object?.setStaticRoutes)
        ? object.setStaticRoutes.map((e: any) => StaticRoutes.fromJSON(e))
        : [],
      delStaticRoutes: globalThis.Array.isArray(object?.delStaticRoutes)
        ? object.delStaticRoutes.map((e: any) => globalThis.String(e))
        : [],
      setDhcpRelays: globalThis.Array.isArray(object?.setDhcpRelays)
        ? object.setDhcpRelays.map((e: any) => DhcpRelay.fromJSON(e))
        : [],
      delDhcpRelays: globalThis.Array.isArray(object?.delDhcpRelays)
        ? object.delDhcpRelays.map((e: any) => globalThis.String(e))
        : [],
      setSubInterfaces: globalThis.Array.isArray(object?.setSubInterfaces)
        ? object.setSubInterfaces.map((e: any) => SubInterface.fromJSON(e))
        : [],
      delSubInterfaces: globalThis.Array.isArray(object?.delSubInterfaces)
        ? object.delSubInterfaces.map((e: any) => globalThis.String(e))
        : [],
      setBgpPolicies: globalThis.Array.isArray(object?.setBgpPolicies)
        ? object.setBgpPolicies.map((e: any) => BgpPolicy.fromJSON(e))
        : [],
      delBgpPolicies: globalThis.Array.isArray(object?.delBgpPolicies)
        ? object.delBgpPolicies.map((e: any) => globalThis.String(e))
        : [],
      setBgpPeers: globalThis.Array.isArray(object?.setBgpPeers)
        ? object.setBgpPeers.map((e: any) => BgpPeer.fromJSON(e))
        : [],
      delBgpPeers: globalThis.Array.isArray(object?.delBgpPeers)
        ? object.delBgpPeers.map((e: any) => globalThis.String(e))
        : [],
      setIpmConfigs: globalThis.Array.isArray(object?.setIpmConfigs)
        ? object.setIpmConfigs.map((e: any) => IpmConfig.fromJSON(e))
        : [],
      delIpmConfigs: globalThis.Array.isArray(object?.delIpmConfigs)
        ? object.delIpmConfigs.map((e: any) => globalThis.String(e))
        : [],
      setDscpConfigs: globalThis.Array.isArray(object?.setDscpConfigs)
        ? object.setDscpConfigs.map((e: any) => DscpConfig.fromJSON(e))
        : [],
      delDscpConfigs: globalThis.Array.isArray(object?.delDscpConfigs)
        ? object.delDscpConfigs.map((e: any) => globalThis.String(e))
        : [],
      setPacketMirrorings: globalThis.Array.isArray(object?.setPacketMirrorings)
        ? object.setPacketMirrorings.map((e: any) => PacketMirroring.fromJSON(e))
        : [],
      delPacketMirrorings: globalThis.Array.isArray(object?.delPacketMirrorings)
        ? object.delPacketMirrorings.map((e: any) => globalThis.String(e))
        : [],
      setIpSlaConfigs: globalThis.Array.isArray(object?.setIpSlaConfigs)
        ? object.setIpSlaConfigs.map((e: any) => IpSlaConfig.fromJSON(e))
        : [],
      delIpSlaConfigs: globalThis.Array.isArray(object?.delIpSlaConfigs)
        ? object.delIpSlaConfigs.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ProvisionTenants): unknown {
    const obj: any = {};
    if (message.setArsConfigs?.length) {
      obj.setArsConfigs = message.setArsConfigs.map((e) => ArsConfig.toJSON(e));
    }
    if (message.delArsConfigs?.length) {
      obj.delArsConfigs = message.delArsConfigs;
    }
    if (message.setLoopbacks?.length) {
      obj.setLoopbacks = message.setLoopbacks.map((e) => Loopback.toJSON(e));
    }
    if (message.delLoopbacks?.length) {
      obj.delLoopbacks = message.delLoopbacks;
    }
    if (message.setVrfs?.length) {
      obj.setVrfs = message.setVrfs.map((e) => Vrf.toJSON(e));
    }
    if (message.delVrfs?.length) {
      obj.delVrfs = message.delVrfs;
    }
    if (message.setPortChannels?.length) {
      obj.setPortChannels = message.setPortChannels.map((e) => PortChannel.toJSON(e));
    }
    if (message.delPortChannels?.length) {
      obj.delPortChannels = message.delPortChannels;
    }
    if (message.setVnis?.length) {
      obj.setVnis = message.setVnis.map((e) => Vni.toJSON(e));
    }
    if (message.delVnis?.length) {
      obj.delVnis = message.delVnis;
    }
    if (message.setStaticRoutes?.length) {
      obj.setStaticRoutes = message.setStaticRoutes.map((e) => StaticRoutes.toJSON(e));
    }
    if (message.delStaticRoutes?.length) {
      obj.delStaticRoutes = message.delStaticRoutes;
    }
    if (message.setDhcpRelays?.length) {
      obj.setDhcpRelays = message.setDhcpRelays.map((e) => DhcpRelay.toJSON(e));
    }
    if (message.delDhcpRelays?.length) {
      obj.delDhcpRelays = message.delDhcpRelays;
    }
    if (message.setSubInterfaces?.length) {
      obj.setSubInterfaces = message.setSubInterfaces.map((e) => SubInterface.toJSON(e));
    }
    if (message.delSubInterfaces?.length) {
      obj.delSubInterfaces = message.delSubInterfaces;
    }
    if (message.setBgpPolicies?.length) {
      obj.setBgpPolicies = message.setBgpPolicies.map((e) => BgpPolicy.toJSON(e));
    }
    if (message.delBgpPolicies?.length) {
      obj.delBgpPolicies = message.delBgpPolicies;
    }
    if (message.setBgpPeers?.length) {
      obj.setBgpPeers = message.setBgpPeers.map((e) => BgpPeer.toJSON(e));
    }
    if (message.delBgpPeers?.length) {
      obj.delBgpPeers = message.delBgpPeers;
    }
    if (message.setIpmConfigs?.length) {
      obj.setIpmConfigs = message.setIpmConfigs.map((e) => IpmConfig.toJSON(e));
    }
    if (message.delIpmConfigs?.length) {
      obj.delIpmConfigs = message.delIpmConfigs;
    }
    if (message.setDscpConfigs?.length) {
      obj.setDscpConfigs = message.setDscpConfigs.map((e) => DscpConfig.toJSON(e));
    }
    if (message.delDscpConfigs?.length) {
      obj.delDscpConfigs = message.delDscpConfigs;
    }
    if (message.setPacketMirrorings?.length) {
      obj.setPacketMirrorings = message.setPacketMirrorings.map((e) => PacketMirroring.toJSON(e));
    }
    if (message.delPacketMirrorings?.length) {
      obj.delPacketMirrorings = message.delPacketMirrorings;
    }
    if (message.setIpSlaConfigs?.length) {
      obj.setIpSlaConfigs = message.setIpSlaConfigs.map((e) => IpSlaConfig.toJSON(e));
    }
    if (message.delIpSlaConfigs?.length) {
      obj.delIpSlaConfigs = message.delIpSlaConfigs;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionTenants>, I>>(base?: I): ProvisionTenants {
    return ProvisionTenants.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionTenants>, I>>(object: I): ProvisionTenants {
    const message = createBaseProvisionTenants();
    message.setArsConfigs = object.setArsConfigs?.map((e) => ArsConfig.fromPartial(e)) || [];
    message.delArsConfigs = object.delArsConfigs?.map((e) => e) || [];
    message.setLoopbacks = object.setLoopbacks?.map((e) => Loopback.fromPartial(e)) || [];
    message.delLoopbacks = object.delLoopbacks?.map((e) => e) || [];
    message.setVrfs = object.setVrfs?.map((e) => Vrf.fromPartial(e)) || [];
    message.delVrfs = object.delVrfs?.map((e) => e) || [];
    message.setPortChannels = object.setPortChannels?.map((e) => PortChannel.fromPartial(e)) || [];
    message.delPortChannels = object.delPortChannels?.map((e) => e) || [];
    message.setVnis = object.setVnis?.map((e) => Vni.fromPartial(e)) || [];
    message.delVnis = object.delVnis?.map((e) => e) || [];
    message.setStaticRoutes = object.setStaticRoutes?.map((e) => StaticRoutes.fromPartial(e)) || [];
    message.delStaticRoutes = object.delStaticRoutes?.map((e) => e) || [];
    message.setDhcpRelays = object.setDhcpRelays?.map((e) => DhcpRelay.fromPartial(e)) || [];
    message.delDhcpRelays = object.delDhcpRelays?.map((e) => e) || [];
    message.setSubInterfaces = object.setSubInterfaces?.map((e) => SubInterface.fromPartial(e)) || [];
    message.delSubInterfaces = object.delSubInterfaces?.map((e) => e) || [];
    message.setBgpPolicies = object.setBgpPolicies?.map((e) => BgpPolicy.fromPartial(e)) || [];
    message.delBgpPolicies = object.delBgpPolicies?.map((e) => e) || [];
    message.setBgpPeers = object.setBgpPeers?.map((e) => BgpPeer.fromPartial(e)) || [];
    message.delBgpPeers = object.delBgpPeers?.map((e) => e) || [];
    message.setIpmConfigs = object.setIpmConfigs?.map((e) => IpmConfig.fromPartial(e)) || [];
    message.delIpmConfigs = object.delIpmConfigs?.map((e) => e) || [];
    message.setDscpConfigs = object.setDscpConfigs?.map((e) => DscpConfig.fromPartial(e)) || [];
    message.delDscpConfigs = object.delDscpConfigs?.map((e) => e) || [];
    message.setPacketMirrorings = object.setPacketMirrorings?.map((e) => PacketMirroring.fromPartial(e)) || [];
    message.delPacketMirrorings = object.delPacketMirrorings?.map((e) => e) || [];
    message.setIpSlaConfigs = object.setIpSlaConfigs?.map((e) => IpSlaConfig.fromPartial(e)) || [];
    message.delIpSlaConfigs = object.delIpSlaConfigs?.map((e) => e) || [];
    return message;
  },
};

function createBaseDeleteTenantChildrenRequest(): DeleteTenantChildrenRequest {
  return { tenantId: [] };
}

export const DeleteTenantChildrenRequest: MessageFns<DeleteTenantChildrenRequest> = {
  encode(message: DeleteTenantChildrenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tenantId) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTenantChildrenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTenantChildrenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTenantChildrenRequest {
    return {
      tenantId: globalThis.Array.isArray(object?.tenantId) ? object.tenantId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: DeleteTenantChildrenRequest): unknown {
    const obj: any = {};
    if (message.tenantId?.length) {
      obj.tenantId = message.tenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteTenantChildrenRequest>, I>>(base?: I): DeleteTenantChildrenRequest {
    return DeleteTenantChildrenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteTenantChildrenRequest>, I>>(object: I): DeleteTenantChildrenRequest {
    const message = createBaseDeleteTenantChildrenRequest();
    message.tenantId = object.tenantId?.map((e) => e) || [];
    return message;
  },
};

function createBaseBindDevice(): BindDevice {
  return { fabricId: "", nodeId: "", deviceId: "" };
}

export const BindDevice: MessageFns<BindDevice> = {
  encode(message: BindDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BindDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBindDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BindDevice {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: BindDevice): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BindDevice>, I>>(base?: I): BindDevice {
    return BindDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BindDevice>, I>>(object: I): BindDevice {
    const message = createBaseBindDevice();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseProvisionFabrics(): ProvisionFabrics {
  return {
    setFabrics: [],
    delFabrics: [],
    setConnections: [],
    delConnections: [],
    setPortBreakouts: [],
    delPortBreakouts: [],
    setNodes: [],
    delNodes: [],
    bindDevices: [],
    unbindDevices: [],
    setPerVlanStps: [],
    setMultisites: [],
    delMultisites: [],
    setNetworkPorts: [],
    resetNetworkPorts: [],
    setFabricSwConf: [],
    delFabricSwConf: [],
    skipDeviceReadinessCheck: false,
    setFabricDesigns: [],
    deleteFabricDesigns: [],
    delFabricDesignObjects: [],
    setFabricDesignObjects: [],
    setServerMgmtPorts: [],
    delInventories: [],
    setDashboardFolders: [],
    delDashboardFolders: [],
    setDashboards: [],
    delDashboards: [],
    setDashboardPanels: [],
    delDashboardPanels: [],
    setResourceReservations: [],
    delResourceReservations: [],
    restoreFabric: "",
  };
}

export const ProvisionFabrics: MessageFns<ProvisionFabrics> = {
  encode(message: ProvisionFabrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.setFabrics) {
      Fabric.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.delFabrics) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.setConnections) {
      PortConnection.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.delConnections) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.setPortBreakouts) {
      PortBreakout.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.delPortBreakouts) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.setNodes) {
      Node.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.delNodes) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.bindDevices) {
      BindDevice.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.unbindDevices) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.setPerVlanStps) {
      PerVlanStp.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.setMultisites) {
      FabricMultisite.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.delMultisites) {
      writer.uint32(106).string(v!);
    }
    for (const v of message.setNetworkPorts) {
      NetworkPort.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.resetNetworkPorts) {
      writer.uint32(130).string(v!);
    }
    for (const v of message.setFabricSwConf) {
      FabricSoftwareConfig.encode(v!, writer.uint32(242).fork()).join();
    }
    for (const v of message.delFabricSwConf) {
      FabricSoftwareConfig.encode(v!, writer.uint32(250).fork()).join();
    }
    if (message.skipDeviceReadinessCheck !== false) {
      writer.uint32(256).bool(message.skipDeviceReadinessCheck);
    }
    for (const v of message.setFabricDesigns) {
      FabricDesign.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.deleteFabricDesigns) {
      writer.uint32(170).string(v!);
    }
    for (const v of message.delFabricDesignObjects) {
      DeleteFabricDesignObjects.encode(v!, writer.uint32(186).fork()).join();
    }
    for (const v of message.setFabricDesignObjects) {
      SetFabricDesignObjects.encode(v!, writer.uint32(194).fork()).join();
    }
    for (const v of message.setServerMgmtPorts) {
      ServerMgmtPort.encode(v!, writer.uint32(178).fork()).join();
    }
    for (const v of message.delInventories) {
      writer.uint32(402).string(v!);
    }
    for (const v of message.setDashboardFolders) {
      DashboardFolder.encode(v!, writer.uint32(482).fork()).join();
    }
    for (const v of message.delDashboardFolders) {
      writer.uint32(490).string(v!);
    }
    for (const v of message.setDashboards) {
      Dashboard.encode(v!, writer.uint32(498).fork()).join();
    }
    for (const v of message.delDashboards) {
      writer.uint32(506).string(v!);
    }
    for (const v of message.setDashboardPanels) {
      Panel.encode(v!, writer.uint32(514).fork()).join();
    }
    for (const v of message.delDashboardPanels) {
      writer.uint32(522).string(v!);
    }
    for (const v of message.setResourceReservations) {
      ResourceReservation.encode(v!, writer.uint32(562).fork()).join();
    }
    for (const v of message.delResourceReservations) {
      writer.uint32(570).string(v!);
    }
    if (message.restoreFabric !== "") {
      writer.uint32(802).string(message.restoreFabric);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionFabrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionFabrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.setFabrics.push(Fabric.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.delFabrics.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.setConnections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.delConnections.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.setPortBreakouts.push(PortBreakout.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.delPortBreakouts.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.setNodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.delNodes.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.bindDevices.push(BindDevice.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.unbindDevices.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.setPerVlanStps.push(PerVlanStp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.setMultisites.push(FabricMultisite.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.delMultisites.push(reader.string());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.setNetworkPorts.push(NetworkPort.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.resetNetworkPorts.push(reader.string());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.setFabricSwConf.push(FabricSoftwareConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.delFabricSwConf.push(FabricSoftwareConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.skipDeviceReadinessCheck = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.setFabricDesigns.push(FabricDesign.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.deleteFabricDesigns.push(reader.string());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.delFabricDesignObjects.push(DeleteFabricDesignObjects.decode(reader, reader.uint32()));
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.setFabricDesignObjects.push(SetFabricDesignObjects.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.setServerMgmtPorts.push(ServerMgmtPort.decode(reader, reader.uint32()));
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.delInventories.push(reader.string());
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.setDashboardFolders.push(DashboardFolder.decode(reader, reader.uint32()));
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.delDashboardFolders.push(reader.string());
          continue;
        }
        case 62: {
          if (tag !== 498) {
            break;
          }

          message.setDashboards.push(Dashboard.decode(reader, reader.uint32()));
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.delDashboards.push(reader.string());
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.setDashboardPanels.push(Panel.decode(reader, reader.uint32()));
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.delDashboardPanels.push(reader.string());
          continue;
        }
        case 70: {
          if (tag !== 562) {
            break;
          }

          message.setResourceReservations.push(ResourceReservation.decode(reader, reader.uint32()));
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.delResourceReservations.push(reader.string());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.restoreFabric = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionFabrics {
    return {
      setFabrics: globalThis.Array.isArray(object?.setFabrics)
        ? object.setFabrics.map((e: any) => Fabric.fromJSON(e))
        : [],
      delFabrics: globalThis.Array.isArray(object?.delFabrics)
        ? object.delFabrics.map((e: any) => globalThis.String(e))
        : [],
      setConnections: globalThis.Array.isArray(object?.setConnections)
        ? object.setConnections.map((e: any) => PortConnection.fromJSON(e))
        : [],
      delConnections: globalThis.Array.isArray(object?.delConnections)
        ? object.delConnections.map((e: any) => globalThis.String(e))
        : [],
      setPortBreakouts: globalThis.Array.isArray(object?.setPortBreakouts)
        ? object.setPortBreakouts.map((e: any) => PortBreakout.fromJSON(e))
        : [],
      delPortBreakouts: globalThis.Array.isArray(object?.delPortBreakouts)
        ? object.delPortBreakouts.map((e: any) => globalThis.String(e))
        : [],
      setNodes: globalThis.Array.isArray(object?.setNodes)
        ? object.setNodes.map((e: any) => Node.fromJSON(e))
        : [],
      delNodes: globalThis.Array.isArray(object?.delNodes) ? object.delNodes.map((e: any) => globalThis.String(e)) : [],
      bindDevices: globalThis.Array.isArray(object?.bindDevices)
        ? object.bindDevices.map((e: any) => BindDevice.fromJSON(e))
        : [],
      unbindDevices: globalThis.Array.isArray(object?.unbindDevices)
        ? object.unbindDevices.map((e: any) => globalThis.String(e))
        : [],
      setPerVlanStps: globalThis.Array.isArray(object?.setPerVlanStps)
        ? object.setPerVlanStps.map((e: any) => PerVlanStp.fromJSON(e))
        : [],
      setMultisites: globalThis.Array.isArray(object?.setMultisites)
        ? object.setMultisites.map((e: any) => FabricMultisite.fromJSON(e))
        : [],
      delMultisites: globalThis.Array.isArray(object?.delMultisites)
        ? object.delMultisites.map((e: any) => globalThis.String(e))
        : [],
      setNetworkPorts: globalThis.Array.isArray(object?.setNetworkPorts)
        ? object.setNetworkPorts.map((e: any) => NetworkPort.fromJSON(e))
        : [],
      resetNetworkPorts: globalThis.Array.isArray(object?.resetNetworkPorts)
        ? object.resetNetworkPorts.map((e: any) => globalThis.String(e))
        : [],
      setFabricSwConf: globalThis.Array.isArray(object?.setFabricSwConf)
        ? object.setFabricSwConf.map((e: any) => FabricSoftwareConfig.fromJSON(e))
        : [],
      delFabricSwConf: globalThis.Array.isArray(object?.delFabricSwConf)
        ? object.delFabricSwConf.map((e: any) => FabricSoftwareConfig.fromJSON(e))
        : [],
      skipDeviceReadinessCheck: isSet(object.skipDeviceReadinessCheck)
        ? globalThis.Boolean(object.skipDeviceReadinessCheck)
        : false,
      setFabricDesigns: globalThis.Array.isArray(object?.setFabricDesigns)
        ? object.setFabricDesigns.map((e: any) => FabricDesign.fromJSON(e))
        : [],
      deleteFabricDesigns: globalThis.Array.isArray(object?.deleteFabricDesigns)
        ? object.deleteFabricDesigns.map((e: any) => globalThis.String(e))
        : [],
      delFabricDesignObjects: globalThis.Array.isArray(object?.delFabricDesignObjects)
        ? object.delFabricDesignObjects.map((e: any) => DeleteFabricDesignObjects.fromJSON(e))
        : [],
      setFabricDesignObjects: globalThis.Array.isArray(object?.setFabricDesignObjects)
        ? object.setFabricDesignObjects.map((e: any) => SetFabricDesignObjects.fromJSON(e))
        : [],
      setServerMgmtPorts: globalThis.Array.isArray(object?.setServerMgmtPorts)
        ? object.setServerMgmtPorts.map((e: any) => ServerMgmtPort.fromJSON(e))
        : [],
      delInventories: globalThis.Array.isArray(object?.delInventories)
        ? object.delInventories.map((e: any) => globalThis.String(e))
        : [],
      setDashboardFolders: globalThis.Array.isArray(object?.setDashboardFolders)
        ? object.setDashboardFolders.map((e: any) => DashboardFolder.fromJSON(e))
        : [],
      delDashboardFolders: globalThis.Array.isArray(object?.delDashboardFolders)
        ? object.delDashboardFolders.map((e: any) => globalThis.String(e))
        : [],
      setDashboards: globalThis.Array.isArray(object?.setDashboards)
        ? object.setDashboards.map((e: any) => Dashboard.fromJSON(e))
        : [],
      delDashboards: globalThis.Array.isArray(object?.delDashboards)
        ? object.delDashboards.map((e: any) => globalThis.String(e))
        : [],
      setDashboardPanels: globalThis.Array.isArray(object?.setDashboardPanels)
        ? object.setDashboardPanels.map((e: any) => Panel.fromJSON(e))
        : [],
      delDashboardPanels: globalThis.Array.isArray(object?.delDashboardPanels)
        ? object.delDashboardPanels.map((e: any) => globalThis.String(e))
        : [],
      setResourceReservations: globalThis.Array.isArray(object?.setResourceReservations)
        ? object.setResourceReservations.map((e: any) => ResourceReservation.fromJSON(e))
        : [],
      delResourceReservations: globalThis.Array.isArray(object?.delResourceReservations)
        ? object.delResourceReservations.map((e: any) => globalThis.String(e))
        : [],
      restoreFabric: isSet(object.restoreFabric) ? globalThis.String(object.restoreFabric) : "",
    };
  },

  toJSON(message: ProvisionFabrics): unknown {
    const obj: any = {};
    if (message.setFabrics?.length) {
      obj.setFabrics = message.setFabrics.map((e) => Fabric.toJSON(e));
    }
    if (message.delFabrics?.length) {
      obj.delFabrics = message.delFabrics;
    }
    if (message.setConnections?.length) {
      obj.setConnections = message.setConnections.map((e) => PortConnection.toJSON(e));
    }
    if (message.delConnections?.length) {
      obj.delConnections = message.delConnections;
    }
    if (message.setPortBreakouts?.length) {
      obj.setPortBreakouts = message.setPortBreakouts.map((e) => PortBreakout.toJSON(e));
    }
    if (message.delPortBreakouts?.length) {
      obj.delPortBreakouts = message.delPortBreakouts;
    }
    if (message.setNodes?.length) {
      obj.setNodes = message.setNodes.map((e) => Node.toJSON(e));
    }
    if (message.delNodes?.length) {
      obj.delNodes = message.delNodes;
    }
    if (message.bindDevices?.length) {
      obj.bindDevices = message.bindDevices.map((e) => BindDevice.toJSON(e));
    }
    if (message.unbindDevices?.length) {
      obj.unbindDevices = message.unbindDevices;
    }
    if (message.setPerVlanStps?.length) {
      obj.setPerVlanStps = message.setPerVlanStps.map((e) => PerVlanStp.toJSON(e));
    }
    if (message.setMultisites?.length) {
      obj.setMultisites = message.setMultisites.map((e) => FabricMultisite.toJSON(e));
    }
    if (message.delMultisites?.length) {
      obj.delMultisites = message.delMultisites;
    }
    if (message.setNetworkPorts?.length) {
      obj.setNetworkPorts = message.setNetworkPorts.map((e) => NetworkPort.toJSON(e));
    }
    if (message.resetNetworkPorts?.length) {
      obj.resetNetworkPorts = message.resetNetworkPorts;
    }
    if (message.setFabricSwConf?.length) {
      obj.setFabricSwConf = message.setFabricSwConf.map((e) => FabricSoftwareConfig.toJSON(e));
    }
    if (message.delFabricSwConf?.length) {
      obj.delFabricSwConf = message.delFabricSwConf.map((e) => FabricSoftwareConfig.toJSON(e));
    }
    if (message.skipDeviceReadinessCheck !== false) {
      obj.skipDeviceReadinessCheck = message.skipDeviceReadinessCheck;
    }
    if (message.setFabricDesigns?.length) {
      obj.setFabricDesigns = message.setFabricDesigns.map((e) => FabricDesign.toJSON(e));
    }
    if (message.deleteFabricDesigns?.length) {
      obj.deleteFabricDesigns = message.deleteFabricDesigns;
    }
    if (message.delFabricDesignObjects?.length) {
      obj.delFabricDesignObjects = message.delFabricDesignObjects.map((e) => DeleteFabricDesignObjects.toJSON(e));
    }
    if (message.setFabricDesignObjects?.length) {
      obj.setFabricDesignObjects = message.setFabricDesignObjects.map((e) => SetFabricDesignObjects.toJSON(e));
    }
    if (message.setServerMgmtPorts?.length) {
      obj.setServerMgmtPorts = message.setServerMgmtPorts.map((e) => ServerMgmtPort.toJSON(e));
    }
    if (message.delInventories?.length) {
      obj.delInventories = message.delInventories;
    }
    if (message.setDashboardFolders?.length) {
      obj.setDashboardFolders = message.setDashboardFolders.map((e) => DashboardFolder.toJSON(e));
    }
    if (message.delDashboardFolders?.length) {
      obj.delDashboardFolders = message.delDashboardFolders;
    }
    if (message.setDashboards?.length) {
      obj.setDashboards = message.setDashboards.map((e) => Dashboard.toJSON(e));
    }
    if (message.delDashboards?.length) {
      obj.delDashboards = message.delDashboards;
    }
    if (message.setDashboardPanels?.length) {
      obj.setDashboardPanels = message.setDashboardPanels.map((e) => Panel.toJSON(e));
    }
    if (message.delDashboardPanels?.length) {
      obj.delDashboardPanels = message.delDashboardPanels;
    }
    if (message.setResourceReservations?.length) {
      obj.setResourceReservations = message.setResourceReservations.map((e) => ResourceReservation.toJSON(e));
    }
    if (message.delResourceReservations?.length) {
      obj.delResourceReservations = message.delResourceReservations;
    }
    if (message.restoreFabric !== "") {
      obj.restoreFabric = message.restoreFabric;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionFabrics>, I>>(base?: I): ProvisionFabrics {
    return ProvisionFabrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionFabrics>, I>>(object: I): ProvisionFabrics {
    const message = createBaseProvisionFabrics();
    message.setFabrics = object.setFabrics?.map((e) => Fabric.fromPartial(e)) || [];
    message.delFabrics = object.delFabrics?.map((e) => e) || [];
    message.setConnections = object.setConnections?.map((e) => PortConnection.fromPartial(e)) || [];
    message.delConnections = object.delConnections?.map((e) => e) || [];
    message.setPortBreakouts = object.setPortBreakouts?.map((e) => PortBreakout.fromPartial(e)) || [];
    message.delPortBreakouts = object.delPortBreakouts?.map((e) => e) || [];
    message.setNodes = object.setNodes?.map((e) => Node.fromPartial(e)) || [];
    message.delNodes = object.delNodes?.map((e) => e) || [];
    message.bindDevices = object.bindDevices?.map((e) => BindDevice.fromPartial(e)) || [];
    message.unbindDevices = object.unbindDevices?.map((e) => e) || [];
    message.setPerVlanStps = object.setPerVlanStps?.map((e) => PerVlanStp.fromPartial(e)) || [];
    message.setMultisites = object.setMultisites?.map((e) => FabricMultisite.fromPartial(e)) || [];
    message.delMultisites = object.delMultisites?.map((e) => e) || [];
    message.setNetworkPorts = object.setNetworkPorts?.map((e) => NetworkPort.fromPartial(e)) || [];
    message.resetNetworkPorts = object.resetNetworkPorts?.map((e) => e) || [];
    message.setFabricSwConf = object.setFabricSwConf?.map((e) => FabricSoftwareConfig.fromPartial(e)) || [];
    message.delFabricSwConf = object.delFabricSwConf?.map((e) => FabricSoftwareConfig.fromPartial(e)) || [];
    message.skipDeviceReadinessCheck = object.skipDeviceReadinessCheck ?? false;
    message.setFabricDesigns = object.setFabricDesigns?.map((e) => FabricDesign.fromPartial(e)) || [];
    message.deleteFabricDesigns = object.deleteFabricDesigns?.map((e) => e) || [];
    message.delFabricDesignObjects =
      object.delFabricDesignObjects?.map((e) => DeleteFabricDesignObjects.fromPartial(e)) || [];
    message.setFabricDesignObjects = object.setFabricDesignObjects?.map((e) => SetFabricDesignObjects.fromPartial(e)) ||
      [];
    message.setServerMgmtPorts = object.setServerMgmtPorts?.map((e) => ServerMgmtPort.fromPartial(e)) || [];
    message.delInventories = object.delInventories?.map((e) => e) || [];
    message.setDashboardFolders = object.setDashboardFolders?.map((e) => DashboardFolder.fromPartial(e)) || [];
    message.delDashboardFolders = object.delDashboardFolders?.map((e) => e) || [];
    message.setDashboards = object.setDashboards?.map((e) => Dashboard.fromPartial(e)) || [];
    message.delDashboards = object.delDashboards?.map((e) => e) || [];
    message.setDashboardPanels = object.setDashboardPanels?.map((e) => Panel.fromPartial(e)) || [];
    message.delDashboardPanels = object.delDashboardPanels?.map((e) => e) || [];
    message.setResourceReservations = object.setResourceReservations?.map((e) => ResourceReservation.fromPartial(e)) ||
      [];
    message.delResourceReservations = object.delResourceReservations?.map((e) => e) || [];
    message.restoreFabric = object.restoreFabric ?? "";
    return message;
  },
};

function createBaseDeleteFabricDesignObjects(): DeleteFabricDesignObjects {
  return {
    DeleteTiers: [],
    DeleteSwitchGroups: [],
    DeleteServerGroups: [],
    DeleteRailGroups: [],
    DeleteRails: [],
    DeleteHwSets: [],
    DelSwitchGrpConnRules: [],
    DelServerGrpConnRules: [],
    DelNodePortConnRules: [],
    DelNodePortOverRules: [],
  };
}

export const DeleteFabricDesignObjects: MessageFns<DeleteFabricDesignObjects> = {
  encode(message: DeleteFabricDesignObjects, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.DeleteTiers) {
      Tier.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.DeleteSwitchGroups) {
      SwitchGroup.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.DeleteServerGroups) {
      ServerGroup.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.DeleteRailGroups) {
      RailGroup.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.DeleteRails) {
      Rail.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.DeleteHwSets) {
      HwSet.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.DelSwitchGrpConnRules) {
      SwitchGroupConnectivityRule.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.DelServerGrpConnRules) {
      ServerGroupConnectivityRule.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.DelNodePortConnRules) {
      NodePortConnectivityRule.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.DelNodePortOverRules) {
      NodePortOverrideRule.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricDesignObjects {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricDesignObjects();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.DeleteTiers.push(Tier.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.DeleteSwitchGroups.push(SwitchGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.DeleteServerGroups.push(ServerGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.DeleteRailGroups.push(RailGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.DeleteRails.push(Rail.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.DeleteHwSets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.DelSwitchGrpConnRules.push(SwitchGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DelServerGrpConnRules.push(ServerGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DelNodePortConnRules.push(NodePortConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.DelNodePortOverRules.push(NodePortOverrideRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricDesignObjects {
    return {
      DeleteTiers: globalThis.Array.isArray(object?.DeleteTiers)
        ? object.DeleteTiers.map((e: any) => Tier.fromJSON(e))
        : [],
      DeleteSwitchGroups: globalThis.Array.isArray(object?.DeleteSwitchGroups)
        ? object.DeleteSwitchGroups.map((e: any) => SwitchGroup.fromJSON(e))
        : [],
      DeleteServerGroups: globalThis.Array.isArray(object?.DeleteServerGroups)
        ? object.DeleteServerGroups.map((e: any) => ServerGroup.fromJSON(e))
        : [],
      DeleteRailGroups: globalThis.Array.isArray(object?.DeleteRailGroups)
        ? object.DeleteRailGroups.map((e: any) => RailGroup.fromJSON(e))
        : [],
      DeleteRails: globalThis.Array.isArray(object?.DeleteRails)
        ? object.DeleteRails.map((e: any) => Rail.fromJSON(e))
        : [],
      DeleteHwSets: globalThis.Array.isArray(object?.DeleteHwSets)
        ? object.DeleteHwSets.map((e: any) => HwSet.fromJSON(e))
        : [],
      DelSwitchGrpConnRules: globalThis.Array.isArray(object?.DelSwitchGrpConnRules)
        ? object.DelSwitchGrpConnRules.map((e: any) => SwitchGroupConnectivityRule.fromJSON(e))
        : [],
      DelServerGrpConnRules: globalThis.Array.isArray(object?.DelServerGrpConnRules)
        ? object.DelServerGrpConnRules.map((e: any) => ServerGroupConnectivityRule.fromJSON(e))
        : [],
      DelNodePortConnRules: globalThis.Array.isArray(object?.DelNodePortConnRules)
        ? object.DelNodePortConnRules.map((e: any) => NodePortConnectivityRule.fromJSON(e))
        : [],
      DelNodePortOverRules: globalThis.Array.isArray(object?.DelNodePortOverRules)
        ? object.DelNodePortOverRules.map((e: any) => NodePortOverrideRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DeleteFabricDesignObjects): unknown {
    const obj: any = {};
    if (message.DeleteTiers?.length) {
      obj.DeleteTiers = message.DeleteTiers.map((e) => Tier.toJSON(e));
    }
    if (message.DeleteSwitchGroups?.length) {
      obj.DeleteSwitchGroups = message.DeleteSwitchGroups.map((e) => SwitchGroup.toJSON(e));
    }
    if (message.DeleteServerGroups?.length) {
      obj.DeleteServerGroups = message.DeleteServerGroups.map((e) => ServerGroup.toJSON(e));
    }
    if (message.DeleteRailGroups?.length) {
      obj.DeleteRailGroups = message.DeleteRailGroups.map((e) => RailGroup.toJSON(e));
    }
    if (message.DeleteRails?.length) {
      obj.DeleteRails = message.DeleteRails.map((e) => Rail.toJSON(e));
    }
    if (message.DeleteHwSets?.length) {
      obj.DeleteHwSets = message.DeleteHwSets.map((e) => HwSet.toJSON(e));
    }
    if (message.DelSwitchGrpConnRules?.length) {
      obj.DelSwitchGrpConnRules = message.DelSwitchGrpConnRules.map((e) => SwitchGroupConnectivityRule.toJSON(e));
    }
    if (message.DelServerGrpConnRules?.length) {
      obj.DelServerGrpConnRules = message.DelServerGrpConnRules.map((e) => ServerGroupConnectivityRule.toJSON(e));
    }
    if (message.DelNodePortConnRules?.length) {
      obj.DelNodePortConnRules = message.DelNodePortConnRules.map((e) => NodePortConnectivityRule.toJSON(e));
    }
    if (message.DelNodePortOverRules?.length) {
      obj.DelNodePortOverRules = message.DelNodePortOverRules.map((e) => NodePortOverrideRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricDesignObjects>, I>>(base?: I): DeleteFabricDesignObjects {
    return DeleteFabricDesignObjects.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricDesignObjects>, I>>(object: I): DeleteFabricDesignObjects {
    const message = createBaseDeleteFabricDesignObjects();
    message.DeleteTiers = object.DeleteTiers?.map((e) => Tier.fromPartial(e)) || [];
    message.DeleteSwitchGroups = object.DeleteSwitchGroups?.map((e) => SwitchGroup.fromPartial(e)) || [];
    message.DeleteServerGroups = object.DeleteServerGroups?.map((e) => ServerGroup.fromPartial(e)) || [];
    message.DeleteRailGroups = object.DeleteRailGroups?.map((e) => RailGroup.fromPartial(e)) || [];
    message.DeleteRails = object.DeleteRails?.map((e) => Rail.fromPartial(e)) || [];
    message.DeleteHwSets = object.DeleteHwSets?.map((e) => HwSet.fromPartial(e)) || [];
    message.DelSwitchGrpConnRules =
      object.DelSwitchGrpConnRules?.map((e) => SwitchGroupConnectivityRule.fromPartial(e)) || [];
    message.DelServerGrpConnRules =
      object.DelServerGrpConnRules?.map((e) => ServerGroupConnectivityRule.fromPartial(e)) || [];
    message.DelNodePortConnRules = object.DelNodePortConnRules?.map((e) => NodePortConnectivityRule.fromPartial(e)) ||
      [];
    message.DelNodePortOverRules = object.DelNodePortOverRules?.map((e) => NodePortOverrideRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHwSetWithGroupType(): HwSetWithGroupType {
  return { groupType: 0, hwSet: undefined };
}

export const HwSetWithGroupType: MessageFns<HwSetWithGroupType> = {
  encode(message: HwSetWithGroupType, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupType !== 0) {
      writer.uint32(8).int32(message.groupType);
    }
    if (message.hwSet !== undefined) {
      HwSet.encode(message.hwSet, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HwSetWithGroupType {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHwSetWithGroupType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hwSet = HwSet.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HwSetWithGroupType {
    return {
      groupType: isSet(object.groupType) ? topologyGroupTypeFromJSON(object.groupType) : 0,
      hwSet: isSet(object.hwSet) ? HwSet.fromJSON(object.hwSet) : undefined,
    };
  },

  toJSON(message: HwSetWithGroupType): unknown {
    const obj: any = {};
    if (message.groupType !== 0) {
      obj.groupType = topologyGroupTypeToJSON(message.groupType);
    }
    if (message.hwSet !== undefined) {
      obj.hwSet = HwSet.toJSON(message.hwSet);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HwSetWithGroupType>, I>>(base?: I): HwSetWithGroupType {
    return HwSetWithGroupType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HwSetWithGroupType>, I>>(object: I): HwSetWithGroupType {
    const message = createBaseHwSetWithGroupType();
    message.groupType = object.groupType ?? 0;
    message.hwSet = (object.hwSet !== undefined && object.hwSet !== null) ? HwSet.fromPartial(object.hwSet) : undefined;
    return message;
  },
};

function createBaseSetFabricDesignObjects(): SetFabricDesignObjects {
  return {
    SetTiers: [],
    SetSwitchGroups: [],
    SetServerGroups: [],
    SetRailGroups: [],
    SetHwSets: [],
    SetSwitchGrpConnRules: [],
    SetServerGrpConnRules: [],
    SetNodePortConnRules: [],
    SetNodePortOverRules: [],
  };
}

export const SetFabricDesignObjects: MessageFns<SetFabricDesignObjects> = {
  encode(message: SetFabricDesignObjects, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.SetTiers) {
      Tier.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.SetSwitchGroups) {
      SwitchGroup.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.SetServerGroups) {
      ServerGroup.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.SetRailGroups) {
      RailGroup.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.SetHwSets) {
      HwSetWithGroupType.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.SetSwitchGrpConnRules) {
      SwitchGroupConnectivityRule.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.SetServerGrpConnRules) {
      ServerGroupConnectivityRule.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.SetNodePortConnRules) {
      NodePortConnectivityRule.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.SetNodePortOverRules) {
      NodePortOverrideRule.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetFabricDesignObjects {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFabricDesignObjects();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SetTiers.push(Tier.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.SetSwitchGroups.push(SwitchGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.SetServerGroups.push(ServerGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.SetRailGroups.push(RailGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.SetHwSets.push(HwSetWithGroupType.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.SetSwitchGrpConnRules.push(SwitchGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.SetServerGrpConnRules.push(ServerGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.SetNodePortConnRules.push(NodePortConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.SetNodePortOverRules.push(NodePortOverrideRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetFabricDesignObjects {
    return {
      SetTiers: globalThis.Array.isArray(object?.SetTiers) ? object.SetTiers.map((e: any) => Tier.fromJSON(e)) : [],
      SetSwitchGroups: globalThis.Array.isArray(object?.SetSwitchGroups)
        ? object.SetSwitchGroups.map((e: any) => SwitchGroup.fromJSON(e))
        : [],
      SetServerGroups: globalThis.Array.isArray(object?.SetServerGroups)
        ? object.SetServerGroups.map((e: any) => ServerGroup.fromJSON(e))
        : [],
      SetRailGroups: globalThis.Array.isArray(object?.SetRailGroups)
        ? object.SetRailGroups.map((e: any) => RailGroup.fromJSON(e))
        : [],
      SetHwSets: globalThis.Array.isArray(object?.SetHwSets)
        ? object.SetHwSets.map((e: any) => HwSetWithGroupType.fromJSON(e))
        : [],
      SetSwitchGrpConnRules: globalThis.Array.isArray(object?.SetSwitchGrpConnRules)
        ? object.SetSwitchGrpConnRules.map((e: any) => SwitchGroupConnectivityRule.fromJSON(e))
        : [],
      SetServerGrpConnRules: globalThis.Array.isArray(object?.SetServerGrpConnRules)
        ? object.SetServerGrpConnRules.map((e: any) => ServerGroupConnectivityRule.fromJSON(e))
        : [],
      SetNodePortConnRules: globalThis.Array.isArray(object?.SetNodePortConnRules)
        ? object.SetNodePortConnRules.map((e: any) => NodePortConnectivityRule.fromJSON(e))
        : [],
      SetNodePortOverRules: globalThis.Array.isArray(object?.SetNodePortOverRules)
        ? object.SetNodePortOverRules.map((e: any) => NodePortOverrideRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetFabricDesignObjects): unknown {
    const obj: any = {};
    if (message.SetTiers?.length) {
      obj.SetTiers = message.SetTiers.map((e) => Tier.toJSON(e));
    }
    if (message.SetSwitchGroups?.length) {
      obj.SetSwitchGroups = message.SetSwitchGroups.map((e) => SwitchGroup.toJSON(e));
    }
    if (message.SetServerGroups?.length) {
      obj.SetServerGroups = message.SetServerGroups.map((e) => ServerGroup.toJSON(e));
    }
    if (message.SetRailGroups?.length) {
      obj.SetRailGroups = message.SetRailGroups.map((e) => RailGroup.toJSON(e));
    }
    if (message.SetHwSets?.length) {
      obj.SetHwSets = message.SetHwSets.map((e) => HwSetWithGroupType.toJSON(e));
    }
    if (message.SetSwitchGrpConnRules?.length) {
      obj.SetSwitchGrpConnRules = message.SetSwitchGrpConnRules.map((e) => SwitchGroupConnectivityRule.toJSON(e));
    }
    if (message.SetServerGrpConnRules?.length) {
      obj.SetServerGrpConnRules = message.SetServerGrpConnRules.map((e) => ServerGroupConnectivityRule.toJSON(e));
    }
    if (message.SetNodePortConnRules?.length) {
      obj.SetNodePortConnRules = message.SetNodePortConnRules.map((e) => NodePortConnectivityRule.toJSON(e));
    }
    if (message.SetNodePortOverRules?.length) {
      obj.SetNodePortOverRules = message.SetNodePortOverRules.map((e) => NodePortOverrideRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFabricDesignObjects>, I>>(base?: I): SetFabricDesignObjects {
    return SetFabricDesignObjects.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFabricDesignObjects>, I>>(object: I): SetFabricDesignObjects {
    const message = createBaseSetFabricDesignObjects();
    message.SetTiers = object.SetTiers?.map((e) => Tier.fromPartial(e)) || [];
    message.SetSwitchGroups = object.SetSwitchGroups?.map((e) => SwitchGroup.fromPartial(e)) || [];
    message.SetServerGroups = object.SetServerGroups?.map((e) => ServerGroup.fromPartial(e)) || [];
    message.SetRailGroups = object.SetRailGroups?.map((e) => RailGroup.fromPartial(e)) || [];
    message.SetHwSets = object.SetHwSets?.map((e) => HwSetWithGroupType.fromPartial(e)) || [];
    message.SetSwitchGrpConnRules =
      object.SetSwitchGrpConnRules?.map((e) => SwitchGroupConnectivityRule.fromPartial(e)) || [];
    message.SetServerGrpConnRules =
      object.SetServerGrpConnRules?.map((e) => ServerGroupConnectivityRule.fromPartial(e)) || [];
    message.SetNodePortConnRules = object.SetNodePortConnRules?.map((e) => NodePortConnectivityRule.fromPartial(e)) ||
      [];
    message.SetNodePortOverRules = object.SetNodePortOverRules?.map((e) => NodePortOverrideRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProvisionRequest(): ProvisionRequest {
  return {
    dryRun: false,
    fabricId: "",
    candidate: "",
    comments: "",
    revisionId: "0",
    runCabling: false,
    commitId: "0",
    settings: undefined,
    fabrics: undefined,
    tenants: undefined,
  };
}

export const ProvisionRequest: MessageFns<ProvisionRequest> = {
  encode(message: ProvisionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dryRun !== false) {
      writer.uint32(8).bool(message.dryRun);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    if (message.comments !== "") {
      writer.uint32(34).string(message.comments);
    }
    if (message.revisionId !== "0") {
      writer.uint32(64).int64(message.revisionId);
    }
    if (message.runCabling !== false) {
      writer.uint32(72).bool(message.runCabling);
    }
    if (message.commitId !== "0") {
      writer.uint32(80).int64(message.commitId);
    }
    if (message.settings !== undefined) {
      ProvisionSettings.encode(message.settings, writer.uint32(42).fork()).join();
    }
    if (message.fabrics !== undefined) {
      ProvisionFabrics.encode(message.fabrics, writer.uint32(50).fork()).join();
    }
    if (message.tenants !== undefined) {
      ProvisionTenants.encode(message.tenants, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.runCabling = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.settings = ProvisionSettings.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabrics = ProvisionFabrics.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tenants = ProvisionTenants.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionRequest {
    return {
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      runCabling: isSet(object.runCabling) ? globalThis.Boolean(object.runCabling) : false,
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      settings: isSet(object.settings) ? ProvisionSettings.fromJSON(object.settings) : undefined,
      fabrics: isSet(object.fabrics) ? ProvisionFabrics.fromJSON(object.fabrics) : undefined,
      tenants: isSet(object.tenants) ? ProvisionTenants.fromJSON(object.tenants) : undefined,
    };
  },

  toJSON(message: ProvisionRequest): unknown {
    const obj: any = {};
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.runCabling !== false) {
      obj.runCabling = message.runCabling;
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.settings !== undefined) {
      obj.settings = ProvisionSettings.toJSON(message.settings);
    }
    if (message.fabrics !== undefined) {
      obj.fabrics = ProvisionFabrics.toJSON(message.fabrics);
    }
    if (message.tenants !== undefined) {
      obj.tenants = ProvisionTenants.toJSON(message.tenants);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionRequest>, I>>(base?: I): ProvisionRequest {
    return ProvisionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionRequest>, I>>(object: I): ProvisionRequest {
    const message = createBaseProvisionRequest();
    message.dryRun = object.dryRun ?? false;
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.comments = object.comments ?? "";
    message.revisionId = object.revisionId ?? "0";
    message.runCabling = object.runCabling ?? false;
    message.commitId = object.commitId ?? "0";
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProvisionSettings.fromPartial(object.settings)
      : undefined;
    message.fabrics = (object.fabrics !== undefined && object.fabrics !== null)
      ? ProvisionFabrics.fromPartial(object.fabrics)
      : undefined;
    message.tenants = (object.tenants !== undefined && object.tenants !== null)
      ? ProvisionTenants.fromPartial(object.tenants)
      : undefined;
    return message;
  },
};

function createBaseProvisionResponse(): ProvisionResponse {
  return { dryRun: false, settings: undefined, fabrics: undefined, tenants: undefined };
}

export const ProvisionResponse: MessageFns<ProvisionResponse> = {
  encode(message: ProvisionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dryRun !== false) {
      writer.uint32(8).bool(message.dryRun);
    }
    if (message.settings !== undefined) {
      ProvisionSettings.encode(message.settings, writer.uint32(18).fork()).join();
    }
    if (message.fabrics !== undefined) {
      ProvisionFabrics.encode(message.fabrics, writer.uint32(26).fork()).join();
    }
    if (message.tenants !== undefined) {
      ProvisionTenants.encode(message.tenants, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = ProvisionSettings.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabrics = ProvisionFabrics.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tenants = ProvisionTenants.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionResponse {
    return {
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      settings: isSet(object.settings) ? ProvisionSettings.fromJSON(object.settings) : undefined,
      fabrics: isSet(object.fabrics) ? ProvisionFabrics.fromJSON(object.fabrics) : undefined,
      tenants: isSet(object.tenants) ? ProvisionTenants.fromJSON(object.tenants) : undefined,
    };
  },

  toJSON(message: ProvisionResponse): unknown {
    const obj: any = {};
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.settings !== undefined) {
      obj.settings = ProvisionSettings.toJSON(message.settings);
    }
    if (message.fabrics !== undefined) {
      obj.fabrics = ProvisionFabrics.toJSON(message.fabrics);
    }
    if (message.tenants !== undefined) {
      obj.tenants = ProvisionTenants.toJSON(message.tenants);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionResponse>, I>>(base?: I): ProvisionResponse {
    return ProvisionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionResponse>, I>>(object: I): ProvisionResponse {
    const message = createBaseProvisionResponse();
    message.dryRun = object.dryRun ?? false;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProvisionSettings.fromPartial(object.settings)
      : undefined;
    message.fabrics = (object.fabrics !== undefined && object.fabrics !== null)
      ? ProvisionFabrics.fromPartial(object.fabrics)
      : undefined;
    message.tenants = (object.tenants !== undefined && object.tenants !== null)
      ? ProvisionTenants.fromPartial(object.tenants)
      : undefined;
    return message;
  },
};

function createBaseProvisionSettingsRequest(): ProvisionSettingsRequest {
  return { dryRun: false, settings: undefined };
}

export const ProvisionSettingsRequest: MessageFns<ProvisionSettingsRequest> = {
  encode(message: ProvisionSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dryRun !== false) {
      writer.uint32(8).bool(message.dryRun);
    }
    if (message.settings !== undefined) {
      ProvisionSettings.encode(message.settings, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = ProvisionSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionSettingsRequest {
    return {
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      settings: isSet(object.settings) ? ProvisionSettings.fromJSON(object.settings) : undefined,
    };
  },

  toJSON(message: ProvisionSettingsRequest): unknown {
    const obj: any = {};
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.settings !== undefined) {
      obj.settings = ProvisionSettings.toJSON(message.settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionSettingsRequest>, I>>(base?: I): ProvisionSettingsRequest {
    return ProvisionSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionSettingsRequest>, I>>(object: I): ProvisionSettingsRequest {
    const message = createBaseProvisionSettingsRequest();
    message.dryRun = object.dryRun ?? false;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProvisionSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseProvisionSettingsResponse(): ProvisionSettingsResponse {
  return { dryRun: false, settings: undefined };
}

export const ProvisionSettingsResponse: MessageFns<ProvisionSettingsResponse> = {
  encode(message: ProvisionSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dryRun !== false) {
      writer.uint32(8).bool(message.dryRun);
    }
    if (message.settings !== undefined) {
      ProvisionSettings.encode(message.settings, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = ProvisionSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionSettingsResponse {
    return {
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      settings: isSet(object.settings) ? ProvisionSettings.fromJSON(object.settings) : undefined,
    };
  },

  toJSON(message: ProvisionSettingsResponse): unknown {
    const obj: any = {};
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.settings !== undefined) {
      obj.settings = ProvisionSettings.toJSON(message.settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProvisionSettingsResponse>, I>>(base?: I): ProvisionSettingsResponse {
    return ProvisionSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProvisionSettingsResponse>, I>>(object: I): ProvisionSettingsResponse {
    const message = createBaseProvisionSettingsResponse();
    message.dryRun = object.dryRun ?? false;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProvisionSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseGetFabricsFilters(): GetFabricsFilters {
  return {
    partialMatch: false,
    loadChildren: false,
    candidate: "",
    loadDesign: false,
    fabricIds: [],
    names: [],
    labels: [],
    nodeIds: [],
    isParkingLot: false,
    modifiedStart: undefined,
    modifiedEnd: undefined,
    modifiedUsers: [],
  };
}

export const GetFabricsFilters: MessageFns<GetFabricsFilters> = {
  encode(message: GetFabricsFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.partialMatch !== false) {
      writer.uint32(8).bool(message.partialMatch);
    }
    if (message.loadChildren !== false) {
      writer.uint32(16).bool(message.loadChildren);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    if (message.loadDesign !== false) {
      writer.uint32(32).bool(message.loadDesign);
    }
    for (const v of message.fabricIds) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.labels) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.nodeIds) {
      writer.uint32(66).string(v!);
    }
    if (message.isParkingLot !== false) {
      writer.uint32(72).bool(message.isParkingLot);
    }
    if (message.modifiedStart !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedStart), writer.uint32(82).fork()).join();
    }
    if (message.modifiedEnd !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedEnd), writer.uint32(90).fork()).join();
    }
    for (const v of message.modifiedUsers) {
      writer.uint32(98).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricsFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricsFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.partialMatch = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.loadChildren = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.loadDesign = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isParkingLot = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.modifiedStart = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.modifiedEnd = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.modifiedUsers.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricsFilters {
    return {
      partialMatch: isSet(object.partialMatch) ? globalThis.Boolean(object.partialMatch) : false,
      loadChildren: isSet(object.loadChildren) ? globalThis.Boolean(object.loadChildren) : false,
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      loadDesign: isSet(object.loadDesign) ? globalThis.Boolean(object.loadDesign) : false,
      fabricIds: globalThis.Array.isArray(object?.fabricIds)
        ? object.fabricIds.map((e: any) => globalThis.String(e))
        : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      isParkingLot: isSet(object.isParkingLot) ? globalThis.Boolean(object.isParkingLot) : false,
      modifiedStart: isSet(object.modifiedStart) ? fromJsonTimestamp(object.modifiedStart) : undefined,
      modifiedEnd: isSet(object.modifiedEnd) ? fromJsonTimestamp(object.modifiedEnd) : undefined,
      modifiedUsers: globalThis.Array.isArray(object?.modifiedUsers)
        ? object.modifiedUsers.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetFabricsFilters): unknown {
    const obj: any = {};
    if (message.partialMatch !== false) {
      obj.partialMatch = message.partialMatch;
    }
    if (message.loadChildren !== false) {
      obj.loadChildren = message.loadChildren;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.loadDesign !== false) {
      obj.loadDesign = message.loadDesign;
    }
    if (message.fabricIds?.length) {
      obj.fabricIds = message.fabricIds;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.isParkingLot !== false) {
      obj.isParkingLot = message.isParkingLot;
    }
    if (message.modifiedStart !== undefined) {
      obj.modifiedStart = message.modifiedStart.toISOString();
    }
    if (message.modifiedEnd !== undefined) {
      obj.modifiedEnd = message.modifiedEnd.toISOString();
    }
    if (message.modifiedUsers?.length) {
      obj.modifiedUsers = message.modifiedUsers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricsFilters>, I>>(base?: I): GetFabricsFilters {
    return GetFabricsFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricsFilters>, I>>(object: I): GetFabricsFilters {
    const message = createBaseGetFabricsFilters();
    message.partialMatch = object.partialMatch ?? false;
    message.loadChildren = object.loadChildren ?? false;
    message.candidate = object.candidate ?? "";
    message.loadDesign = object.loadDesign ?? false;
    message.fabricIds = object.fabricIds?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.labels = object.labels?.map((e) => e) || [];
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.isParkingLot = object.isParkingLot ?? false;
    message.modifiedStart = object.modifiedStart ?? undefined;
    message.modifiedEnd = object.modifiedEnd ?? undefined;
    message.modifiedUsers = object.modifiedUsers?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetFabricsRequest(): GetFabricsRequest {
  return { filters: undefined, pagination: undefined };
}

export const GetFabricsRequest: MessageFns<GetFabricsRequest> = {
  encode(message: GetFabricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      GetFabricsFilters.encode(message.filters, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = GetFabricsFilters.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricsRequest {
    return {
      filters: isSet(object.filters) ? GetFabricsFilters.fromJSON(object.filters) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetFabricsRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = GetFabricsFilters.toJSON(message.filters);
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricsRequest>, I>>(base?: I): GetFabricsRequest {
    return GetFabricsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricsRequest>, I>>(object: I): GetFabricsRequest {
    const message = createBaseGetFabricsRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? GetFabricsFilters.fromPartial(object.filters)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetFabricsResponse(): GetFabricsResponse {
  return { fabrics: [], candidate: "", pagination: undefined };
}

export const GetFabricsResponse: MessageFns<GetFabricsResponse> = {
  encode(message: GetFabricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabrics) {
      Fabric.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabrics.push(Fabric.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricsResponse {
    return {
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => Fabric.fromJSON(e)) : [],
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetFabricsResponse): unknown {
    const obj: any = {};
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => Fabric.toJSON(e));
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricsResponse>, I>>(base?: I): GetFabricsResponse {
    return GetFabricsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricsResponse>, I>>(object: I): GetFabricsResponse {
    const message = createBaseGetFabricsResponse();
    message.fabrics = object.fabrics?.map((e) => Fabric.fromPartial(e)) || [];
    message.candidate = object.candidate ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetFabricDesignRequest(): GetFabricDesignRequest {
  return { candidate: "", fabricId: "" };
}

export const GetFabricDesignRequest: MessageFns<GetFabricDesignRequest> = {
  encode(message: GetFabricDesignRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricDesignRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricDesignRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricDesignRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: GetFabricDesignRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricDesignRequest>, I>>(base?: I): GetFabricDesignRequest {
    return GetFabricDesignRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricDesignRequest>, I>>(object: I): GetFabricDesignRequest {
    const message = createBaseGetFabricDesignRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetFabricDesignResponse(): GetFabricDesignResponse {
  return { design: undefined, candidate: "" };
}

export const GetFabricDesignResponse: MessageFns<GetFabricDesignResponse> = {
  encode(message: GetFabricDesignResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(10).fork()).join();
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricDesignResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricDesignResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricDesignResponse {
    return {
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetFabricDesignResponse): unknown {
    const obj: any = {};
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricDesignResponse>, I>>(base?: I): GetFabricDesignResponse {
    return GetFabricDesignResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricDesignResponse>, I>>(object: I): GetFabricDesignResponse {
    const message = createBaseGetFabricDesignResponse();
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetNodesFilters(): GetNodesFilters {
  return {
    partialMatch: false,
    loadChildren: false,
    candidate: "",
    fabricId: "",
    nodeIds: [],
    names: [],
    labels: [],
    roles: [],
    serialNumbers: [],
    modelNames: [],
    deviceIds: [],
  };
}

export const GetNodesFilters: MessageFns<GetNodesFilters> = {
  encode(message: GetNodesFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.partialMatch !== false) {
      writer.uint32(8).bool(message.partialMatch);
    }
    if (message.loadChildren !== false) {
      writer.uint32(16).bool(message.loadChildren);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    for (const v of message.nodeIds) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.labels) {
      writer.uint32(58).string(v!);
    }
    writer.uint32(66).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.serialNumbers) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.modelNames) {
      writer.uint32(90).string(v!);
    }
    for (const v of message.deviceIds) {
      writer.uint32(98).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodesFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodesFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.partialMatch = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.loadChildren = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.serialNumbers.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.modelNames.push(reader.string());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.deviceIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodesFilters {
    return {
      partialMatch: isSet(object.partialMatch) ? globalThis.Boolean(object.partialMatch) : false,
      loadChildren: isSet(object.loadChildren) ? globalThis.Boolean(object.loadChildren) : false,
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => nodeRoleFromJSON(e)) : [],
      serialNumbers: globalThis.Array.isArray(object?.serialNumbers)
        ? object.serialNumbers.map((e: any) => globalThis.String(e))
        : [],
      modelNames: globalThis.Array.isArray(object?.modelNames)
        ? object.modelNames.map((e: any) => globalThis.String(e))
        : [],
      deviceIds: globalThis.Array.isArray(object?.deviceIds)
        ? object.deviceIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetNodesFilters): unknown {
    const obj: any = {};
    if (message.partialMatch !== false) {
      obj.partialMatch = message.partialMatch;
    }
    if (message.loadChildren !== false) {
      obj.loadChildren = message.loadChildren;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => nodeRoleToJSON(e));
    }
    if (message.serialNumbers?.length) {
      obj.serialNumbers = message.serialNumbers;
    }
    if (message.modelNames?.length) {
      obj.modelNames = message.modelNames;
    }
    if (message.deviceIds?.length) {
      obj.deviceIds = message.deviceIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodesFilters>, I>>(base?: I): GetNodesFilters {
    return GetNodesFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodesFilters>, I>>(object: I): GetNodesFilters {
    const message = createBaseGetNodesFilters();
    message.partialMatch = object.partialMatch ?? false;
    message.loadChildren = object.loadChildren ?? false;
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.labels = object.labels?.map((e) => e) || [];
    message.roles = object.roles?.map((e) => e) || [];
    message.serialNumbers = object.serialNumbers?.map((e) => e) || [];
    message.modelNames = object.modelNames?.map((e) => e) || [];
    message.deviceIds = object.deviceIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetNodesRequest(): GetNodesRequest {
  return { filters: undefined, pagination: undefined };
}

export const GetNodesRequest: MessageFns<GetNodesRequest> = {
  encode(message: GetNodesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      GetNodesFilters.encode(message.filters, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = GetNodesFilters.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodesRequest {
    return {
      filters: isSet(object.filters) ? GetNodesFilters.fromJSON(object.filters) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetNodesRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = GetNodesFilters.toJSON(message.filters);
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodesRequest>, I>>(base?: I): GetNodesRequest {
    return GetNodesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodesRequest>, I>>(object: I): GetNodesRequest {
    const message = createBaseGetNodesRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? GetNodesFilters.fromPartial(object.filters)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetNodesResponse(): GetNodesResponse {
  return { nodes: [], candidate: "", pagination: undefined };
}

export const GetNodesResponse: MessageFns<GetNodesResponse> = {
  encode(message: GetNodesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodes) {
      Node.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodesResponse {
    return {
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => Node.fromJSON(e)) : [],
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetNodesResponse): unknown {
    const obj: any = {};
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => Node.toJSON(e));
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodesResponse>, I>>(base?: I): GetNodesResponse {
    return GetNodesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodesResponse>, I>>(object: I): GetNodesResponse {
    const message = createBaseGetNodesResponse();
    message.nodes = object.nodes?.map((e) => Node.fromPartial(e)) || [];
    message.candidate = object.candidate ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetNodesPortsRequest(): GetNodesPortsRequest {
  return { candidate: "", fabricId: "", nodeIds: [], ports: [] };
}

export const GetNodesPortsRequest: MessageFns<GetNodesPortsRequest> = {
  encode(message: GetNodesPortsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.nodeIds) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.ports) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodesPortsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodesPortsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ports.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodesPortsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetNodesPortsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.ports?.length) {
      obj.ports = message.ports;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodesPortsRequest>, I>>(base?: I): GetNodesPortsRequest {
    return GetNodesPortsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodesPortsRequest>, I>>(object: I): GetNodesPortsRequest {
    const message = createBaseGetNodesPortsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.ports = object.ports?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetNodesPortsResponse(): GetNodesPortsResponse {
  return { nodes: [] };
}

export const GetNodesPortsResponse: MessageFns<GetNodesPortsResponse> = {
  encode(message: GetNodesPortsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodes) {
      Node.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodesPortsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodesPortsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodesPortsResponse {
    return { nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => Node.fromJSON(e)) : [] };
  },

  toJSON(message: GetNodesPortsResponse): unknown {
    const obj: any = {};
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => Node.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodesPortsResponse>, I>>(base?: I): GetNodesPortsResponse {
    return GetNodesPortsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodesPortsResponse>, I>>(object: I): GetNodesPortsResponse {
    const message = createBaseGetNodesPortsResponse();
    message.nodes = object.nodes?.map((e) => Node.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPortBreakoutsRequest(): GetPortBreakoutsRequest {
  return { candidate: "", fabricId: "", nodeIds: [], ids: [], names: [] };
}

export const GetPortBreakoutsRequest: MessageFns<GetPortBreakoutsRequest> = {
  encode(message: GetPortBreakoutsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.nodeIds) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPortBreakoutsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPortBreakoutsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPortBreakoutsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetPortBreakoutsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPortBreakoutsRequest>, I>>(base?: I): GetPortBreakoutsRequest {
    return GetPortBreakoutsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPortBreakoutsRequest>, I>>(object: I): GetPortBreakoutsRequest {
    const message = createBaseGetPortBreakoutsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetPortBreakoutsResponse(): GetPortBreakoutsResponse {
  return { breakouts: [] };
}

export const GetPortBreakoutsResponse: MessageFns<GetPortBreakoutsResponse> = {
  encode(message: GetPortBreakoutsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.breakouts) {
      PortBreakout.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPortBreakoutsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPortBreakoutsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.breakouts.push(PortBreakout.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPortBreakoutsResponse {
    return {
      breakouts: globalThis.Array.isArray(object?.breakouts)
        ? object.breakouts.map((e: any) => PortBreakout.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPortBreakoutsResponse): unknown {
    const obj: any = {};
    if (message.breakouts?.length) {
      obj.breakouts = message.breakouts.map((e) => PortBreakout.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPortBreakoutsResponse>, I>>(base?: I): GetPortBreakoutsResponse {
    return GetPortBreakoutsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPortBreakoutsResponse>, I>>(object: I): GetPortBreakoutsResponse {
    const message = createBaseGetPortBreakoutsResponse();
    message.breakouts = object.breakouts?.map((e) => PortBreakout.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTenantObjects(): TenantObjects {
  return {
    id: "",
    name: "",
    enabled: false,
    candidate: "",
    vlans: [],
    vrfs: [],
    portChannels: [],
    vnis: [],
    staticRoutes: [],
    dhcpRelays: [],
    loopbacks: [],
    subInterfaces: [],
    bgpPolicies: [],
    bgpPeers: [],
    ipmConfigs: [],
    dscpConfigs: [],
    packetMirrorings: [],
    ipSlaConfigs: [],
    arsConfigs: [],
  };
}

export const TenantObjects: MessageFns<TenantObjects> = {
  encode(message: TenantObjects, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    if (message.candidate !== "") {
      writer.uint32(34).string(message.candidate);
    }
    for (const v of message.vlans) {
      Vlan.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.vrfs) {
      Vrf.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.portChannels) {
      PortChannel.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.vnis) {
      Vni.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.staticRoutes) {
      StaticRoutes.encode(v!, writer.uint32(114).fork()).join();
    }
    for (const v of message.dhcpRelays) {
      DhcpRelay.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.loopbacks) {
      Loopback.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.subInterfaces) {
      SubInterface.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.bgpPolicies) {
      BgpPolicy.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.bgpPeers) {
      BgpPeer.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.ipmConfigs) {
      IpmConfig.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.dscpConfigs) {
      DscpConfig.encode(v!, writer.uint32(170).fork()).join();
    }
    for (const v of message.packetMirrorings) {
      PacketMirroring.encode(v!, writer.uint32(178).fork()).join();
    }
    for (const v of message.ipSlaConfigs) {
      IpSlaConfig.encode(v!, writer.uint32(186).fork()).join();
    }
    for (const v of message.arsConfigs) {
      ArsConfig.encode(v!, writer.uint32(194).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenantObjects {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTenantObjects();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.vlans.push(Vlan.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.vrfs.push(Vrf.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.portChannels.push(PortChannel.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.vnis.push(Vni.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.staticRoutes.push(StaticRoutes.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.dhcpRelays.push(DhcpRelay.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.loopbacks.push(Loopback.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.subInterfaces.push(SubInterface.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.bgpPolicies.push(BgpPolicy.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.bgpPeers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.ipmConfigs.push(IpmConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.dscpConfigs.push(DscpConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.packetMirrorings.push(PacketMirroring.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.ipSlaConfigs.push(IpSlaConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.arsConfigs.push(ArsConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TenantObjects {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      vlans: globalThis.Array.isArray(object?.vlans) ? object.vlans.map((e: any) => Vlan.fromJSON(e)) : [],
      vrfs: globalThis.Array.isArray(object?.vrfs) ? object.vrfs.map((e: any) => Vrf.fromJSON(e)) : [],
      portChannels: globalThis.Array.isArray(object?.portChannels)
        ? object.portChannels.map((e: any) => PortChannel.fromJSON(e))
        : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => Vni.fromJSON(e)) : [],
      staticRoutes: globalThis.Array.isArray(object?.staticRoutes)
        ? object.staticRoutes.map((e: any) => StaticRoutes.fromJSON(e))
        : [],
      dhcpRelays: globalThis.Array.isArray(object?.dhcpRelays)
        ? object.dhcpRelays.map((e: any) => DhcpRelay.fromJSON(e))
        : [],
      loopbacks: globalThis.Array.isArray(object?.loopbacks)
        ? object.loopbacks.map((e: any) => Loopback.fromJSON(e))
        : [],
      subInterfaces: globalThis.Array.isArray(object?.subInterfaces)
        ? object.subInterfaces.map((e: any) => SubInterface.fromJSON(e))
        : [],
      bgpPolicies: globalThis.Array.isArray(object?.bgpPolicies)
        ? object.bgpPolicies.map((e: any) => BgpPolicy.fromJSON(e))
        : [],
      bgpPeers: globalThis.Array.isArray(object?.bgpPeers)
        ? object.bgpPeers.map((e: any) => BgpPeer.fromJSON(e))
        : [],
      ipmConfigs: globalThis.Array.isArray(object?.ipmConfigs)
        ? object.ipmConfigs.map((e: any) => IpmConfig.fromJSON(e))
        : [],
      dscpConfigs: globalThis.Array.isArray(object?.dscpConfigs)
        ? object.dscpConfigs.map((e: any) => DscpConfig.fromJSON(e))
        : [],
      packetMirrorings: globalThis.Array.isArray(object?.packetMirrorings)
        ? object.packetMirrorings.map((e: any) => PacketMirroring.fromJSON(e))
        : [],
      ipSlaConfigs: globalThis.Array.isArray(object?.ipSlaConfigs)
        ? object.ipSlaConfigs.map((e: any) => IpSlaConfig.fromJSON(e))
        : [],
      arsConfigs: globalThis.Array.isArray(object?.arsConfigs)
        ? object.arsConfigs.map((e: any) => ArsConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TenantObjects): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.vlans?.length) {
      obj.vlans = message.vlans.map((e) => Vlan.toJSON(e));
    }
    if (message.vrfs?.length) {
      obj.vrfs = message.vrfs.map((e) => Vrf.toJSON(e));
    }
    if (message.portChannels?.length) {
      obj.portChannels = message.portChannels.map((e) => PortChannel.toJSON(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => Vni.toJSON(e));
    }
    if (message.staticRoutes?.length) {
      obj.staticRoutes = message.staticRoutes.map((e) => StaticRoutes.toJSON(e));
    }
    if (message.dhcpRelays?.length) {
      obj.dhcpRelays = message.dhcpRelays.map((e) => DhcpRelay.toJSON(e));
    }
    if (message.loopbacks?.length) {
      obj.loopbacks = message.loopbacks.map((e) => Loopback.toJSON(e));
    }
    if (message.subInterfaces?.length) {
      obj.subInterfaces = message.subInterfaces.map((e) => SubInterface.toJSON(e));
    }
    if (message.bgpPolicies?.length) {
      obj.bgpPolicies = message.bgpPolicies.map((e) => BgpPolicy.toJSON(e));
    }
    if (message.bgpPeers?.length) {
      obj.bgpPeers = message.bgpPeers.map((e) => BgpPeer.toJSON(e));
    }
    if (message.ipmConfigs?.length) {
      obj.ipmConfigs = message.ipmConfigs.map((e) => IpmConfig.toJSON(e));
    }
    if (message.dscpConfigs?.length) {
      obj.dscpConfigs = message.dscpConfigs.map((e) => DscpConfig.toJSON(e));
    }
    if (message.packetMirrorings?.length) {
      obj.packetMirrorings = message.packetMirrorings.map((e) => PacketMirroring.toJSON(e));
    }
    if (message.ipSlaConfigs?.length) {
      obj.ipSlaConfigs = message.ipSlaConfigs.map((e) => IpSlaConfig.toJSON(e));
    }
    if (message.arsConfigs?.length) {
      obj.arsConfigs = message.arsConfigs.map((e) => ArsConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TenantObjects>, I>>(base?: I): TenantObjects {
    return TenantObjects.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TenantObjects>, I>>(object: I): TenantObjects {
    const message = createBaseTenantObjects();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.candidate = object.candidate ?? "";
    message.vlans = object.vlans?.map((e) => Vlan.fromPartial(e)) || [];
    message.vrfs = object.vrfs?.map((e) => Vrf.fromPartial(e)) || [];
    message.portChannels = object.portChannels?.map((e) => PortChannel.fromPartial(e)) || [];
    message.vnis = object.vnis?.map((e) => Vni.fromPartial(e)) || [];
    message.staticRoutes = object.staticRoutes?.map((e) => StaticRoutes.fromPartial(e)) || [];
    message.dhcpRelays = object.dhcpRelays?.map((e) => DhcpRelay.fromPartial(e)) || [];
    message.loopbacks = object.loopbacks?.map((e) => Loopback.fromPartial(e)) || [];
    message.subInterfaces = object.subInterfaces?.map((e) => SubInterface.fromPartial(e)) || [];
    message.bgpPolicies = object.bgpPolicies?.map((e) => BgpPolicy.fromPartial(e)) || [];
    message.bgpPeers = object.bgpPeers?.map((e) => BgpPeer.fromPartial(e)) || [];
    message.ipmConfigs = object.ipmConfigs?.map((e) => IpmConfig.fromPartial(e)) || [];
    message.dscpConfigs = object.dscpConfigs?.map((e) => DscpConfig.fromPartial(e)) || [];
    message.packetMirrorings = object.packetMirrorings?.map((e) => PacketMirroring.fromPartial(e)) || [];
    message.ipSlaConfigs = object.ipSlaConfigs?.map((e) => IpSlaConfig.fromPartial(e)) || [];
    message.arsConfigs = object.arsConfigs?.map((e) => ArsConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTenantsObjectsResponse(): TenantsObjectsResponse {
  return { tenants: [] };
}

export const TenantsObjectsResponse: MessageFns<TenantsObjectsResponse> = {
  encode(message: TenantsObjectsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tenants) {
      TenantObjects.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenantsObjectsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTenantsObjectsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenants.push(TenantObjects.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TenantsObjectsResponse {
    return {
      tenants: globalThis.Array.isArray(object?.tenants)
        ? object.tenants.map((e: any) => TenantObjects.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TenantsObjectsResponse): unknown {
    const obj: any = {};
    if (message.tenants?.length) {
      obj.tenants = message.tenants.map((e) => TenantObjects.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TenantsObjectsResponse>, I>>(base?: I): TenantsObjectsResponse {
    return TenantsObjectsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TenantsObjectsResponse>, I>>(object: I): TenantsObjectsResponse {
    const message = createBaseTenantsObjectsResponse();
    message.tenants = object.tenants?.map((e) => TenantObjects.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetVnisRequest(): GetVnisRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], vnis: [], vlanIds: [], l3Only: false };
}

export const GetVnisRequest: MessageFns<GetVnisRequest> = {
  encode(message: GetVnisRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    writer.uint32(42).fork();
    for (const v of message.vnis) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(50).fork();
    for (const v of message.vlanIds) {
      writer.uint32(v);
    }
    writer.join();
    if (message.l3Only !== false) {
      writer.uint32(64).bool(message.l3Only);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVnisRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetVnisRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.vnis.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.vnis.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag === 48) {
            message.vlanIds.push(reader.uint32());

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.vlanIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.l3Only = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetVnisRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => globalThis.Number(e)) : [],
      vlanIds: globalThis.Array.isArray(object?.vlanIds) ? object.vlanIds.map((e: any) => globalThis.Number(e)) : [],
      l3Only: isSet(object.l3Only) ? globalThis.Boolean(object.l3Only) : false,
    };
  },

  toJSON(message: GetVnisRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => Math.round(e));
    }
    if (message.vlanIds?.length) {
      obj.vlanIds = message.vlanIds.map((e) => Math.round(e));
    }
    if (message.l3Only !== false) {
      obj.l3Only = message.l3Only;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetVnisRequest>, I>>(base?: I): GetVnisRequest {
    return GetVnisRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetVnisRequest>, I>>(object: I): GetVnisRequest {
    const message = createBaseGetVnisRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.vnis = object.vnis?.map((e) => e) || [];
    message.vlanIds = object.vlanIds?.map((e) => e) || [];
    message.l3Only = object.l3Only ?? false;
    return message;
  },
};

function createBaseGetMaterializedVniRequest(): GetMaterializedVniRequest {
  return { candidate: "", fabricId: "", vni: 0, nodeId: "" };
}

export const GetMaterializedVniRequest: MessageFns<GetMaterializedVniRequest> = {
  encode(message: GetMaterializedVniRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.vni !== 0) {
      writer.uint32(24).uint32(message.vni);
    }
    if (message.nodeId !== "") {
      writer.uint32(34).string(message.nodeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMaterializedVniRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMaterializedVniRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMaterializedVniRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
    };
  },

  toJSON(message: GetMaterializedVniRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMaterializedVniRequest>, I>>(base?: I): GetMaterializedVniRequest {
    return GetMaterializedVniRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMaterializedVniRequest>, I>>(object: I): GetMaterializedVniRequest {
    const message = createBaseGetMaterializedVniRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.vni = object.vni ?? 0;
    message.nodeId = object.nodeId ?? "";
    return message;
  },
};

function createBaseGetVrfsRequest(): GetVrfsRequest {
  return {
    candidate: "",
    fabricId: "",
    ids: [],
    names: [],
    needIps: false,
    ipv4Addresses: [],
    ipv6Addresses: [],
    supernet: false,
  };
}

export const GetVrfsRequest: MessageFns<GetVrfsRequest> = {
  encode(message: GetVrfsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    if (message.needIps !== false) {
      writer.uint32(40).bool(message.needIps);
    }
    for (const v of message.ipv4Addresses) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.ipv6Addresses) {
      writer.uint32(58).string(v!);
    }
    if (message.supernet !== false) {
      writer.uint32(64).bool(message.supernet);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVrfsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetVrfsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.needIps = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ipv4Addresses.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ipv6Addresses.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.supernet = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetVrfsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      needIps: isSet(object.needIps) ? globalThis.Boolean(object.needIps) : false,
      ipv4Addresses: globalThis.Array.isArray(object?.ipv4Addresses)
        ? object.ipv4Addresses.map((e: any) => globalThis.String(e))
        : [],
      ipv6Addresses: globalThis.Array.isArray(object?.ipv6Addresses)
        ? object.ipv6Addresses.map((e: any) => globalThis.String(e))
        : [],
      supernet: isSet(object.supernet) ? globalThis.Boolean(object.supernet) : false,
    };
  },

  toJSON(message: GetVrfsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.needIps !== false) {
      obj.needIps = message.needIps;
    }
    if (message.ipv4Addresses?.length) {
      obj.ipv4Addresses = message.ipv4Addresses;
    }
    if (message.ipv6Addresses?.length) {
      obj.ipv6Addresses = message.ipv6Addresses;
    }
    if (message.supernet !== false) {
      obj.supernet = message.supernet;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetVrfsRequest>, I>>(base?: I): GetVrfsRequest {
    return GetVrfsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetVrfsRequest>, I>>(object: I): GetVrfsRequest {
    const message = createBaseGetVrfsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.needIps = object.needIps ?? false;
    message.ipv4Addresses = object.ipv4Addresses?.map((e) => e) || [];
    message.ipv6Addresses = object.ipv6Addresses?.map((e) => e) || [];
    message.supernet = object.supernet ?? false;
    return message;
  },
};

function createBaseGetPortChannelsRequest(): GetPortChannelsRequest {
  return { candidate: "", fabricId: "", ids: [], names: [] };
}

export const GetPortChannelsRequest: MessageFns<GetPortChannelsRequest> = {
  encode(message: GetPortChannelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPortChannelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPortChannelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPortChannelsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetPortChannelsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPortChannelsRequest>, I>>(base?: I): GetPortChannelsRequest {
    return GetPortChannelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPortChannelsRequest>, I>>(object: I): GetPortChannelsRequest {
    const message = createBaseGetPortChannelsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetSubInterfacesRequest(): GetSubInterfacesRequest {
  return { candidate: "", fabricId: "", nodeIds: [], ids: [], names: [], parents: [] };
}

export const GetSubInterfacesRequest: MessageFns<GetSubInterfacesRequest> = {
  encode(message: GetSubInterfacesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.nodeIds) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.parents) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSubInterfacesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSubInterfacesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parents.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSubInterfacesRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      parents: globalThis.Array.isArray(object?.parents) ? object.parents.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetSubInterfacesRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.parents?.length) {
      obj.parents = message.parents;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSubInterfacesRequest>, I>>(base?: I): GetSubInterfacesRequest {
    return GetSubInterfacesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSubInterfacesRequest>, I>>(object: I): GetSubInterfacesRequest {
    const message = createBaseGetSubInterfacesRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.parents = object.parents?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetStaticRoutesRequest(): GetStaticRoutesRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], vrfIds: [] };
}

export const GetStaticRoutesRequest: MessageFns<GetStaticRoutesRequest> = {
  encode(message: GetStaticRoutesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.vrfIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetStaticRoutesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetStaticRoutesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vrfIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetStaticRoutesRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      vrfIds: globalThis.Array.isArray(object?.vrfIds) ? object.vrfIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetStaticRoutesRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.vrfIds?.length) {
      obj.vrfIds = message.vrfIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetStaticRoutesRequest>, I>>(base?: I): GetStaticRoutesRequest {
    return GetStaticRoutesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetStaticRoutesRequest>, I>>(object: I): GetStaticRoutesRequest {
    const message = createBaseGetStaticRoutesRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.vrfIds = object.vrfIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetDhcpRelaysRequest(): GetDhcpRelaysRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], vrfIds: [] };
}

export const GetDhcpRelaysRequest: MessageFns<GetDhcpRelaysRequest> = {
  encode(message: GetDhcpRelaysRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.vrfIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDhcpRelaysRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDhcpRelaysRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vrfIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDhcpRelaysRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      vrfIds: globalThis.Array.isArray(object?.vrfIds) ? object.vrfIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetDhcpRelaysRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.vrfIds?.length) {
      obj.vrfIds = message.vrfIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDhcpRelaysRequest>, I>>(base?: I): GetDhcpRelaysRequest {
    return GetDhcpRelaysRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDhcpRelaysRequest>, I>>(object: I): GetDhcpRelaysRequest {
    const message = createBaseGetDhcpRelaysRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.vrfIds = object.vrfIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetLoopbacksRequest(): GetLoopbacksRequest {
  return { candidate: "", fabricId: "", nodeIds: [], ids: [], names: [], vrfIds: [] };
}

export const GetLoopbacksRequest: MessageFns<GetLoopbacksRequest> = {
  encode(message: GetLoopbacksRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.nodeIds) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.vrfIds) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLoopbacksRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLoopbacksRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.vrfIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLoopbacksRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      vrfIds: globalThis.Array.isArray(object?.vrfIds) ? object.vrfIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetLoopbacksRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.vrfIds?.length) {
      obj.vrfIds = message.vrfIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLoopbacksRequest>, I>>(base?: I): GetLoopbacksRequest {
    return GetLoopbacksRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLoopbacksRequest>, I>>(object: I): GetLoopbacksRequest {
    const message = createBaseGetLoopbacksRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.vrfIds = object.vrfIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetPerVlanStpRequest(): GetPerVlanStpRequest {
  return { candidate: "", fabricId: "" };
}

export const GetPerVlanStpRequest: MessageFns<GetPerVlanStpRequest> = {
  encode(message: GetPerVlanStpRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPerVlanStpRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPerVlanStpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPerVlanStpRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: GetPerVlanStpRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPerVlanStpRequest>, I>>(base?: I): GetPerVlanStpRequest {
    return GetPerVlanStpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPerVlanStpRequest>, I>>(object: I): GetPerVlanStpRequest {
    const message = createBaseGetPerVlanStpRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetPerVlanStpResponse(): GetPerVlanStpResponse {
  return { perVlanStp: undefined };
}

export const GetPerVlanStpResponse: MessageFns<GetPerVlanStpResponse> = {
  encode(message: GetPerVlanStpResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.perVlanStp !== undefined) {
      PerVlanStp.encode(message.perVlanStp, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPerVlanStpResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPerVlanStpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.perVlanStp = PerVlanStp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPerVlanStpResponse {
    return { perVlanStp: isSet(object.perVlanStp) ? PerVlanStp.fromJSON(object.perVlanStp) : undefined };
  },

  toJSON(message: GetPerVlanStpResponse): unknown {
    const obj: any = {};
    if (message.perVlanStp !== undefined) {
      obj.perVlanStp = PerVlanStp.toJSON(message.perVlanStp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPerVlanStpResponse>, I>>(base?: I): GetPerVlanStpResponse {
    return GetPerVlanStpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPerVlanStpResponse>, I>>(object: I): GetPerVlanStpResponse {
    const message = createBaseGetPerVlanStpResponse();
    message.perVlanStp = (object.perVlanStp !== undefined && object.perVlanStp !== null)
      ? PerVlanStp.fromPartial(object.perVlanStp)
      : undefined;
    return message;
  },
};

function createBaseGetBgpPeersRequest(): GetBgpPeersRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], vrfIds: [] };
}

export const GetBgpPeersRequest: MessageFns<GetBgpPeersRequest> = {
  encode(message: GetBgpPeersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.vrfIds) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBgpPeersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBgpPeersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.vrfIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBgpPeersRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      vrfIds: globalThis.Array.isArray(object?.vrfIds) ? object.vrfIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetBgpPeersRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.vrfIds?.length) {
      obj.vrfIds = message.vrfIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBgpPeersRequest>, I>>(base?: I): GetBgpPeersRequest {
    return GetBgpPeersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBgpPeersRequest>, I>>(object: I): GetBgpPeersRequest {
    const message = createBaseGetBgpPeersRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.vrfIds = object.vrfIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetBgpPoliciesRequest(): GetBgpPoliciesRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], types: [] };
}

export const GetBgpPoliciesRequest: MessageFns<GetBgpPoliciesRequest> = {
  encode(message: GetBgpPoliciesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    writer.uint32(50).fork();
    for (const v of message.types) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBgpPoliciesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBgpPoliciesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 6: {
          if (tag === 48) {
            message.types.push(reader.int32() as any);

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.types.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBgpPoliciesRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      types: globalThis.Array.isArray(object?.types) ? object.types.map((e: any) => bgpPolicyTypeFromJSON(e)) : [],
    };
  },

  toJSON(message: GetBgpPoliciesRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.types?.length) {
      obj.types = message.types.map((e) => bgpPolicyTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBgpPoliciesRequest>, I>>(base?: I): GetBgpPoliciesRequest {
    return GetBgpPoliciesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBgpPoliciesRequest>, I>>(object: I): GetBgpPoliciesRequest {
    const message = createBaseGetBgpPoliciesRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.types = object.types?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetPrefixListsRequest(): GetPrefixListsRequest {
  return { ids: [], names: [], pagination: undefined };
}

export const GetPrefixListsRequest: MessageFns<GetPrefixListsRequest> = {
  encode(message: GetPrefixListsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(42).string(v!);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPrefixListsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPrefixListsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPrefixListsRequest {
    return {
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetPrefixListsRequest): unknown {
    const obj: any = {};
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPrefixListsRequest>, I>>(base?: I): GetPrefixListsRequest {
    return GetPrefixListsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPrefixListsRequest>, I>>(object: I): GetPrefixListsRequest {
    const message = createBaseGetPrefixListsRequest();
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetPrefixListsResponse(): GetPrefixListsResponse {
  return { lists: [], pagination: undefined };
}

export const GetPrefixListsResponse: MessageFns<GetPrefixListsResponse> = {
  encode(message: GetPrefixListsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.lists) {
      PrefixList.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPrefixListsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPrefixListsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lists.push(PrefixList.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPrefixListsResponse {
    return {
      lists: globalThis.Array.isArray(object?.lists) ? object.lists.map((e: any) => PrefixList.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetPrefixListsResponse): unknown {
    const obj: any = {};
    if (message.lists?.length) {
      obj.lists = message.lists.map((e) => PrefixList.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPrefixListsResponse>, I>>(base?: I): GetPrefixListsResponse {
    return GetPrefixListsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPrefixListsResponse>, I>>(object: I): GetPrefixListsResponse {
    const message = createBaseGetPrefixListsResponse();
    message.lists = object.lists?.map((e) => PrefixList.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseDeviceClaim(): DeviceClaim {
  return { serialNumber: "", modelName: "", deviceId: "", claimCode: "", claimStatus: 0 };
}

export const DeviceClaim: MessageFns<DeviceClaim> = {
  encode(message: DeviceClaim, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serialNumber !== "") {
      writer.uint32(10).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(18).string(message.modelName);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.claimCode !== "") {
      writer.uint32(34).string(message.claimCode);
    }
    if (message.claimStatus !== 0) {
      writer.uint32(40).int32(message.claimStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceClaim {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceClaim();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.claimCode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.claimStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceClaim {
    return {
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      claimCode: isSet(object.claimCode) ? globalThis.String(object.claimCode) : "",
      claimStatus: isSet(object.claimStatus) ? claimStatusFromJSON(object.claimStatus) : 0,
    };
  },

  toJSON(message: DeviceClaim): unknown {
    const obj: any = {};
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.claimCode !== "") {
      obj.claimCode = message.claimCode;
    }
    if (message.claimStatus !== 0) {
      obj.claimStatus = claimStatusToJSON(message.claimStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceClaim>, I>>(base?: I): DeviceClaim {
    return DeviceClaim.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceClaim>, I>>(object: I): DeviceClaim {
    const message = createBaseDeviceClaim();
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.deviceId = object.deviceId ?? "";
    message.claimCode = object.claimCode ?? "";
    message.claimStatus = object.claimStatus ?? 0;
    return message;
  },
};

function createBaseDeviceClaimRequest(): DeviceClaimRequest {
  return { claims: [] };
}

export const DeviceClaimRequest: MessageFns<DeviceClaimRequest> = {
  encode(message: DeviceClaimRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.claims) {
      DeviceClaim.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceClaimRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceClaimRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.claims.push(DeviceClaim.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceClaimRequest {
    return {
      claims: globalThis.Array.isArray(object?.claims) ? object.claims.map((e: any) => DeviceClaim.fromJSON(e)) : [],
    };
  },

  toJSON(message: DeviceClaimRequest): unknown {
    const obj: any = {};
    if (message.claims?.length) {
      obj.claims = message.claims.map((e) => DeviceClaim.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceClaimRequest>, I>>(base?: I): DeviceClaimRequest {
    return DeviceClaimRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceClaimRequest>, I>>(object: I): DeviceClaimRequest {
    const message = createBaseDeviceClaimRequest();
    message.claims = object.claims?.map((e) => DeviceClaim.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeviceClaimResponse(): DeviceClaimResponse {
  return { claims: [] };
}

export const DeviceClaimResponse: MessageFns<DeviceClaimResponse> = {
  encode(message: DeviceClaimResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.claims) {
      DeviceClaim.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceClaimResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceClaimResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.claims.push(DeviceClaim.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceClaimResponse {
    return {
      claims: globalThis.Array.isArray(object?.claims) ? object.claims.map((e: any) => DeviceClaim.fromJSON(e)) : [],
    };
  },

  toJSON(message: DeviceClaimResponse): unknown {
    const obj: any = {};
    if (message.claims?.length) {
      obj.claims = message.claims.map((e) => DeviceClaim.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceClaimResponse>, I>>(base?: I): DeviceClaimResponse {
    return DeviceClaimResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceClaimResponse>, I>>(object: I): DeviceClaimResponse {
    const message = createBaseDeviceClaimResponse();
    message.claims = object.claims?.map((e) => DeviceClaim.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClaimDevicesRequest(): ClaimDevicesRequest {
  return { claimCodes: [], deviceIds: [], serialNumbers: [] };
}

export const ClaimDevicesRequest: MessageFns<ClaimDevicesRequest> = {
  encode(message: ClaimDevicesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.claimCodes) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.deviceIds) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.serialNumbers) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimDevicesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimDevicesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.claimCodes.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serialNumbers.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimDevicesRequest {
    return {
      claimCodes: globalThis.Array.isArray(object?.claimCodes)
        ? object.claimCodes.map((e: any) => globalThis.String(e))
        : [],
      deviceIds: globalThis.Array.isArray(object?.deviceIds)
        ? object.deviceIds.map((e: any) => globalThis.String(e))
        : [],
      serialNumbers: globalThis.Array.isArray(object?.serialNumbers)
        ? object.serialNumbers.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ClaimDevicesRequest): unknown {
    const obj: any = {};
    if (message.claimCodes?.length) {
      obj.claimCodes = message.claimCodes;
    }
    if (message.deviceIds?.length) {
      obj.deviceIds = message.deviceIds;
    }
    if (message.serialNumbers?.length) {
      obj.serialNumbers = message.serialNumbers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimDevicesRequest>, I>>(base?: I): ClaimDevicesRequest {
    return ClaimDevicesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimDevicesRequest>, I>>(object: I): ClaimDevicesRequest {
    const message = createBaseClaimDevicesRequest();
    message.claimCodes = object.claimCodes?.map((e) => e) || [];
    message.deviceIds = object.deviceIds?.map((e) => e) || [];
    message.serialNumbers = object.serialNumbers?.map((e) => e) || [];
    return message;
  },
};

function createBaseClaimDevicesResponse(): ClaimDevicesResponse {
  return { claims: [] };
}

export const ClaimDevicesResponse: MessageFns<ClaimDevicesResponse> = {
  encode(message: ClaimDevicesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.claims) {
      ClaimResult.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimDevicesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimDevicesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.claims.push(ClaimResult.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimDevicesResponse {
    return {
      claims: globalThis.Array.isArray(object?.claims) ? object.claims.map((e: any) => ClaimResult.fromJSON(e)) : [],
    };
  },

  toJSON(message: ClaimDevicesResponse): unknown {
    const obj: any = {};
    if (message.claims?.length) {
      obj.claims = message.claims.map((e) => ClaimResult.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimDevicesResponse>, I>>(base?: I): ClaimDevicesResponse {
    return ClaimDevicesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimDevicesResponse>, I>>(object: I): ClaimDevicesResponse {
    const message = createBaseClaimDevicesResponse();
    message.claims = object.claims?.map((e) => ClaimResult.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClaimDeviceSecondCommitRequest(): ClaimDeviceSecondCommitRequest {
  return {
    deviceId: "",
    targetOrgId: "",
    targetFabId: "",
    claimCode: "",
    serialNumber: "",
    osType: 0,
    monitored: false,
  };
}

export const ClaimDeviceSecondCommitRequest: MessageFns<ClaimDeviceSecondCommitRequest> = {
  encode(message: ClaimDeviceSecondCommitRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.targetOrgId !== "") {
      writer.uint32(18).string(message.targetOrgId);
    }
    if (message.targetFabId !== "") {
      writer.uint32(26).string(message.targetFabId);
    }
    if (message.claimCode !== "") {
      writer.uint32(34).string(message.claimCode);
    }
    if (message.serialNumber !== "") {
      writer.uint32(42).string(message.serialNumber);
    }
    if (message.osType !== 0) {
      writer.uint32(48).int32(message.osType);
    }
    if (message.monitored !== false) {
      writer.uint32(56).bool(message.monitored);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimDeviceSecondCommitRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimDeviceSecondCommitRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.targetOrgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.targetFabId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.claimCode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimDeviceSecondCommitRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      targetOrgId: isSet(object.targetOrgId) ? globalThis.String(object.targetOrgId) : "",
      targetFabId: isSet(object.targetFabId) ? globalThis.String(object.targetFabId) : "",
      claimCode: isSet(object.claimCode) ? globalThis.String(object.claimCode) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
    };
  },

  toJSON(message: ClaimDeviceSecondCommitRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.targetOrgId !== "") {
      obj.targetOrgId = message.targetOrgId;
    }
    if (message.targetFabId !== "") {
      obj.targetFabId = message.targetFabId;
    }
    if (message.claimCode !== "") {
      obj.claimCode = message.claimCode;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimDeviceSecondCommitRequest>, I>>(base?: I): ClaimDeviceSecondCommitRequest {
    return ClaimDeviceSecondCommitRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimDeviceSecondCommitRequest>, I>>(
    object: I,
  ): ClaimDeviceSecondCommitRequest {
    const message = createBaseClaimDeviceSecondCommitRequest();
    message.deviceId = object.deviceId ?? "";
    message.targetOrgId = object.targetOrgId ?? "";
    message.targetFabId = object.targetFabId ?? "";
    message.claimCode = object.claimCode ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.osType = object.osType ?? 0;
    message.monitored = object.monitored ?? false;
    return message;
  },
};

function createBaseClaimDeviceSecondCommitResponse(): ClaimDeviceSecondCommitResponse {
  return { claimStatus: 0 };
}

export const ClaimDeviceSecondCommitResponse: MessageFns<ClaimDeviceSecondCommitResponse> = {
  encode(message: ClaimDeviceSecondCommitResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.claimStatus !== 0) {
      writer.uint32(8).int32(message.claimStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimDeviceSecondCommitResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimDeviceSecondCommitResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.claimStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimDeviceSecondCommitResponse {
    return { claimStatus: isSet(object.claimStatus) ? claimStatusFromJSON(object.claimStatus) : 0 };
  },

  toJSON(message: ClaimDeviceSecondCommitResponse): unknown {
    const obj: any = {};
    if (message.claimStatus !== 0) {
      obj.claimStatus = claimStatusToJSON(message.claimStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimDeviceSecondCommitResponse>, I>>(base?: I): ClaimDeviceSecondCommitResponse {
    return ClaimDeviceSecondCommitResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimDeviceSecondCommitResponse>, I>>(
    object: I,
  ): ClaimDeviceSecondCommitResponse {
    const message = createBaseClaimDeviceSecondCommitResponse();
    message.claimStatus = object.claimStatus ?? 0;
    return message;
  },
};

function createBaseCleanClaimedDeviceRequest(): CleanClaimedDeviceRequest {
  return { deviceId: "", sourceOrgId: "" };
}

export const CleanClaimedDeviceRequest: MessageFns<CleanClaimedDeviceRequest> = {
  encode(message: CleanClaimedDeviceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.sourceOrgId !== "") {
      writer.uint32(18).string(message.sourceOrgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CleanClaimedDeviceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCleanClaimedDeviceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sourceOrgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CleanClaimedDeviceRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      sourceOrgId: isSet(object.sourceOrgId) ? globalThis.String(object.sourceOrgId) : "",
    };
  },

  toJSON(message: CleanClaimedDeviceRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.sourceOrgId !== "") {
      obj.sourceOrgId = message.sourceOrgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CleanClaimedDeviceRequest>, I>>(base?: I): CleanClaimedDeviceRequest {
    return CleanClaimedDeviceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CleanClaimedDeviceRequest>, I>>(object: I): CleanClaimedDeviceRequest {
    const message = createBaseCleanClaimedDeviceRequest();
    message.deviceId = object.deviceId ?? "";
    message.sourceOrgId = object.sourceOrgId ?? "";
    return message;
  },
};

function createBaseUnclaimDeviceRequest(): UnclaimDeviceRequest {
  return { deviceId: "" };
}

export const UnclaimDeviceRequest: MessageFns<UnclaimDeviceRequest> = {
  encode(message: UnclaimDeviceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnclaimDeviceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnclaimDeviceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnclaimDeviceRequest {
    return { deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "" };
  },

  toJSON(message: UnclaimDeviceRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnclaimDeviceRequest>, I>>(base?: I): UnclaimDeviceRequest {
    return UnclaimDeviceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnclaimDeviceRequest>, I>>(object: I): UnclaimDeviceRequest {
    const message = createBaseUnclaimDeviceRequest();
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseBuildDeviceThreadlistRequest(): BuildDeviceThreadlistRequest {
  return { deviceId: "" };
}

export const BuildDeviceThreadlistRequest: MessageFns<BuildDeviceThreadlistRequest> = {
  encode(message: BuildDeviceThreadlistRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BuildDeviceThreadlistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBuildDeviceThreadlistRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BuildDeviceThreadlistRequest {
    return { deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "" };
  },

  toJSON(message: BuildDeviceThreadlistRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BuildDeviceThreadlistRequest>, I>>(base?: I): BuildDeviceThreadlistRequest {
    return BuildDeviceThreadlistRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BuildDeviceThreadlistRequest>, I>>(object: I): BuildDeviceThreadlistRequest {
    const message = createBaseBuildDeviceThreadlistRequest();
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseRemoveDeviceFromInstanceRequest(): RemoveDeviceFromInstanceRequest {
  return { deviceId: "", sourceFabId: "", sourceOrgId: "", targetOrgId: "", targetFabId: "" };
}

export const RemoveDeviceFromInstanceRequest: MessageFns<RemoveDeviceFromInstanceRequest> = {
  encode(message: RemoveDeviceFromInstanceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.sourceFabId !== "") {
      writer.uint32(18).string(message.sourceFabId);
    }
    if (message.sourceOrgId !== "") {
      writer.uint32(26).string(message.sourceOrgId);
    }
    if (message.targetOrgId !== "") {
      writer.uint32(34).string(message.targetOrgId);
    }
    if (message.targetFabId !== "") {
      writer.uint32(42).string(message.targetFabId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveDeviceFromInstanceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveDeviceFromInstanceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sourceFabId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sourceOrgId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.targetOrgId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetFabId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveDeviceFromInstanceRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      sourceFabId: isSet(object.sourceFabId) ? globalThis.String(object.sourceFabId) : "",
      sourceOrgId: isSet(object.sourceOrgId) ? globalThis.String(object.sourceOrgId) : "",
      targetOrgId: isSet(object.targetOrgId) ? globalThis.String(object.targetOrgId) : "",
      targetFabId: isSet(object.targetFabId) ? globalThis.String(object.targetFabId) : "",
    };
  },

  toJSON(message: RemoveDeviceFromInstanceRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.sourceFabId !== "") {
      obj.sourceFabId = message.sourceFabId;
    }
    if (message.sourceOrgId !== "") {
      obj.sourceOrgId = message.sourceOrgId;
    }
    if (message.targetOrgId !== "") {
      obj.targetOrgId = message.targetOrgId;
    }
    if (message.targetFabId !== "") {
      obj.targetFabId = message.targetFabId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveDeviceFromInstanceRequest>, I>>(base?: I): RemoveDeviceFromInstanceRequest {
    return RemoveDeviceFromInstanceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveDeviceFromInstanceRequest>, I>>(
    object: I,
  ): RemoveDeviceFromInstanceRequest {
    const message = createBaseRemoveDeviceFromInstanceRequest();
    message.deviceId = object.deviceId ?? "";
    message.sourceFabId = object.sourceFabId ?? "";
    message.sourceOrgId = object.sourceOrgId ?? "";
    message.targetOrgId = object.targetOrgId ?? "";
    message.targetFabId = object.targetFabId ?? "";
    return message;
  },
};

function createBaseAddDeviceToInstanceRequest(): AddDeviceToInstanceRequest {
  return { deviceId: "", sourceFabId: "", sourceOrgId: "", targetOrgId: "", targetFabId: "" };
}

export const AddDeviceToInstanceRequest: MessageFns<AddDeviceToInstanceRequest> = {
  encode(message: AddDeviceToInstanceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.sourceFabId !== "") {
      writer.uint32(18).string(message.sourceFabId);
    }
    if (message.sourceOrgId !== "") {
      writer.uint32(26).string(message.sourceOrgId);
    }
    if (message.targetOrgId !== "") {
      writer.uint32(34).string(message.targetOrgId);
    }
    if (message.targetFabId !== "") {
      writer.uint32(42).string(message.targetFabId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddDeviceToInstanceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddDeviceToInstanceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sourceFabId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sourceOrgId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.targetOrgId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetFabId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddDeviceToInstanceRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      sourceFabId: isSet(object.sourceFabId) ? globalThis.String(object.sourceFabId) : "",
      sourceOrgId: isSet(object.sourceOrgId) ? globalThis.String(object.sourceOrgId) : "",
      targetOrgId: isSet(object.targetOrgId) ? globalThis.String(object.targetOrgId) : "",
      targetFabId: isSet(object.targetFabId) ? globalThis.String(object.targetFabId) : "",
    };
  },

  toJSON(message: AddDeviceToInstanceRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.sourceFabId !== "") {
      obj.sourceFabId = message.sourceFabId;
    }
    if (message.sourceOrgId !== "") {
      obj.sourceOrgId = message.sourceOrgId;
    }
    if (message.targetOrgId !== "") {
      obj.targetOrgId = message.targetOrgId;
    }
    if (message.targetFabId !== "") {
      obj.targetFabId = message.targetFabId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddDeviceToInstanceRequest>, I>>(base?: I): AddDeviceToInstanceRequest {
    return AddDeviceToInstanceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddDeviceToInstanceRequest>, I>>(object: I): AddDeviceToInstanceRequest {
    const message = createBaseAddDeviceToInstanceRequest();
    message.deviceId = object.deviceId ?? "";
    message.sourceFabId = object.sourceFabId ?? "";
    message.sourceOrgId = object.sourceOrgId ?? "";
    message.targetOrgId = object.targetOrgId ?? "";
    message.targetFabId = object.targetFabId ?? "";
    return message;
  },
};

function createBaseDeviceRMAUnclaimRequest(): DeviceRMAUnclaimRequest {
  return { deviceId: "", orgId: "", fabricId: "", supportUser: "" };
}

export const DeviceRMAUnclaimRequest: MessageFns<DeviceRMAUnclaimRequest> = {
  encode(message: DeviceRMAUnclaimRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.supportUser !== "") {
      writer.uint32(34).string(message.supportUser);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceRMAUnclaimRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceRMAUnclaimRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.supportUser = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceRMAUnclaimRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      supportUser: isSet(object.supportUser) ? globalThis.String(object.supportUser) : "",
    };
  },

  toJSON(message: DeviceRMAUnclaimRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.supportUser !== "") {
      obj.supportUser = message.supportUser;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceRMAUnclaimRequest>, I>>(base?: I): DeviceRMAUnclaimRequest {
    return DeviceRMAUnclaimRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceRMAUnclaimRequest>, I>>(object: I): DeviceRMAUnclaimRequest {
    const message = createBaseDeviceRMAUnclaimRequest();
    message.deviceId = object.deviceId ?? "";
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.supportUser = object.supportUser ?? "";
    return message;
  },
};

function createBaseDeviceRMAUnbindRequest(): DeviceRMAUnbindRequest {
  return { deviceId: "", orgId: "", fabricId: "", supportUser: "" };
}

export const DeviceRMAUnbindRequest: MessageFns<DeviceRMAUnbindRequest> = {
  encode(message: DeviceRMAUnbindRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.supportUser !== "") {
      writer.uint32(34).string(message.supportUser);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceRMAUnbindRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceRMAUnbindRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.supportUser = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceRMAUnbindRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      supportUser: isSet(object.supportUser) ? globalThis.String(object.supportUser) : "",
    };
  },

  toJSON(message: DeviceRMAUnbindRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.supportUser !== "") {
      obj.supportUser = message.supportUser;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceRMAUnbindRequest>, I>>(base?: I): DeviceRMAUnbindRequest {
    return DeviceRMAUnbindRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceRMAUnbindRequest>, I>>(object: I): DeviceRMAUnbindRequest {
    const message = createBaseDeviceRMAUnbindRequest();
    message.deviceId = object.deviceId ?? "";
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.supportUser = object.supportUser ?? "";
    return message;
  },
};

function createBaseDeviceRMAUnbindResponse(): DeviceRMAUnbindResponse {
  return { parkingLotFabricId: "" };
}

export const DeviceRMAUnbindResponse: MessageFns<DeviceRMAUnbindResponse> = {
  encode(message: DeviceRMAUnbindResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parkingLotFabricId !== "") {
      writer.uint32(10).string(message.parkingLotFabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceRMAUnbindResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceRMAUnbindResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.parkingLotFabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceRMAUnbindResponse {
    return { parkingLotFabricId: isSet(object.parkingLotFabricId) ? globalThis.String(object.parkingLotFabricId) : "" };
  },

  toJSON(message: DeviceRMAUnbindResponse): unknown {
    const obj: any = {};
    if (message.parkingLotFabricId !== "") {
      obj.parkingLotFabricId = message.parkingLotFabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceRMAUnbindResponse>, I>>(base?: I): DeviceRMAUnbindResponse {
    return DeviceRMAUnbindResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceRMAUnbindResponse>, I>>(object: I): DeviceRMAUnbindResponse {
    const message = createBaseDeviceRMAUnbindResponse();
    message.parkingLotFabricId = object.parkingLotFabricId ?? "";
    return message;
  },
};

function createBaseGetWorkflowFeedbacksRequest(): GetWorkflowFeedbacksRequest {
  return {
    nodeIds: [],
    details: false,
    startTime: undefined,
    endTime: undefined,
    configFp: "",
    taskNames: [],
    workflowTypes: [],
    fabricId: "",
  };
}

export const GetWorkflowFeedbacksRequest: MessageFns<GetWorkflowFeedbacksRequest> = {
  encode(message: GetWorkflowFeedbacksRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodeIds) {
      writer.uint32(10).string(v!);
    }
    if (message.details !== false) {
      writer.uint32(16).bool(message.details);
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(26).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(34).fork()).join();
    }
    if (message.configFp !== "") {
      writer.uint32(42).string(message.configFp);
    }
    for (const v of message.taskNames) {
      writer.uint32(50).string(v!);
    }
    writer.uint32(66).fork();
    for (const v of message.workflowTypes) {
      writer.int32(v);
    }
    writer.join();
    if (message.fabricId !== "") {
      writer.uint32(74).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkflowFeedbacksRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkflowFeedbacksRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.details = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.configFp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.taskNames.push(reader.string());
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.workflowTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.workflowTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkflowFeedbacksRequest {
    return {
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      details: isSet(object.details) ? globalThis.Boolean(object.details) : false,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      configFp: isSet(object.configFp) ? globalThis.String(object.configFp) : "",
      taskNames: globalThis.Array.isArray(object?.taskNames)
        ? object.taskNames.map((e: any) => globalThis.String(e))
        : [],
      workflowTypes: globalThis.Array.isArray(object?.workflowTypes)
        ? object.workflowTypes.map((e: any) => workflowTypeFromJSON(e))
        : [],
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: GetWorkflowFeedbacksRequest): unknown {
    const obj: any = {};
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.details !== false) {
      obj.details = message.details;
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.configFp !== "") {
      obj.configFp = message.configFp;
    }
    if (message.taskNames?.length) {
      obj.taskNames = message.taskNames;
    }
    if (message.workflowTypes?.length) {
      obj.workflowTypes = message.workflowTypes.map((e) => workflowTypeToJSON(e));
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetWorkflowFeedbacksRequest>, I>>(base?: I): GetWorkflowFeedbacksRequest {
    return GetWorkflowFeedbacksRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetWorkflowFeedbacksRequest>, I>>(object: I): GetWorkflowFeedbacksRequest {
    const message = createBaseGetWorkflowFeedbacksRequest();
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.details = object.details ?? false;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.configFp = object.configFp ?? "";
    message.taskNames = object.taskNames?.map((e) => e) || [];
    message.workflowTypes = object.workflowTypes?.map((e) => e) || [];
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetWorkflowFeedbacksResponse(): GetWorkflowFeedbacksResponse {
  return { nodeIds: [], feedbacks: [], names: [] };
}

export const GetWorkflowFeedbacksResponse: MessageFns<GetWorkflowFeedbacksResponse> = {
  encode(message: GetWorkflowFeedbacksResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodeIds) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.feedbacks) {
      WorkflowFeedback.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.names) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkflowFeedbacksResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkflowFeedbacksResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.feedbacks.push(WorkflowFeedback.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkflowFeedbacksResponse {
    return {
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
      feedbacks: globalThis.Array.isArray(object?.feedbacks)
        ? object.feedbacks.map((e: any) => WorkflowFeedback.fromJSON(e))
        : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetWorkflowFeedbacksResponse): unknown {
    const obj: any = {};
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    if (message.feedbacks?.length) {
      obj.feedbacks = message.feedbacks.map((e) => WorkflowFeedback.toJSON(e));
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetWorkflowFeedbacksResponse>, I>>(base?: I): GetWorkflowFeedbacksResponse {
    return GetWorkflowFeedbacksResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetWorkflowFeedbacksResponse>, I>>(object: I): GetWorkflowFeedbacksResponse {
    const message = createBaseGetWorkflowFeedbacksResponse();
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    message.feedbacks = object.feedbacks?.map((e) => WorkflowFeedback.fromPartial(e)) || [];
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseCandidateReview(): CandidateReview {
  return { comments: "", createdBy: "", createdAt: undefined, operation: 0 };
}

export const CandidateReview: MessageFns<CandidateReview> = {
  encode(message: CandidateReview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comments !== "") {
      writer.uint32(10).string(message.comments);
    }
    if (message.createdBy !== "") {
      writer.uint32(18).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.operation !== 0) {
      writer.uint32(32).int32(message.operation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CandidateReview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandidateReview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.operation = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CandidateReview {
    return {
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      operation: isSet(object.operation) ? operationFromJSON(object.operation) : 0,
    };
  },

  toJSON(message: CandidateReview): unknown {
    const obj: any = {};
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.operation !== 0) {
      obj.operation = operationToJSON(message.operation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CandidateReview>, I>>(base?: I): CandidateReview {
    return CandidateReview.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CandidateReview>, I>>(object: I): CandidateReview {
    const message = createBaseCandidateReview();
    message.comments = object.comments ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.operation = object.operation ?? 0;
    return message;
  },
};

function createBaseFabricCandidate(): FabricCandidate {
  return {
    fabricId: "",
    name: "",
    active: false,
    txnId: "0",
    revisionId: "0",
    createdBy: "",
    createdAt: undefined,
    modifiedBy: "",
    modifiedAt: undefined,
    reviews: [],
    events: [],
    type: 0,
    errors: [],
  };
}

export const FabricCandidate: MessageFns<FabricCandidate> = {
  encode(message: FabricCandidate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.active !== false) {
      writer.uint32(24).bool(message.active);
    }
    if (message.txnId !== "0") {
      writer.uint32(32).int64(message.txnId);
    }
    if (message.revisionId !== "0") {
      writer.uint32(40).int64(message.revisionId);
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.modifiedBy !== "") {
      writer.uint32(66).string(message.modifiedBy);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(74).fork()).join();
    }
    for (const v of message.reviews) {
      CandidateReview.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.events) {
      ActivityEvent.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(96).int32(message.type);
    }
    for (const v of message.errors) {
      writer.uint32(106).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricCandidate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricCandidate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.txnId = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.modifiedBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.reviews.push(CandidateReview.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.events.push(ActivityEvent.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.errors.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricCandidate {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "0",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      modifiedBy: isSet(object.modifiedBy) ? globalThis.String(object.modifiedBy) : "",
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      reviews: globalThis.Array.isArray(object?.reviews)
        ? object.reviews.map((e: any) => CandidateReview.fromJSON(e))
        : [],
      events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => ActivityEvent.fromJSON(e)) : [],
      type: isSet(object.type) ? candidateTypeFromJSON(object.type) : 0,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: FabricCandidate): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.txnId !== "0") {
      obj.txnId = message.txnId;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.modifiedBy !== "") {
      obj.modifiedBy = message.modifiedBy;
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.reviews?.length) {
      obj.reviews = message.reviews.map((e) => CandidateReview.toJSON(e));
    }
    if (message.events?.length) {
      obj.events = message.events.map((e) => ActivityEvent.toJSON(e));
    }
    if (message.type !== 0) {
      obj.type = candidateTypeToJSON(message.type);
    }
    if (message.errors?.length) {
      obj.errors = message.errors;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricCandidate>, I>>(base?: I): FabricCandidate {
    return FabricCandidate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricCandidate>, I>>(object: I): FabricCandidate {
    const message = createBaseFabricCandidate();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.active = object.active ?? false;
    message.txnId = object.txnId ?? "0";
    message.revisionId = object.revisionId ?? "0";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.modifiedBy = object.modifiedBy ?? "";
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.reviews = object.reviews?.map((e) => CandidateReview.fromPartial(e)) || [];
    message.events = object.events?.map((e) => ActivityEvent.fromPartial(e)) || [];
    message.type = object.type ?? 0;
    message.errors = object.errors?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetFabricCandidatesRequest(): GetFabricCandidatesRequest {
  return {
    fabricId: "",
    name: "",
    txnId: "0",
    needInactive: false,
    needReviews: false,
    needEvents: false,
    startTime: undefined,
    endTime: undefined,
    pagination: undefined,
    max: 0,
    cursor: "",
  };
}

export const GetFabricCandidatesRequest: MessageFns<GetFabricCandidatesRequest> = {
  encode(message: GetFabricCandidatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.txnId !== "0") {
      writer.uint32(24).int64(message.txnId);
    }
    if (message.needInactive !== false) {
      writer.uint32(32).bool(message.needInactive);
    }
    if (message.needReviews !== false) {
      writer.uint32(40).bool(message.needReviews);
    }
    if (message.needEvents !== false) {
      writer.uint32(48).bool(message.needEvents);
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(58).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(66).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    if (message.max !== 0) {
      writer.uint32(88).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(98).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricCandidatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricCandidatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.txnId = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.needInactive = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.needReviews = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.needEvents = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricCandidatesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "0",
      needInactive: isSet(object.needInactive) ? globalThis.Boolean(object.needInactive) : false,
      needReviews: isSet(object.needReviews) ? globalThis.Boolean(object.needReviews) : false,
      needEvents: isSet(object.needEvents) ? globalThis.Boolean(object.needEvents) : false,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
    };
  },

  toJSON(message: GetFabricCandidatesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.txnId !== "0") {
      obj.txnId = message.txnId;
    }
    if (message.needInactive !== false) {
      obj.needInactive = message.needInactive;
    }
    if (message.needReviews !== false) {
      obj.needReviews = message.needReviews;
    }
    if (message.needEvents !== false) {
      obj.needEvents = message.needEvents;
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricCandidatesRequest>, I>>(base?: I): GetFabricCandidatesRequest {
    return GetFabricCandidatesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricCandidatesRequest>, I>>(object: I): GetFabricCandidatesRequest {
    const message = createBaseGetFabricCandidatesRequest();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.txnId = object.txnId ?? "0";
    message.needInactive = object.needInactive ?? false;
    message.needReviews = object.needReviews ?? false;
    message.needEvents = object.needEvents ?? false;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    return message;
  },
};

function createBaseGetFabricCandidateRequest(): GetFabricCandidateRequest {
  return { fabricId: "", name: "", needInactive: false, needReviews: false, needEvents: false };
}

export const GetFabricCandidateRequest: MessageFns<GetFabricCandidateRequest> = {
  encode(message: GetFabricCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.needInactive !== false) {
      writer.uint32(24).bool(message.needInactive);
    }
    if (message.needReviews !== false) {
      writer.uint32(32).bool(message.needReviews);
    }
    if (message.needEvents !== false) {
      writer.uint32(40).bool(message.needEvents);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.needInactive = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.needReviews = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.needEvents = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricCandidateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      needInactive: isSet(object.needInactive) ? globalThis.Boolean(object.needInactive) : false,
      needReviews: isSet(object.needReviews) ? globalThis.Boolean(object.needReviews) : false,
      needEvents: isSet(object.needEvents) ? globalThis.Boolean(object.needEvents) : false,
    };
  },

  toJSON(message: GetFabricCandidateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.needInactive !== false) {
      obj.needInactive = message.needInactive;
    }
    if (message.needReviews !== false) {
      obj.needReviews = message.needReviews;
    }
    if (message.needEvents !== false) {
      obj.needEvents = message.needEvents;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricCandidateRequest>, I>>(base?: I): GetFabricCandidateRequest {
    return GetFabricCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricCandidateRequest>, I>>(object: I): GetFabricCandidateRequest {
    const message = createBaseGetFabricCandidateRequest();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.needInactive = object.needInactive ?? false;
    message.needReviews = object.needReviews ?? false;
    message.needEvents = object.needEvents ?? false;
    return message;
  },
};

function createBaseGetFabricCandidatesResponse(): GetFabricCandidatesResponse {
  return { candidates: [], cursor: "", pagination: undefined };
}

export const GetFabricCandidatesResponse: MessageFns<GetFabricCandidatesResponse> = {
  encode(message: GetFabricCandidatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.candidates) {
      FabricCandidate.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricCandidatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricCandidatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidates.push(FabricCandidate.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricCandidatesResponse {
    return {
      candidates: globalThis.Array.isArray(object?.candidates)
        ? object.candidates.map((e: any) => FabricCandidate.fromJSON(e))
        : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetFabricCandidatesResponse): unknown {
    const obj: any = {};
    if (message.candidates?.length) {
      obj.candidates = message.candidates.map((e) => FabricCandidate.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricCandidatesResponse>, I>>(base?: I): GetFabricCandidatesResponse {
    return GetFabricCandidatesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricCandidatesResponse>, I>>(object: I): GetFabricCandidatesResponse {
    const message = createBaseGetFabricCandidatesResponse();
    message.candidates = object.candidates?.map((e) => FabricCandidate.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseCommitFabricCandidateRequest(): CommitFabricCandidateRequest {
  return { fabricId: "", name: "", comments: "", revisionId: "0", mergeDci: false };
}

export const CommitFabricCandidateRequest: MessageFns<CommitFabricCandidateRequest> = {
  encode(message: CommitFabricCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.comments !== "") {
      writer.uint32(26).string(message.comments);
    }
    if (message.revisionId !== "0") {
      writer.uint32(32).int64(message.revisionId);
    }
    if (message.mergeDci !== false) {
      writer.uint32(40).bool(message.mergeDci);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommitFabricCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitFabricCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mergeDci = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommitFabricCandidateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      mergeDci: isSet(object.mergeDci) ? globalThis.Boolean(object.mergeDci) : false,
    };
  },

  toJSON(message: CommitFabricCandidateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.mergeDci !== false) {
      obj.mergeDci = message.mergeDci;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommitFabricCandidateRequest>, I>>(base?: I): CommitFabricCandidateRequest {
    return CommitFabricCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommitFabricCandidateRequest>, I>>(object: I): CommitFabricCandidateRequest {
    const message = createBaseCommitFabricCandidateRequest();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.comments = object.comments ?? "";
    message.revisionId = object.revisionId ?? "0";
    message.mergeDci = object.mergeDci ?? false;
    return message;
  },
};

function createBaseCommitFabricCandidateResponse(): CommitFabricCandidateResponse {
  return { fabricId: "", committed: false };
}

export const CommitFabricCandidateResponse: MessageFns<CommitFabricCandidateResponse> = {
  encode(message: CommitFabricCandidateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.committed !== false) {
      writer.uint32(16).bool(message.committed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommitFabricCandidateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitFabricCandidateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.committed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommitFabricCandidateResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      committed: isSet(object.committed) ? globalThis.Boolean(object.committed) : false,
    };
  },

  toJSON(message: CommitFabricCandidateResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.committed !== false) {
      obj.committed = message.committed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommitFabricCandidateResponse>, I>>(base?: I): CommitFabricCandidateResponse {
    return CommitFabricCandidateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommitFabricCandidateResponse>, I>>(
    object: I,
  ): CommitFabricCandidateResponse {
    const message = createBaseCommitFabricCandidateResponse();
    message.fabricId = object.fabricId ?? "";
    message.committed = object.committed ?? false;
    return message;
  },
};

function createBaseRevertFabricCandidateRequest(): RevertFabricCandidateRequest {
  return { fabricId: "", name: "", comments: "", revisionId: "0" };
}

export const RevertFabricCandidateRequest: MessageFns<RevertFabricCandidateRequest> = {
  encode(message: RevertFabricCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.comments !== "") {
      writer.uint32(26).string(message.comments);
    }
    if (message.revisionId !== "0") {
      writer.uint32(32).int64(message.revisionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevertFabricCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevertFabricCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevertFabricCandidateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
    };
  },

  toJSON(message: RevertFabricCandidateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevertFabricCandidateRequest>, I>>(base?: I): RevertFabricCandidateRequest {
    return RevertFabricCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevertFabricCandidateRequest>, I>>(object: I): RevertFabricCandidateRequest {
    const message = createBaseRevertFabricCandidateRequest();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.comments = object.comments ?? "";
    message.revisionId = object.revisionId ?? "0";
    return message;
  },
};

function createBaseRevertFabricCandidateResponse(): RevertFabricCandidateResponse {
  return { fabricId: "", reverted: false };
}

export const RevertFabricCandidateResponse: MessageFns<RevertFabricCandidateResponse> = {
  encode(message: RevertFabricCandidateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.reverted !== false) {
      writer.uint32(16).bool(message.reverted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevertFabricCandidateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevertFabricCandidateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.reverted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevertFabricCandidateResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      reverted: isSet(object.reverted) ? globalThis.Boolean(object.reverted) : false,
    };
  },

  toJSON(message: RevertFabricCandidateResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.reverted !== false) {
      obj.reverted = message.reverted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevertFabricCandidateResponse>, I>>(base?: I): RevertFabricCandidateResponse {
    return RevertFabricCandidateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevertFabricCandidateResponse>, I>>(
    object: I,
  ): RevertFabricCandidateResponse {
    const message = createBaseRevertFabricCandidateResponse();
    message.fabricId = object.fabricId ?? "";
    message.reverted = object.reverted ?? false;
    return message;
  },
};

function createBaseFabricConfig(): FabricConfig {
  return {
    fabric: undefined,
    tenants: [],
    perVlanStp: undefined,
    dciConfigs: [],
    multisites: [],
    revisionId: "0",
    configFp: "",
    comments: "",
    createdBy: "",
    createdAt: undefined,
    swConf: undefined,
  };
}

export const FabricConfig: MessageFns<FabricConfig> = {
  encode(message: FabricConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabric !== undefined) {
      Fabric.encode(message.fabric, writer.uint32(10).fork()).join();
    }
    for (const v of message.tenants) {
      TenantObjects.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.perVlanStp !== undefined) {
      PerVlanStp.encode(message.perVlanStp, writer.uint32(26).fork()).join();
    }
    for (const v of message.dciConfigs) {
      DciConfig.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.multisites) {
      FabricMultisite.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.revisionId !== "0") {
      writer.uint32(120).int64(message.revisionId);
    }
    if (message.configFp !== "") {
      writer.uint32(130).string(message.configFp);
    }
    if (message.comments !== "") {
      writer.uint32(138).string(message.comments);
    }
    if (message.createdBy !== "") {
      writer.uint32(146).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(154).fork()).join();
    }
    if (message.swConf !== undefined) {
      FabricSoftwareConfig.encode(message.swConf, writer.uint32(242).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabric = Fabric.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tenants.push(TenantObjects.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.perVlanStp = PerVlanStp.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.dciConfigs.push(DciConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.multisites.push(FabricMultisite.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.configFp = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.swConf = FabricSoftwareConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricConfig {
    return {
      fabric: isSet(object.fabric) ? Fabric.fromJSON(object.fabric) : undefined,
      tenants: globalThis.Array.isArray(object?.tenants)
        ? object.tenants.map((e: any) => TenantObjects.fromJSON(e))
        : [],
      perVlanStp: isSet(object.perVlanStp) ? PerVlanStp.fromJSON(object.perVlanStp) : undefined,
      dciConfigs: globalThis.Array.isArray(object?.dciConfigs)
        ? object.dciConfigs.map((e: any) => DciConfig.fromJSON(e))
        : [],
      multisites: globalThis.Array.isArray(object?.multisites)
        ? object.multisites.map((e: any) => FabricMultisite.fromJSON(e))
        : [],
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      configFp: isSet(object.configFp) ? globalThis.String(object.configFp) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      swConf: isSet(object.swConf) ? FabricSoftwareConfig.fromJSON(object.swConf) : undefined,
    };
  },

  toJSON(message: FabricConfig): unknown {
    const obj: any = {};
    if (message.fabric !== undefined) {
      obj.fabric = Fabric.toJSON(message.fabric);
    }
    if (message.tenants?.length) {
      obj.tenants = message.tenants.map((e) => TenantObjects.toJSON(e));
    }
    if (message.perVlanStp !== undefined) {
      obj.perVlanStp = PerVlanStp.toJSON(message.perVlanStp);
    }
    if (message.dciConfigs?.length) {
      obj.dciConfigs = message.dciConfigs.map((e) => DciConfig.toJSON(e));
    }
    if (message.multisites?.length) {
      obj.multisites = message.multisites.map((e) => FabricMultisite.toJSON(e));
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.configFp !== "") {
      obj.configFp = message.configFp;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.swConf !== undefined) {
      obj.swConf = FabricSoftwareConfig.toJSON(message.swConf);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricConfig>, I>>(base?: I): FabricConfig {
    return FabricConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricConfig>, I>>(object: I): FabricConfig {
    const message = createBaseFabricConfig();
    message.fabric = (object.fabric !== undefined && object.fabric !== null)
      ? Fabric.fromPartial(object.fabric)
      : undefined;
    message.tenants = object.tenants?.map((e) => TenantObjects.fromPartial(e)) || [];
    message.perVlanStp = (object.perVlanStp !== undefined && object.perVlanStp !== null)
      ? PerVlanStp.fromPartial(object.perVlanStp)
      : undefined;
    message.dciConfigs = object.dciConfigs?.map((e) => DciConfig.fromPartial(e)) || [];
    message.multisites = object.multisites?.map((e) => FabricMultisite.fromPartial(e)) || [];
    message.revisionId = object.revisionId ?? "0";
    message.configFp = object.configFp ?? "";
    message.comments = object.comments ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.swConf = (object.swConf !== undefined && object.swConf !== null)
      ? FabricSoftwareConfig.fromPartial(object.swConf)
      : undefined;
    return message;
  },
};

function createBaseGetFabricConfigRequest(): GetFabricConfigRequest {
  return { candidate: "", fabricId: "", noTenants: false };
}

export const GetFabricConfigRequest: MessageFns<GetFabricConfigRequest> = {
  encode(message: GetFabricConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.noTenants !== false) {
      writer.uint32(24).bool(message.noTenants);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.noTenants = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConfigRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      noTenants: isSet(object.noTenants) ? globalThis.Boolean(object.noTenants) : false,
    };
  },

  toJSON(message: GetFabricConfigRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.noTenants !== false) {
      obj.noTenants = message.noTenants;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConfigRequest>, I>>(base?: I): GetFabricConfigRequest {
    return GetFabricConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConfigRequest>, I>>(object: I): GetFabricConfigRequest {
    const message = createBaseGetFabricConfigRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.noTenants = object.noTenants ?? false;
    return message;
  },
};

function createBaseGetFabricConfigResponse(): GetFabricConfigResponse {
  return { candidate: "", config: undefined };
}

export const GetFabricConfigResponse: MessageFns<GetFabricConfigResponse> = {
  encode(message: GetFabricConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.config !== undefined) {
      FabricConfig.encode(message.config, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.config = FabricConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConfigResponse {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      config: isSet(object.config) ? FabricConfig.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: GetFabricConfigResponse): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.config !== undefined) {
      obj.config = FabricConfig.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConfigResponse>, I>>(base?: I): GetFabricConfigResponse {
    return GetFabricConfigResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConfigResponse>, I>>(object: I): GetFabricConfigResponse {
    const message = createBaseGetFabricConfigResponse();
    message.candidate = object.candidate ?? "";
    message.config = (object.config !== undefined && object.config !== null)
      ? FabricConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseReviewFabricCandidateRequest(): ReviewFabricCandidateRequest {
  return { fabricId: "", name: "", comments: "" };
}

export const ReviewFabricCandidateRequest: MessageFns<ReviewFabricCandidateRequest> = {
  encode(message: ReviewFabricCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.comments !== "") {
      writer.uint32(26).string(message.comments);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewFabricCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewFabricCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewFabricCandidateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
    };
  },

  toJSON(message: ReviewFabricCandidateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewFabricCandidateRequest>, I>>(base?: I): ReviewFabricCandidateRequest {
    return ReviewFabricCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewFabricCandidateRequest>, I>>(object: I): ReviewFabricCandidateRequest {
    const message = createBaseReviewFabricCandidateRequest();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.comments = object.comments ?? "";
    return message;
  },
};

function createBaseReviewFabricCandidateResponse(): ReviewFabricCandidateResponse {
  return { fabricId: "" };
}

export const ReviewFabricCandidateResponse: MessageFns<ReviewFabricCandidateResponse> = {
  encode(message: ReviewFabricCandidateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewFabricCandidateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewFabricCandidateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewFabricCandidateResponse {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: ReviewFabricCandidateResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewFabricCandidateResponse>, I>>(base?: I): ReviewFabricCandidateResponse {
    return ReviewFabricCandidateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewFabricCandidateResponse>, I>>(
    object: I,
  ): ReviewFabricCandidateResponse {
    const message = createBaseReviewFabricCandidateResponse();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetFabricInventoriesRequest(): GetFabricInventoriesRequest {
  return { fabricId: "", topology: 0, nodeIds: [] };
}

export const GetFabricInventoriesRequest: MessageFns<GetFabricInventoriesRequest> = {
  encode(message: GetFabricInventoriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.topology !== 0) {
      writer.uint32(16).int32(message.topology);
    }
    for (const v of message.nodeIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricInventoriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricInventoriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.topology = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricInventoriesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      topology: isSet(object.topology) ? fabricTopologyFromJSON(object.topology) : 0,
      nodeIds: globalThis.Array.isArray(object?.nodeIds) ? object.nodeIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetFabricInventoriesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.topology !== 0) {
      obj.topology = fabricTopologyToJSON(message.topology);
    }
    if (message.nodeIds?.length) {
      obj.nodeIds = message.nodeIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricInventoriesRequest>, I>>(base?: I): GetFabricInventoriesRequest {
    return GetFabricInventoriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricInventoriesRequest>, I>>(object: I): GetFabricInventoriesRequest {
    const message = createBaseGetFabricInventoriesRequest();
    message.fabricId = object.fabricId ?? "";
    message.topology = object.topology ?? 0;
    message.nodeIds = object.nodeIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetFabricInventoriesResponse(): GetFabricInventoriesResponse {
  return { fabrics: [] };
}

export const GetFabricInventoriesResponse: MessageFns<GetFabricInventoriesResponse> = {
  encode(message: GetFabricInventoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabrics) {
      Fabric.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricInventoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricInventoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabrics.push(Fabric.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricInventoriesResponse {
    return {
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => Fabric.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetFabricInventoriesResponse): unknown {
    const obj: any = {};
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => Fabric.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricInventoriesResponse>, I>>(base?: I): GetFabricInventoriesResponse {
    return GetFabricInventoriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricInventoriesResponse>, I>>(object: I): GetFabricInventoriesResponse {
    const message = createBaseGetFabricInventoriesResponse();
    message.fabrics = object.fabrics?.map((e) => Fabric.fromPartial(e)) || [];
    return message;
  },
};

function createBaseActivityEvent(): ActivityEvent {
  return {
    eventId: "0",
    timestamp: undefined,
    username: "",
    objectType: 0,
    objectId: "",
    objectName: "",
    parentType: 0,
    parentId: "",
    operation: 0,
    childId: "",
  };
}

export const ActivityEvent: MessageFns<ActivityEvent> = {
  encode(message: ActivityEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventId !== "0") {
      writer.uint32(8).int64(message.eventId);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(26).fork()).join();
    }
    if (message.username !== "") {
      writer.uint32(34).string(message.username);
    }
    if (message.objectType !== 0) {
      writer.uint32(40).int32(message.objectType);
    }
    if (message.objectId !== "") {
      writer.uint32(50).string(message.objectId);
    }
    if (message.objectName !== "") {
      writer.uint32(58).string(message.objectName);
    }
    if (message.parentType !== 0) {
      writer.uint32(64).int32(message.parentType);
    }
    if (message.parentId !== "") {
      writer.uint32(74).string(message.parentId);
    }
    if (message.operation !== 0) {
      writer.uint32(80).int32(message.operation);
    }
    if (message.childId !== "") {
      writer.uint32(90).string(message.childId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivityEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivityEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.eventId = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.username = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.objectType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.objectId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.objectName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.parentType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.operation = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.childId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivityEvent {
    return {
      eventId: isSet(object.eventId) ? globalThis.String(object.eventId) : "0",
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      objectType: isSet(object.objectType) ? objectTypeFromJSON(object.objectType) : 0,
      objectId: isSet(object.objectId) ? globalThis.String(object.objectId) : "",
      objectName: isSet(object.objectName) ? globalThis.String(object.objectName) : "",
      parentType: isSet(object.parentType) ? objectTypeFromJSON(object.parentType) : 0,
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : "",
      operation: isSet(object.operation) ? operationFromJSON(object.operation) : 0,
      childId: isSet(object.childId) ? globalThis.String(object.childId) : "",
    };
  },

  toJSON(message: ActivityEvent): unknown {
    const obj: any = {};
    if (message.eventId !== "0") {
      obj.eventId = message.eventId;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.objectType !== 0) {
      obj.objectType = objectTypeToJSON(message.objectType);
    }
    if (message.objectId !== "") {
      obj.objectId = message.objectId;
    }
    if (message.objectName !== "") {
      obj.objectName = message.objectName;
    }
    if (message.parentType !== 0) {
      obj.parentType = objectTypeToJSON(message.parentType);
    }
    if (message.parentId !== "") {
      obj.parentId = message.parentId;
    }
    if (message.operation !== 0) {
      obj.operation = operationToJSON(message.operation);
    }
    if (message.childId !== "") {
      obj.childId = message.childId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActivityEvent>, I>>(base?: I): ActivityEvent {
    return ActivityEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActivityEvent>, I>>(object: I): ActivityEvent {
    const message = createBaseActivityEvent();
    message.eventId = object.eventId ?? "0";
    message.timestamp = object.timestamp ?? undefined;
    message.username = object.username ?? "";
    message.objectType = object.objectType ?? 0;
    message.objectId = object.objectId ?? "";
    message.objectName = object.objectName ?? "";
    message.parentType = object.parentType ?? 0;
    message.parentId = object.parentId ?? "";
    message.operation = object.operation ?? 0;
    message.childId = object.childId ?? "";
    return message;
  },
};

function createBaseGetActivityEventsRequest(): GetActivityEventsRequest {
  return {
    startTime: undefined,
    endTime: undefined,
    objectTypes: [],
    objectIds: [],
    usernames: [],
    objectNames: [],
    operations: [],
    pagination: undefined,
  };
}

export const GetActivityEventsRequest: MessageFns<GetActivityEventsRequest> = {
  encode(message: GetActivityEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(18).fork()).join();
    }
    writer.uint32(26).fork();
    for (const v of message.objectTypes) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.objectIds) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.usernames) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.objectNames) {
      writer.uint32(50).string(v!);
    }
    writer.uint32(58).fork();
    for (const v of message.operations) {
      writer.int32(v);
    }
    writer.join();
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActivityEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActivityEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.objectTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.objectTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.objectIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.usernames.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.objectNames.push(reader.string());
          continue;
        }
        case 7: {
          if (tag === 56) {
            message.operations.push(reader.int32() as any);

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.operations.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActivityEventsRequest {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      objectTypes: globalThis.Array.isArray(object?.objectTypes)
        ? object.objectTypes.map((e: any) => objectTypeFromJSON(e))
        : [],
      objectIds: globalThis.Array.isArray(object?.objectIds)
        ? object.objectIds.map((e: any) => globalThis.String(e))
        : [],
      usernames: globalThis.Array.isArray(object?.usernames)
        ? object.usernames.map((e: any) => globalThis.String(e))
        : [],
      objectNames: globalThis.Array.isArray(object?.objectNames)
        ? object.objectNames.map((e: any) => globalThis.String(e))
        : [],
      operations: globalThis.Array.isArray(object?.operations)
        ? object.operations.map((e: any) => operationFromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetActivityEventsRequest): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.objectTypes?.length) {
      obj.objectTypes = message.objectTypes.map((e) => objectTypeToJSON(e));
    }
    if (message.objectIds?.length) {
      obj.objectIds = message.objectIds;
    }
    if (message.usernames?.length) {
      obj.usernames = message.usernames;
    }
    if (message.objectNames?.length) {
      obj.objectNames = message.objectNames;
    }
    if (message.operations?.length) {
      obj.operations = message.operations.map((e) => operationToJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActivityEventsRequest>, I>>(base?: I): GetActivityEventsRequest {
    return GetActivityEventsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActivityEventsRequest>, I>>(object: I): GetActivityEventsRequest {
    const message = createBaseGetActivityEventsRequest();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.objectTypes = object.objectTypes?.map((e) => e) || [];
    message.objectIds = object.objectIds?.map((e) => e) || [];
    message.usernames = object.usernames?.map((e) => e) || [];
    message.objectNames = object.objectNames?.map((e) => e) || [];
    message.operations = object.operations?.map((e) => e) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetActivityEventsResponse(): GetActivityEventsResponse {
  return { events: [], pagination: undefined };
}

export const GetActivityEventsResponse: MessageFns<GetActivityEventsResponse> = {
  encode(message: GetActivityEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      ActivityEvent.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActivityEventsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActivityEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.events.push(ActivityEvent.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActivityEventsResponse {
    return {
      events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => ActivityEvent.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetActivityEventsResponse): unknown {
    const obj: any = {};
    if (message.events?.length) {
      obj.events = message.events.map((e) => ActivityEvent.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActivityEventsResponse>, I>>(base?: I): GetActivityEventsResponse {
    return GetActivityEventsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActivityEventsResponse>, I>>(object: I): GetActivityEventsResponse {
    const message = createBaseGetActivityEventsResponse();
    message.events = object.events?.map((e) => ActivityEvent.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetLabelsRequest(): GetLabelsRequest {
  return {
    startTime: undefined,
    endTime: undefined,
    labels: [],
    objectTypes: [],
    objectIds: [],
    tagsOnly: false,
    pagination: undefined,
  };
}

export const GetLabelsRequest: MessageFns<GetLabelsRequest> = {
  encode(message: GetLabelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(18).fork()).join();
    }
    for (const v of message.labels) {
      writer.uint32(26).string(v!);
    }
    writer.uint32(34).fork();
    for (const v of message.objectTypes) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.objectIds) {
      writer.uint32(42).string(v!);
    }
    if (message.tagsOnly !== false) {
      writer.uint32(48).bool(message.tagsOnly);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLabelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLabelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.objectTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.objectTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.objectIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.tagsOnly = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLabelsRequest {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      objectTypes: globalThis.Array.isArray(object?.objectTypes)
        ? object.objectTypes.map((e: any) => objectTypeFromJSON(e))
        : [],
      objectIds: globalThis.Array.isArray(object?.objectIds)
        ? object.objectIds.map((e: any) => globalThis.String(e))
        : [],
      tagsOnly: isSet(object.tagsOnly) ? globalThis.Boolean(object.tagsOnly) : false,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetLabelsRequest): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.objectTypes?.length) {
      obj.objectTypes = message.objectTypes.map((e) => objectTypeToJSON(e));
    }
    if (message.objectIds?.length) {
      obj.objectIds = message.objectIds;
    }
    if (message.tagsOnly !== false) {
      obj.tagsOnly = message.tagsOnly;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLabelsRequest>, I>>(base?: I): GetLabelsRequest {
    return GetLabelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLabelsRequest>, I>>(object: I): GetLabelsRequest {
    const message = createBaseGetLabelsRequest();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.labels = object.labels?.map((e) => e) || [];
    message.objectTypes = object.objectTypes?.map((e) => e) || [];
    message.objectIds = object.objectIds?.map((e) => e) || [];
    message.tagsOnly = object.tagsOnly ?? false;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetLabelsResponse(): GetLabelsResponse {
  return { labels: [], pagination: undefined };
}

export const GetLabelsResponse: MessageFns<GetLabelsResponse> = {
  encode(message: GetLabelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.labels) {
      Label.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLabelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLabelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.labels.push(Label.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLabelsResponse {
    return {
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => Label.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetLabelsResponse): unknown {
    const obj: any = {};
    if (message.labels?.length) {
      obj.labels = message.labels.map((e) => Label.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLabelsResponse>, I>>(base?: I): GetLabelsResponse {
    return GetLabelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLabelsResponse>, I>>(object: I): GetLabelsResponse {
    const message = createBaseGetLabelsResponse();
    message.labels = object.labels?.map((e) => Label.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetDeviceModelsRequest(): GetDeviceModelsRequest {
  return { modelNames: [], names: [], roles: [] };
}

export const GetDeviceModelsRequest: MessageFns<GetDeviceModelsRequest> = {
  encode(message: GetDeviceModelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.modelNames) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(18).string(v!);
    }
    writer.uint32(26).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDeviceModelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeviceModelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelNames.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeviceModelsRequest {
    return {
      modelNames: globalThis.Array.isArray(object?.modelNames)
        ? object.modelNames.map((e: any) => globalThis.String(e))
        : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => nodeRoleFromJSON(e)) : [],
    };
  },

  toJSON(message: GetDeviceModelsRequest): unknown {
    const obj: any = {};
    if (message.modelNames?.length) {
      obj.modelNames = message.modelNames;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => nodeRoleToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeviceModelsRequest>, I>>(base?: I): GetDeviceModelsRequest {
    return GetDeviceModelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeviceModelsRequest>, I>>(object: I): GetDeviceModelsRequest {
    const message = createBaseGetDeviceModelsRequest();
    message.modelNames = object.modelNames?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.roles = object.roles?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetDeviceModelsResponse(): GetDeviceModelsResponse {
  return { devices: [] };
}

export const GetDeviceModelsResponse: MessageFns<GetDeviceModelsResponse> = {
  encode(message: GetDeviceModelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.devices) {
      DeviceModel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDeviceModelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeviceModelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.devices.push(DeviceModel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeviceModelsResponse {
    return {
      devices: globalThis.Array.isArray(object?.devices) ? object.devices.map((e: any) => DeviceModel.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetDeviceModelsResponse): unknown {
    const obj: any = {};
    if (message.devices?.length) {
      obj.devices = message.devices.map((e) => DeviceModel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeviceModelsResponse>, I>>(base?: I): GetDeviceModelsResponse {
    return GetDeviceModelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeviceModelsResponse>, I>>(object: I): GetDeviceModelsResponse {
    const message = createBaseGetDeviceModelsResponse();
    message.devices = object.devices?.map((e) => DeviceModel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCableModelsRequest(): GetCableModelsRequest {
  return { modelNames: [], speeds: [], connectors: [], cableTypes: [] };
}

export const GetCableModelsRequest: MessageFns<GetCableModelsRequest> = {
  encode(message: GetCableModelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.modelNames) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.speeds) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.connectors) {
      writer.uint32(26).string(v!);
    }
    writer.uint32(34).fork();
    for (const v of message.cableTypes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCableModelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCableModelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelNames.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.speeds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectors.push(reader.string());
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.cableTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cableTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCableModelsRequest {
    return {
      modelNames: globalThis.Array.isArray(object?.modelNames)
        ? object.modelNames.map((e: any) => globalThis.String(e))
        : [],
      speeds: globalThis.Array.isArray(object?.speeds) ? object.speeds.map((e: any) => globalThis.String(e)) : [],
      connectors: globalThis.Array.isArray(object?.connectors)
        ? object.connectors.map((e: any) => globalThis.String(e))
        : [],
      cableTypes: globalThis.Array.isArray(object?.cableTypes)
        ? object.cableTypes.map((e: any) => cableTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCableModelsRequest): unknown {
    const obj: any = {};
    if (message.modelNames?.length) {
      obj.modelNames = message.modelNames;
    }
    if (message.speeds?.length) {
      obj.speeds = message.speeds;
    }
    if (message.connectors?.length) {
      obj.connectors = message.connectors;
    }
    if (message.cableTypes?.length) {
      obj.cableTypes = message.cableTypes.map((e) => cableTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCableModelsRequest>, I>>(base?: I): GetCableModelsRequest {
    return GetCableModelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCableModelsRequest>, I>>(object: I): GetCableModelsRequest {
    const message = createBaseGetCableModelsRequest();
    message.modelNames = object.modelNames?.map((e) => e) || [];
    message.speeds = object.speeds?.map((e) => e) || [];
    message.connectors = object.connectors?.map((e) => e) || [];
    message.cableTypes = object.cableTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetCableModelsResponse(): GetCableModelsResponse {
  return { cables: [] };
}

export const GetCableModelsResponse: MessageFns<GetCableModelsResponse> = {
  encode(message: GetCableModelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cables) {
      CableModel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCableModelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCableModelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cables.push(CableModel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCableModelsResponse {
    return {
      cables: globalThis.Array.isArray(object?.cables) ? object.cables.map((e: any) => CableModel.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetCableModelsResponse): unknown {
    const obj: any = {};
    if (message.cables?.length) {
      obj.cables = message.cables.map((e) => CableModel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCableModelsResponse>, I>>(base?: I): GetCableModelsResponse {
    return GetCableModelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCableModelsResponse>, I>>(object: I): GetCableModelsResponse {
    const message = createBaseGetCableModelsResponse();
    message.cables = object.cables?.map((e) => CableModel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDevicePsuModelsRequest(): GetDevicePsuModelsRequest {
  return { modelNames: [], airflowType: 0 };
}

export const GetDevicePsuModelsRequest: MessageFns<GetDevicePsuModelsRequest> = {
  encode(message: GetDevicePsuModelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.modelNames) {
      writer.uint32(10).string(v!);
    }
    if (message.airflowType !== 0) {
      writer.uint32(16).int32(message.airflowType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDevicePsuModelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDevicePsuModelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelNames.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.airflowType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDevicePsuModelsRequest {
    return {
      modelNames: globalThis.Array.isArray(object?.modelNames)
        ? object.modelNames.map((e: any) => globalThis.String(e))
        : [],
      airflowType: isSet(object.airflowType) ? airflowTypeFromJSON(object.airflowType) : 0,
    };
  },

  toJSON(message: GetDevicePsuModelsRequest): unknown {
    const obj: any = {};
    if (message.modelNames?.length) {
      obj.modelNames = message.modelNames;
    }
    if (message.airflowType !== 0) {
      obj.airflowType = airflowTypeToJSON(message.airflowType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDevicePsuModelsRequest>, I>>(base?: I): GetDevicePsuModelsRequest {
    return GetDevicePsuModelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDevicePsuModelsRequest>, I>>(object: I): GetDevicePsuModelsRequest {
    const message = createBaseGetDevicePsuModelsRequest();
    message.modelNames = object.modelNames?.map((e) => e) || [];
    message.airflowType = object.airflowType ?? 0;
    return message;
  },
};

function createBaseGetServerMgmtCsvTemplateRequest(): GetServerMgmtCsvTemplateRequest {
  return { modelName: "", portGroupType: 0 };
}

export const GetServerMgmtCsvTemplateRequest: MessageFns<GetServerMgmtCsvTemplateRequest> = {
  encode(message: GetServerMgmtCsvTemplateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(10).string(message.modelName);
    }
    if (message.portGroupType !== 0) {
      writer.uint32(16).int32(message.portGroupType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerMgmtCsvTemplateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerMgmtCsvTemplateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.portGroupType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerMgmtCsvTemplateRequest {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      portGroupType: isSet(object.portGroupType) ? serverPortGroupTypeFromJSON(object.portGroupType) : 0,
    };
  },

  toJSON(message: GetServerMgmtCsvTemplateRequest): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.portGroupType !== 0) {
      obj.portGroupType = serverPortGroupTypeToJSON(message.portGroupType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerMgmtCsvTemplateRequest>, I>>(base?: I): GetServerMgmtCsvTemplateRequest {
    return GetServerMgmtCsvTemplateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerMgmtCsvTemplateRequest>, I>>(
    object: I,
  ): GetServerMgmtCsvTemplateRequest {
    const message = createBaseGetServerMgmtCsvTemplateRequest();
    message.modelName = object.modelName ?? "";
    message.portGroupType = object.portGroupType ?? 0;
    return message;
  },
};

function createBaseGetDevicePsuModelsResponse(): GetDevicePsuModelsResponse {
  return { devicePsus: [] };
}

export const GetDevicePsuModelsResponse: MessageFns<GetDevicePsuModelsResponse> = {
  encode(message: GetDevicePsuModelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.devicePsus) {
      DevicePSu.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDevicePsuModelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDevicePsuModelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.devicePsus.push(DevicePSu.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDevicePsuModelsResponse {
    return {
      devicePsus: globalThis.Array.isArray(object?.devicePsus)
        ? object.devicePsus.map((e: any) => DevicePSu.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetDevicePsuModelsResponse): unknown {
    const obj: any = {};
    if (message.devicePsus?.length) {
      obj.devicePsus = message.devicePsus.map((e) => DevicePSu.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDevicePsuModelsResponse>, I>>(base?: I): GetDevicePsuModelsResponse {
    return GetDevicePsuModelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDevicePsuModelsResponse>, I>>(object: I): GetDevicePsuModelsResponse {
    const message = createBaseGetDevicePsuModelsResponse();
    message.devicePsus = object.devicePsus?.map((e) => DevicePSu.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHwPart(): HwPart {
  return { name: "", modelName: "", partStatus: 0, serialNumber: "", quantity: 0 };
}

export const HwPart: MessageFns<HwPart> = {
  encode(message: HwPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.modelName !== "") {
      writer.uint32(18).string(message.modelName);
    }
    if (message.partStatus !== 0) {
      writer.uint32(24).int32(message.partStatus);
    }
    if (message.serialNumber !== "") {
      writer.uint32(34).string(message.serialNumber);
    }
    if (message.quantity !== 0) {
      writer.uint32(40).uint32(message.quantity);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HwPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHwPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.partStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.quantity = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HwPart {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      partStatus: isSet(object.partStatus) ? partStatusFromJSON(object.partStatus) : 0,
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
    };
  },

  toJSON(message: HwPart): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.partStatus !== 0) {
      obj.partStatus = partStatusToJSON(message.partStatus);
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HwPart>, I>>(base?: I): HwPart {
    return HwPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HwPart>, I>>(object: I): HwPart {
    const message = createBaseHwPart();
    message.name = object.name ?? "";
    message.modelName = object.modelName ?? "";
    message.partStatus = object.partStatus ?? 0;
    message.serialNumber = object.serialNumber ?? "";
    message.quantity = object.quantity ?? 0;
    return message;
  },
};

function createBaseHwParts(): HwParts {
  return { totalQuantity: 0, parts: [], description: "" };
}

export const HwParts: MessageFns<HwParts> = {
  encode(message: HwParts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalQuantity !== 0) {
      writer.uint32(8).uint32(message.totalQuantity);
    }
    for (const v of message.parts) {
      HwPart.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HwParts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHwParts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalQuantity = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.parts.push(HwPart.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HwParts {
    return {
      totalQuantity: isSet(object.totalQuantity) ? globalThis.Number(object.totalQuantity) : 0,
      parts: globalThis.Array.isArray(object?.parts) ? object.parts.map((e: any) => HwPart.fromJSON(e)) : [],
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: HwParts): unknown {
    const obj: any = {};
    if (message.totalQuantity !== 0) {
      obj.totalQuantity = Math.round(message.totalQuantity);
    }
    if (message.parts?.length) {
      obj.parts = message.parts.map((e) => HwPart.toJSON(e));
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HwParts>, I>>(base?: I): HwParts {
    return HwParts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HwParts>, I>>(object: I): HwParts {
    const message = createBaseHwParts();
    message.totalQuantity = object.totalQuantity ?? 0;
    message.parts = object.parts?.map((e) => HwPart.fromPartial(e)) || [];
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseNodeHwPart(): NodeHwPart {
  return {
    nodeName: "",
    modelName: "",
    description: "",
    partStatus: 0,
    serialNumber: "",
    opticsHwParts: [],
    fanParts: [],
    powerSupplyParts: [],
    monitored: false,
  };
}

export const NodeHwPart: MessageFns<NodeHwPart> = {
  encode(message: NodeHwPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    if (message.modelName !== "") {
      writer.uint32(18).string(message.modelName);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.partStatus !== 0) {
      writer.uint32(32).int32(message.partStatus);
    }
    if (message.serialNumber !== "") {
      writer.uint32(42).string(message.serialNumber);
    }
    for (const v of message.opticsHwParts) {
      HwParts.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.fanParts) {
      HwParts.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.powerSupplyParts) {
      HwParts.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.monitored !== false) {
      writer.uint32(72).bool(message.monitored);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeHwPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeHwPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.partStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.opticsHwParts.push(HwParts.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fanParts.push(HwParts.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.powerSupplyParts.push(HwParts.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeHwPart {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      partStatus: isSet(object.partStatus) ? partStatusFromJSON(object.partStatus) : 0,
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      opticsHwParts: globalThis.Array.isArray(object?.opticsHwParts)
        ? object.opticsHwParts.map((e: any) => HwParts.fromJSON(e))
        : [],
      fanParts: globalThis.Array.isArray(object?.fanParts) ? object.fanParts.map((e: any) => HwParts.fromJSON(e)) : [],
      powerSupplyParts: globalThis.Array.isArray(object?.powerSupplyParts)
        ? object.powerSupplyParts.map((e: any) => HwParts.fromJSON(e))
        : [],
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
    };
  },

  toJSON(message: NodeHwPart): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.partStatus !== 0) {
      obj.partStatus = partStatusToJSON(message.partStatus);
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.opticsHwParts?.length) {
      obj.opticsHwParts = message.opticsHwParts.map((e) => HwParts.toJSON(e));
    }
    if (message.fanParts?.length) {
      obj.fanParts = message.fanParts.map((e) => HwParts.toJSON(e));
    }
    if (message.powerSupplyParts?.length) {
      obj.powerSupplyParts = message.powerSupplyParts.map((e) => HwParts.toJSON(e));
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeHwPart>, I>>(base?: I): NodeHwPart {
    return NodeHwPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeHwPart>, I>>(object: I): NodeHwPart {
    const message = createBaseNodeHwPart();
    message.nodeName = object.nodeName ?? "";
    message.modelName = object.modelName ?? "";
    message.description = object.description ?? "";
    message.partStatus = object.partStatus ?? 0;
    message.serialNumber = object.serialNumber ?? "";
    message.opticsHwParts = object.opticsHwParts?.map((e) => HwParts.fromPartial(e)) || [];
    message.fanParts = object.fanParts?.map((e) => HwParts.fromPartial(e)) || [];
    message.powerSupplyParts = object.powerSupplyParts?.map((e) => HwParts.fromPartial(e)) || [];
    message.monitored = object.monitored ?? false;
    return message;
  },
};

function createBaseGetFabricAssemblyRequest(): GetFabricAssemblyRequest {
  return { fabricId: "", candidate: "" };
}

export const GetFabricAssemblyRequest: MessageFns<GetFabricAssemblyRequest> = {
  encode(message: GetFabricAssemblyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricAssemblyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricAssemblyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricAssemblyRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetFabricAssemblyRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricAssemblyRequest>, I>>(base?: I): GetFabricAssemblyRequest {
    return GetFabricAssemblyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricAssemblyRequest>, I>>(object: I): GetFabricAssemblyRequest {
    const message = createBaseGetFabricAssemblyRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetFabricAssemblyResponse(): GetFabricAssemblyResponse {
  return { nodeHwParts: [], creationTime: undefined, updatedTime: undefined };
}

export const GetFabricAssemblyResponse: MessageFns<GetFabricAssemblyResponse> = {
  encode(message: GetFabricAssemblyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodeHwParts) {
      NodeHwPart.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.creationTime !== undefined) {
      Timestamp.encode(toTimestamp(message.creationTime), writer.uint32(18).fork()).join();
    }
    if (message.updatedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTime), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricAssemblyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricAssemblyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeHwParts.push(NodeHwPart.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.creationTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricAssemblyResponse {
    return {
      nodeHwParts: globalThis.Array.isArray(object?.nodeHwParts)
        ? object.nodeHwParts.map((e: any) => NodeHwPart.fromJSON(e))
        : [],
      creationTime: isSet(object.creationTime) ? fromJsonTimestamp(object.creationTime) : undefined,
      updatedTime: isSet(object.updatedTime) ? fromJsonTimestamp(object.updatedTime) : undefined,
    };
  },

  toJSON(message: GetFabricAssemblyResponse): unknown {
    const obj: any = {};
    if (message.nodeHwParts?.length) {
      obj.nodeHwParts = message.nodeHwParts.map((e) => NodeHwPart.toJSON(e));
    }
    if (message.creationTime !== undefined) {
      obj.creationTime = message.creationTime.toISOString();
    }
    if (message.updatedTime !== undefined) {
      obj.updatedTime = message.updatedTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricAssemblyResponse>, I>>(base?: I): GetFabricAssemblyResponse {
    return GetFabricAssemblyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricAssemblyResponse>, I>>(object: I): GetFabricAssemblyResponse {
    const message = createBaseGetFabricAssemblyResponse();
    message.nodeHwParts = object.nodeHwParts?.map((e) => NodeHwPart.fromPartial(e)) || [];
    message.creationTime = object.creationTime ?? undefined;
    message.updatedTime = object.updatedTime ?? undefined;
    return message;
  },
};

function createBaseBomItem(): BomItem {
  return {
    modelName: "",
    description: "",
    quantityDeployed: 0,
    quantityRequired: 0,
    quantityTotal: 0,
    itemType: 0,
    tags: [],
    subItems: [],
  };
}

export const BomItem: MessageFns<BomItem> = {
  encode(message: BomItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(10).string(message.modelName);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.quantityDeployed !== 0) {
      writer.uint32(24).uint32(message.quantityDeployed);
    }
    if (message.quantityRequired !== 0) {
      writer.uint32(32).uint32(message.quantityRequired);
    }
    if (message.quantityTotal !== 0) {
      writer.uint32(40).uint32(message.quantityTotal);
    }
    if (message.itemType !== 0) {
      writer.uint32(48).int32(message.itemType);
    }
    for (const v of message.tags) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.subItems) {
      BomItem.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BomItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBomItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.quantityDeployed = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.quantityRequired = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.quantityTotal = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.itemType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.subItems.push(BomItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BomItem {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      quantityDeployed: isSet(object.quantityDeployed) ? globalThis.Number(object.quantityDeployed) : 0,
      quantityRequired: isSet(object.quantityRequired) ? globalThis.Number(object.quantityRequired) : 0,
      quantityTotal: isSet(object.quantityTotal) ? globalThis.Number(object.quantityTotal) : 0,
      itemType: isSet(object.itemType) ? bomTypeFromJSON(object.itemType) : 0,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      subItems: globalThis.Array.isArray(object?.subItems) ? object.subItems.map((e: any) => BomItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: BomItem): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.quantityDeployed !== 0) {
      obj.quantityDeployed = Math.round(message.quantityDeployed);
    }
    if (message.quantityRequired !== 0) {
      obj.quantityRequired = Math.round(message.quantityRequired);
    }
    if (message.quantityTotal !== 0) {
      obj.quantityTotal = Math.round(message.quantityTotal);
    }
    if (message.itemType !== 0) {
      obj.itemType = bomTypeToJSON(message.itemType);
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.subItems?.length) {
      obj.subItems = message.subItems.map((e) => BomItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BomItem>, I>>(base?: I): BomItem {
    return BomItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BomItem>, I>>(object: I): BomItem {
    const message = createBaseBomItem();
    message.modelName = object.modelName ?? "";
    message.description = object.description ?? "";
    message.quantityDeployed = object.quantityDeployed ?? 0;
    message.quantityRequired = object.quantityRequired ?? 0;
    message.quantityTotal = object.quantityTotal ?? 0;
    message.itemType = object.itemType ?? 0;
    message.tags = object.tags?.map((e) => e) || [];
    message.subItems = object.subItems?.map((e) => BomItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetFabricBomRequest(): GetFabricBomRequest {
  return { fabricId: "", candidate: "" };
}

export const GetFabricBomRequest: MessageFns<GetFabricBomRequest> = {
  encode(message: GetFabricBomRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBomRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBomRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBomRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetFabricBomRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBomRequest>, I>>(base?: I): GetFabricBomRequest {
    return GetFabricBomRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBomRequest>, I>>(object: I): GetFabricBomRequest {
    const message = createBaseGetFabricBomRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetFabricBomResponse(): GetFabricBomResponse {
  return { mainItems: [], creationTime: undefined, updatedTime: undefined };
}

export const GetFabricBomResponse: MessageFns<GetFabricBomResponse> = {
  encode(message: GetFabricBomResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mainItems) {
      BomItem.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.creationTime !== undefined) {
      Timestamp.encode(toTimestamp(message.creationTime), writer.uint32(18).fork()).join();
    }
    if (message.updatedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedTime), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBomResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBomResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mainItems.push(BomItem.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.creationTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBomResponse {
    return {
      mainItems: globalThis.Array.isArray(object?.mainItems)
        ? object.mainItems.map((e: any) => BomItem.fromJSON(e))
        : [],
      creationTime: isSet(object.creationTime) ? fromJsonTimestamp(object.creationTime) : undefined,
      updatedTime: isSet(object.updatedTime) ? fromJsonTimestamp(object.updatedTime) : undefined,
    };
  },

  toJSON(message: GetFabricBomResponse): unknown {
    const obj: any = {};
    if (message.mainItems?.length) {
      obj.mainItems = message.mainItems.map((e) => BomItem.toJSON(e));
    }
    if (message.creationTime !== undefined) {
      obj.creationTime = message.creationTime.toISOString();
    }
    if (message.updatedTime !== undefined) {
      obj.updatedTime = message.updatedTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBomResponse>, I>>(base?: I): GetFabricBomResponse {
    return GetFabricBomResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBomResponse>, I>>(object: I): GetFabricBomResponse {
    const message = createBaseGetFabricBomResponse();
    message.mainItems = object.mainItems?.map((e) => BomItem.fromPartial(e)) || [];
    message.creationTime = object.creationTime ?? undefined;
    message.updatedTime = object.updatedTime ?? undefined;
    return message;
  },
};

function createBaseCreateFabricBomEstimateRequest(): CreateFabricBomEstimateRequest {
  return { fabricId: "", candidate: "", createdBy: "", mainItems: [] };
}

export const CreateFabricBomEstimateRequest: MessageFns<CreateFabricBomEstimateRequest> = {
  encode(message: CreateFabricBomEstimateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    for (const v of message.mainItems) {
      BomItem.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFabricBomEstimateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFabricBomEstimateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mainItems.push(BomItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFabricBomEstimateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      mainItems: globalThis.Array.isArray(object?.mainItems)
        ? object.mainItems.map((e: any) => BomItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateFabricBomEstimateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.mainItems?.length) {
      obj.mainItems = message.mainItems.map((e) => BomItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFabricBomEstimateRequest>, I>>(base?: I): CreateFabricBomEstimateRequest {
    return CreateFabricBomEstimateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFabricBomEstimateRequest>, I>>(
    object: I,
  ): CreateFabricBomEstimateRequest {
    const message = createBaseCreateFabricBomEstimateRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.createdBy = object.createdBy ?? "";
    message.mainItems = object.mainItems?.map((e) => BomItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateFabricBomEstimateResponse(): CreateFabricBomEstimateResponse {
  return { fabricId: "", estimateId: "" };
}

export const CreateFabricBomEstimateResponse: MessageFns<CreateFabricBomEstimateResponse> = {
  encode(message: CreateFabricBomEstimateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.estimateId !== "") {
      writer.uint32(18).string(message.estimateId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFabricBomEstimateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFabricBomEstimateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.estimateId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFabricBomEstimateResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      estimateId: isSet(object.estimateId) ? globalThis.String(object.estimateId) : "",
    };
  },

  toJSON(message: CreateFabricBomEstimateResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.estimateId !== "") {
      obj.estimateId = message.estimateId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFabricBomEstimateResponse>, I>>(base?: I): CreateFabricBomEstimateResponse {
    return CreateFabricBomEstimateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFabricBomEstimateResponse>, I>>(
    object: I,
  ): CreateFabricBomEstimateResponse {
    const message = createBaseCreateFabricBomEstimateResponse();
    message.fabricId = object.fabricId ?? "";
    message.estimateId = object.estimateId ?? "";
    return message;
  },
};

function createBaseGetFabricBomEstimatesRequest(): GetFabricBomEstimatesRequest {
  return { fabricId: "" };
}

export const GetFabricBomEstimatesRequest: MessageFns<GetFabricBomEstimatesRequest> = {
  encode(message: GetFabricBomEstimatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBomEstimatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBomEstimatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBomEstimatesRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: GetFabricBomEstimatesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBomEstimatesRequest>, I>>(base?: I): GetFabricBomEstimatesRequest {
    return GetFabricBomEstimatesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBomEstimatesRequest>, I>>(object: I): GetFabricBomEstimatesRequest {
    const message = createBaseGetFabricBomEstimatesRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseEstimate(): Estimate {
  return { estimateId: "", createdBy: "", createdAt: undefined, status: 0 };
}

export const Estimate: MessageFns<Estimate> = {
  encode(message: Estimate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.estimateId !== "") {
      writer.uint32(10).string(message.estimateId);
    }
    if (message.createdBy !== "") {
      writer.uint32(18).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Estimate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.estimateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Estimate {
    return {
      estimateId: isSet(object.estimateId) ? globalThis.String(object.estimateId) : "",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      status: isSet(object.status) ? estimateStatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: Estimate): unknown {
    const obj: any = {};
    if (message.estimateId !== "") {
      obj.estimateId = message.estimateId;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.status !== 0) {
      obj.status = estimateStatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Estimate>, I>>(base?: I): Estimate {
    return Estimate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Estimate>, I>>(object: I): Estimate {
    const message = createBaseEstimate();
    message.estimateId = object.estimateId ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseGetFabricBomEstimatesResponse(): GetFabricBomEstimatesResponse {
  return { fabricId: "", estimates: [] };
}

export const GetFabricBomEstimatesResponse: MessageFns<GetFabricBomEstimatesResponse> = {
  encode(message: GetFabricBomEstimatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.estimates) {
      Estimate.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBomEstimatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBomEstimatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.estimates.push(Estimate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBomEstimatesResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      estimates: globalThis.Array.isArray(object?.estimates)
        ? object.estimates.map((e: any) => Estimate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetFabricBomEstimatesResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.estimates?.length) {
      obj.estimates = message.estimates.map((e) => Estimate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBomEstimatesResponse>, I>>(base?: I): GetFabricBomEstimatesResponse {
    return GetFabricBomEstimatesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBomEstimatesResponse>, I>>(
    object: I,
  ): GetFabricBomEstimatesResponse {
    const message = createBaseGetFabricBomEstimatesResponse();
    message.fabricId = object.fabricId ?? "";
    message.estimates = object.estimates?.map((e) => Estimate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetFabricBomForEstimateRequest(): GetFabricBomForEstimateRequest {
  return { fabricId: "", estimateId: "" };
}

export const GetFabricBomForEstimateRequest: MessageFns<GetFabricBomForEstimateRequest> = {
  encode(message: GetFabricBomForEstimateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.estimateId !== "") {
      writer.uint32(18).string(message.estimateId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBomForEstimateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBomForEstimateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.estimateId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBomForEstimateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      estimateId: isSet(object.estimateId) ? globalThis.String(object.estimateId) : "",
    };
  },

  toJSON(message: GetFabricBomForEstimateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.estimateId !== "") {
      obj.estimateId = message.estimateId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBomForEstimateRequest>, I>>(base?: I): GetFabricBomForEstimateRequest {
    return GetFabricBomForEstimateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBomForEstimateRequest>, I>>(
    object: I,
  ): GetFabricBomForEstimateRequest {
    const message = createBaseGetFabricBomForEstimateRequest();
    message.fabricId = object.fabricId ?? "";
    message.estimateId = object.estimateId ?? "";
    return message;
  },
};

function createBaseGetFabricBomForEstimateResponse(): GetFabricBomForEstimateResponse {
  return { fabricId: "", estimateId: "", bomData: new Uint8Array(0) };
}

export const GetFabricBomForEstimateResponse: MessageFns<GetFabricBomForEstimateResponse> = {
  encode(message: GetFabricBomForEstimateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.estimateId !== "") {
      writer.uint32(18).string(message.estimateId);
    }
    if (message.bomData.length !== 0) {
      writer.uint32(26).bytes(message.bomData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBomForEstimateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBomForEstimateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.estimateId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bomData = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBomForEstimateResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      estimateId: isSet(object.estimateId) ? globalThis.String(object.estimateId) : "",
      bomData: isSet(object.bomData) ? bytesFromBase64(object.bomData) : new Uint8Array(0),
    };
  },

  toJSON(message: GetFabricBomForEstimateResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.estimateId !== "") {
      obj.estimateId = message.estimateId;
    }
    if (message.bomData.length !== 0) {
      obj.bomData = base64FromBytes(message.bomData);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBomForEstimateResponse>, I>>(base?: I): GetFabricBomForEstimateResponse {
    return GetFabricBomForEstimateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBomForEstimateResponse>, I>>(
    object: I,
  ): GetFabricBomForEstimateResponse {
    const message = createBaseGetFabricBomForEstimateResponse();
    message.fabricId = object.fabricId ?? "";
    message.estimateId = object.estimateId ?? "";
    message.bomData = object.bomData ?? new Uint8Array(0);
    return message;
  },
};

function createBaseAddNodesToFabricRequest(): AddNodesToFabricRequest {
  return { fabricId: "", nodes: [] };
}

export const AddNodesToFabricRequest: MessageFns<AddNodesToFabricRequest> = {
  encode(message: AddNodesToFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.nodes) {
      Node.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddNodesToFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddNodesToFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddNodesToFabricRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => Node.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddNodesToFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => Node.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddNodesToFabricRequest>, I>>(base?: I): AddNodesToFabricRequest {
    return AddNodesToFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddNodesToFabricRequest>, I>>(object: I): AddNodesToFabricRequest {
    const message = createBaseAddNodesToFabricRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodes = object.nodes?.map((e) => Node.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddNodesToFabricResponse(): AddNodesToFabricResponse {
  return { nodes: [] };
}

export const AddNodesToFabricResponse: MessageFns<AddNodesToFabricResponse> = {
  encode(message: AddNodesToFabricResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodes) {
      Node.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddNodesToFabricResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddNodesToFabricResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddNodesToFabricResponse {
    return { nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => Node.fromJSON(e)) : [] };
  },

  toJSON(message: AddNodesToFabricResponse): unknown {
    const obj: any = {};
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => Node.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddNodesToFabricResponse>, I>>(base?: I): AddNodesToFabricResponse {
    return AddNodesToFabricResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddNodesToFabricResponse>, I>>(object: I): AddNodesToFabricResponse {
    const message = createBaseAddNodesToFabricResponse();
    message.nodes = object.nodes?.map((e) => Node.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeleteNodeFromFabricRequest(): DeleteNodeFromFabricRequest {
  return { fabricId: "", nodeId: "" };
}

export const DeleteNodeFromFabricRequest: MessageFns<DeleteNodeFromFabricRequest> = {
  encode(message: DeleteNodeFromFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteNodeFromFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteNodeFromFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteNodeFromFabricRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
    };
  },

  toJSON(message: DeleteNodeFromFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteNodeFromFabricRequest>, I>>(base?: I): DeleteNodeFromFabricRequest {
    return DeleteNodeFromFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteNodeFromFabricRequest>, I>>(object: I): DeleteNodeFromFabricRequest {
    const message = createBaseDeleteNodeFromFabricRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    return message;
  },
};

function createBaseDeleteNodeFromFabricResponse(): DeleteNodeFromFabricResponse {
  return { fabricId: "", nodeId: "" };
}

export const DeleteNodeFromFabricResponse: MessageFns<DeleteNodeFromFabricResponse> = {
  encode(message: DeleteNodeFromFabricResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteNodeFromFabricResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteNodeFromFabricResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteNodeFromFabricResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
    };
  },

  toJSON(message: DeleteNodeFromFabricResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteNodeFromFabricResponse>, I>>(base?: I): DeleteNodeFromFabricResponse {
    return DeleteNodeFromFabricResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteNodeFromFabricResponse>, I>>(object: I): DeleteNodeFromFabricResponse {
    const message = createBaseDeleteNodeFromFabricResponse();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    return message;
  },
};

function createBaseBindDeviceRequest(): BindDeviceRequest {
  return { fabricId: "", nodeId: "", deviceId: "" };
}

export const BindDeviceRequest: MessageFns<BindDeviceRequest> = {
  encode(message: BindDeviceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BindDeviceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBindDeviceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BindDeviceRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: BindDeviceRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BindDeviceRequest>, I>>(base?: I): BindDeviceRequest {
    return BindDeviceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BindDeviceRequest>, I>>(object: I): BindDeviceRequest {
    const message = createBaseBindDeviceRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseBindDeviceResponse(): BindDeviceResponse {
  return { nodeId: "", deviceId: "" };
}

export const BindDeviceResponse: MessageFns<BindDeviceResponse> = {
  encode(message: BindDeviceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BindDeviceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBindDeviceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BindDeviceResponse {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: BindDeviceResponse): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BindDeviceResponse>, I>>(base?: I): BindDeviceResponse {
    return BindDeviceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BindDeviceResponse>, I>>(object: I): BindDeviceResponse {
    const message = createBaseBindDeviceResponse();
    message.nodeId = object.nodeId ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseUnbindDeviceRequest(): UnbindDeviceRequest {
  return { fabricId: "", nodeId: "" };
}

export const UnbindDeviceRequest: MessageFns<UnbindDeviceRequest> = {
  encode(message: UnbindDeviceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnbindDeviceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnbindDeviceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnbindDeviceRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
    };
  },

  toJSON(message: UnbindDeviceRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnbindDeviceRequest>, I>>(base?: I): UnbindDeviceRequest {
    return UnbindDeviceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnbindDeviceRequest>, I>>(object: I): UnbindDeviceRequest {
    const message = createBaseUnbindDeviceRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    return message;
  },
};

function createBaseUnbindDeviceResponse(): UnbindDeviceResponse {
  return { nodeId: "" };
}

export const UnbindDeviceResponse: MessageFns<UnbindDeviceResponse> = {
  encode(message: UnbindDeviceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnbindDeviceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnbindDeviceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnbindDeviceResponse {
    return { nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "" };
  },

  toJSON(message: UnbindDeviceResponse): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnbindDeviceResponse>, I>>(base?: I): UnbindDeviceResponse {
    return UnbindDeviceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnbindDeviceResponse>, I>>(object: I): UnbindDeviceResponse {
    const message = createBaseUnbindDeviceResponse();
    message.nodeId = object.nodeId ?? "";
    return message;
  },
};

function createBaseGetNodeConnectionsRequest(): GetNodeConnectionsRequest {
  return { fabricId: "", nodeId: "", candidate: "" };
}

export const GetNodeConnectionsRequest: MessageFns<GetNodeConnectionsRequest> = {
  encode(message: GetNodeConnectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodeConnectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodeConnectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodeConnectionsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetNodeConnectionsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodeConnectionsRequest>, I>>(base?: I): GetNodeConnectionsRequest {
    return GetNodeConnectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodeConnectionsRequest>, I>>(object: I): GetNodeConnectionsRequest {
    const message = createBaseGetNodeConnectionsRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetNodeConnectionsResponse(): GetNodeConnectionsResponse {
  return { nodeId: "", connections: [] };
}

export const GetNodeConnectionsResponse: MessageFns<GetNodeConnectionsResponse> = {
  encode(message: GetNodeConnectionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNodeConnectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNodeConnectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNodeConnectionsResponse {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetNodeConnectionsResponse): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNodeConnectionsResponse>, I>>(base?: I): GetNodeConnectionsResponse {
    return GetNodeConnectionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNodeConnectionsResponse>, I>>(object: I): GetNodeConnectionsResponse {
    const message = createBaseGetNodeConnectionsResponse();
    message.nodeId = object.nodeId ?? "";
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetLimitsRequest(): GetLimitsRequest {
  return { verifiedLimits: false };
}

export const GetLimitsRequest: MessageFns<GetLimitsRequest> = {
  encode(message: GetLimitsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.verifiedLimits !== false) {
      writer.uint32(8).bool(message.verifiedLimits);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLimitsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLimitsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.verifiedLimits = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLimitsRequest {
    return { verifiedLimits: isSet(object.verifiedLimits) ? globalThis.Boolean(object.verifiedLimits) : false };
  },

  toJSON(message: GetLimitsRequest): unknown {
    const obj: any = {};
    if (message.verifiedLimits !== false) {
      obj.verifiedLimits = message.verifiedLimits;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLimitsRequest>, I>>(base?: I): GetLimitsRequest {
    return GetLimitsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLimitsRequest>, I>>(object: I): GetLimitsRequest {
    const message = createBaseGetLimitsRequest();
    message.verifiedLimits = object.verifiedLimits ?? false;
    return message;
  },
};

function createBaseGetLimitsResponse(): GetLimitsResponse {
  return {
    maxSpines: 0,
    maxLeaves: 0,
    maxPortIndex: 0,
    maxAnnotations: 0,
    minUserVlanId: 0,
    maxUserVlanId: 0,
    minUserVni: 0,
    maxUserVni: 0,
    minIpv4Mask: 0,
    minIpv6Mask: 0,
    maxBreakoutsPerPort: 0,
    maxBreakoutsPerNode: 0,
    maxVnisPerFabric: 0,
    maxVrfsPerFabric: 0,
    maxVlanMembers: 0,
    maxInterfacesPerVrf: 0,
    maxSubInfPerPort: 0,
    maxSubInfPerNode: 0,
    maxStaticRoutesPerGroup: 0,
    maxStaticRoutesPerVrf: 0,
    maxRouteGroupsPerFabric: 0,
    maxDhcpRelaysPerVrf: 0,
    maxPortChannelsPerFabric: 0,
    maxLoopbacksPerNode: 0,
    maxPrefixesPerList: 0,
    maxBgpPeersPerVrf: 0,
    maxBgpPolicies: 0,
    maxPrefixLists: 0,
    maxEndpoints: 0,
    minLoopbackId: 0,
    maxLoopbackId: 0,
    minPortChannelId: 0,
    maxPortChannelId: 0,
    maxNotificationEndpoints: 0,
    maxNotificationSettings: 0,
    maxBgpLoopbacks: 0,
    maxDhcpRelaysPerFabric: 0,
    maxPortChannelsPerNode: 0,
    maxFabrics: 0,
    maxVlansPerNode: 0,
    maxServers: 0,
    maxPortConnections: 0,
    maxSwitches: 0,
    maxTiers: 0,
    maxSwitchGroupsPerTier: 0,
    maxServerGroupsPerTier: 0,
    maxPanelsPerDashboard: 0,
    verified: undefined,
  };
}

export const GetLimitsResponse: MessageFns<GetLimitsResponse> = {
  encode(message: GetLimitsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxSpines !== 0) {
      writer.uint32(8).uint32(message.maxSpines);
    }
    if (message.maxLeaves !== 0) {
      writer.uint32(16).uint32(message.maxLeaves);
    }
    if (message.maxPortIndex !== 0) {
      writer.uint32(24).uint32(message.maxPortIndex);
    }
    if (message.maxAnnotations !== 0) {
      writer.uint32(32).uint32(message.maxAnnotations);
    }
    if (message.minUserVlanId !== 0) {
      writer.uint32(40).uint32(message.minUserVlanId);
    }
    if (message.maxUserVlanId !== 0) {
      writer.uint32(48).uint32(message.maxUserVlanId);
    }
    if (message.minUserVni !== 0) {
      writer.uint32(56).uint32(message.minUserVni);
    }
    if (message.maxUserVni !== 0) {
      writer.uint32(64).uint32(message.maxUserVni);
    }
    if (message.minIpv4Mask !== 0) {
      writer.uint32(72).uint32(message.minIpv4Mask);
    }
    if (message.minIpv6Mask !== 0) {
      writer.uint32(80).uint32(message.minIpv6Mask);
    }
    if (message.maxBreakoutsPerPort !== 0) {
      writer.uint32(88).uint32(message.maxBreakoutsPerPort);
    }
    if (message.maxBreakoutsPerNode !== 0) {
      writer.uint32(96).uint32(message.maxBreakoutsPerNode);
    }
    if (message.maxVnisPerFabric !== 0) {
      writer.uint32(112).uint32(message.maxVnisPerFabric);
    }
    if (message.maxVrfsPerFabric !== 0) {
      writer.uint32(120).uint32(message.maxVrfsPerFabric);
    }
    if (message.maxVlanMembers !== 0) {
      writer.uint32(128).uint32(message.maxVlanMembers);
    }
    if (message.maxInterfacesPerVrf !== 0) {
      writer.uint32(136).uint32(message.maxInterfacesPerVrf);
    }
    if (message.maxSubInfPerPort !== 0) {
      writer.uint32(144).uint32(message.maxSubInfPerPort);
    }
    if (message.maxSubInfPerNode !== 0) {
      writer.uint32(152).uint32(message.maxSubInfPerNode);
    }
    if (message.maxStaticRoutesPerGroup !== 0) {
      writer.uint32(160).uint32(message.maxStaticRoutesPerGroup);
    }
    if (message.maxStaticRoutesPerVrf !== 0) {
      writer.uint32(168).uint32(message.maxStaticRoutesPerVrf);
    }
    if (message.maxRouteGroupsPerFabric !== 0) {
      writer.uint32(176).uint32(message.maxRouteGroupsPerFabric);
    }
    if (message.maxDhcpRelaysPerVrf !== 0) {
      writer.uint32(184).uint32(message.maxDhcpRelaysPerVrf);
    }
    if (message.maxPortChannelsPerFabric !== 0) {
      writer.uint32(192).uint32(message.maxPortChannelsPerFabric);
    }
    if (message.maxLoopbacksPerNode !== 0) {
      writer.uint32(200).uint32(message.maxLoopbacksPerNode);
    }
    if (message.maxPrefixesPerList !== 0) {
      writer.uint32(208).uint32(message.maxPrefixesPerList);
    }
    if (message.maxBgpPeersPerVrf !== 0) {
      writer.uint32(216).uint32(message.maxBgpPeersPerVrf);
    }
    if (message.maxBgpPolicies !== 0) {
      writer.uint32(224).uint32(message.maxBgpPolicies);
    }
    if (message.maxPrefixLists !== 0) {
      writer.uint32(232).uint32(message.maxPrefixLists);
    }
    if (message.maxEndpoints !== 0) {
      writer.uint32(240).uint32(message.maxEndpoints);
    }
    if (message.minLoopbackId !== 0) {
      writer.uint32(248).uint32(message.minLoopbackId);
    }
    if (message.maxLoopbackId !== 0) {
      writer.uint32(256).uint32(message.maxLoopbackId);
    }
    if (message.minPortChannelId !== 0) {
      writer.uint32(264).uint32(message.minPortChannelId);
    }
    if (message.maxPortChannelId !== 0) {
      writer.uint32(272).uint32(message.maxPortChannelId);
    }
    if (message.maxNotificationEndpoints !== 0) {
      writer.uint32(280).uint32(message.maxNotificationEndpoints);
    }
    if (message.maxNotificationSettings !== 0) {
      writer.uint32(288).uint32(message.maxNotificationSettings);
    }
    if (message.maxBgpLoopbacks !== 0) {
      writer.uint32(296).uint32(message.maxBgpLoopbacks);
    }
    if (message.maxDhcpRelaysPerFabric !== 0) {
      writer.uint32(304).uint32(message.maxDhcpRelaysPerFabric);
    }
    if (message.maxPortChannelsPerNode !== 0) {
      writer.uint32(312).uint32(message.maxPortChannelsPerNode);
    }
    if (message.maxFabrics !== 0) {
      writer.uint32(320).uint32(message.maxFabrics);
    }
    if (message.maxVlansPerNode !== 0) {
      writer.uint32(328).uint32(message.maxVlansPerNode);
    }
    if (message.maxServers !== 0) {
      writer.uint32(336).uint32(message.maxServers);
    }
    if (message.maxPortConnections !== 0) {
      writer.uint32(344).uint32(message.maxPortConnections);
    }
    if (message.maxSwitches !== 0) {
      writer.uint32(352).uint32(message.maxSwitches);
    }
    if (message.maxTiers !== 0) {
      writer.uint32(360).uint32(message.maxTiers);
    }
    if (message.maxSwitchGroupsPerTier !== 0) {
      writer.uint32(368).uint32(message.maxSwitchGroupsPerTier);
    }
    if (message.maxServerGroupsPerTier !== 0) {
      writer.uint32(376).uint32(message.maxServerGroupsPerTier);
    }
    if (message.maxPanelsPerDashboard !== 0) {
      writer.uint32(384).uint32(message.maxPanelsPerDashboard);
    }
    if (message.verified !== undefined) {
      VerifiedScaleLimits.encode(message.verified, writer.uint32(402).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLimitsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLimitsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.maxSpines = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.maxLeaves = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxPortIndex = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxAnnotations = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.minUserVlanId = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxUserVlanId = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.minUserVni = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.maxUserVni = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.minIpv4Mask = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.minIpv6Mask = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maxBreakoutsPerPort = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maxBreakoutsPerNode = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.maxVnisPerFabric = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.maxVrfsPerFabric = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.maxVlanMembers = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.maxInterfacesPerVrf = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.maxSubInfPerPort = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.maxSubInfPerNode = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.maxStaticRoutesPerGroup = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.maxStaticRoutesPerVrf = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.maxRouteGroupsPerFabric = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.maxDhcpRelaysPerVrf = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.maxPortChannelsPerFabric = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.maxLoopbacksPerNode = reader.uint32();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.maxPrefixesPerList = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.maxBgpPeersPerVrf = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.maxBgpPolicies = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.maxPrefixLists = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.maxEndpoints = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.minLoopbackId = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.maxLoopbackId = reader.uint32();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.minPortChannelId = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.maxPortChannelId = reader.uint32();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.maxNotificationEndpoints = reader.uint32();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.maxNotificationSettings = reader.uint32();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.maxBgpLoopbacks = reader.uint32();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.maxDhcpRelaysPerFabric = reader.uint32();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.maxPortChannelsPerNode = reader.uint32();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.maxFabrics = reader.uint32();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.maxVlansPerNode = reader.uint32();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.maxServers = reader.uint32();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.maxPortConnections = reader.uint32();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.maxSwitches = reader.uint32();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.maxTiers = reader.uint32();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.maxSwitchGroupsPerTier = reader.uint32();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.maxServerGroupsPerTier = reader.uint32();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.maxPanelsPerDashboard = reader.uint32();
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.verified = VerifiedScaleLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLimitsResponse {
    return {
      maxSpines: isSet(object.maxSpines) ? globalThis.Number(object.maxSpines) : 0,
      maxLeaves: isSet(object.maxLeaves) ? globalThis.Number(object.maxLeaves) : 0,
      maxPortIndex: isSet(object.maxPortIndex) ? globalThis.Number(object.maxPortIndex) : 0,
      maxAnnotations: isSet(object.maxAnnotations) ? globalThis.Number(object.maxAnnotations) : 0,
      minUserVlanId: isSet(object.minUserVlanId) ? globalThis.Number(object.minUserVlanId) : 0,
      maxUserVlanId: isSet(object.maxUserVlanId) ? globalThis.Number(object.maxUserVlanId) : 0,
      minUserVni: isSet(object.minUserVni) ? globalThis.Number(object.minUserVni) : 0,
      maxUserVni: isSet(object.maxUserVni) ? globalThis.Number(object.maxUserVni) : 0,
      minIpv4Mask: isSet(object.minIpv4Mask) ? globalThis.Number(object.minIpv4Mask) : 0,
      minIpv6Mask: isSet(object.minIpv6Mask) ? globalThis.Number(object.minIpv6Mask) : 0,
      maxBreakoutsPerPort: isSet(object.maxBreakoutsPerPort) ? globalThis.Number(object.maxBreakoutsPerPort) : 0,
      maxBreakoutsPerNode: isSet(object.maxBreakoutsPerNode) ? globalThis.Number(object.maxBreakoutsPerNode) : 0,
      maxVnisPerFabric: isSet(object.maxVnisPerFabric) ? globalThis.Number(object.maxVnisPerFabric) : 0,
      maxVrfsPerFabric: isSet(object.maxVrfsPerFabric) ? globalThis.Number(object.maxVrfsPerFabric) : 0,
      maxVlanMembers: isSet(object.maxVlanMembers) ? globalThis.Number(object.maxVlanMembers) : 0,
      maxInterfacesPerVrf: isSet(object.maxInterfacesPerVrf) ? globalThis.Number(object.maxInterfacesPerVrf) : 0,
      maxSubInfPerPort: isSet(object.maxSubInfPerPort) ? globalThis.Number(object.maxSubInfPerPort) : 0,
      maxSubInfPerNode: isSet(object.maxSubInfPerNode) ? globalThis.Number(object.maxSubInfPerNode) : 0,
      maxStaticRoutesPerGroup: isSet(object.maxStaticRoutesPerGroup)
        ? globalThis.Number(object.maxStaticRoutesPerGroup)
        : 0,
      maxStaticRoutesPerVrf: isSet(object.maxStaticRoutesPerVrf) ? globalThis.Number(object.maxStaticRoutesPerVrf) : 0,
      maxRouteGroupsPerFabric: isSet(object.maxRouteGroupsPerFabric)
        ? globalThis.Number(object.maxRouteGroupsPerFabric)
        : 0,
      maxDhcpRelaysPerVrf: isSet(object.maxDhcpRelaysPerVrf) ? globalThis.Number(object.maxDhcpRelaysPerVrf) : 0,
      maxPortChannelsPerFabric: isSet(object.maxPortChannelsPerFabric)
        ? globalThis.Number(object.maxPortChannelsPerFabric)
        : 0,
      maxLoopbacksPerNode: isSet(object.maxLoopbacksPerNode) ? globalThis.Number(object.maxLoopbacksPerNode) : 0,
      maxPrefixesPerList: isSet(object.maxPrefixesPerList) ? globalThis.Number(object.maxPrefixesPerList) : 0,
      maxBgpPeersPerVrf: isSet(object.maxBgpPeersPerVrf) ? globalThis.Number(object.maxBgpPeersPerVrf) : 0,
      maxBgpPolicies: isSet(object.maxBgpPolicies) ? globalThis.Number(object.maxBgpPolicies) : 0,
      maxPrefixLists: isSet(object.maxPrefixLists) ? globalThis.Number(object.maxPrefixLists) : 0,
      maxEndpoints: isSet(object.maxEndpoints) ? globalThis.Number(object.maxEndpoints) : 0,
      minLoopbackId: isSet(object.minLoopbackId) ? globalThis.Number(object.minLoopbackId) : 0,
      maxLoopbackId: isSet(object.maxLoopbackId) ? globalThis.Number(object.maxLoopbackId) : 0,
      minPortChannelId: isSet(object.minPortChannelId) ? globalThis.Number(object.minPortChannelId) : 0,
      maxPortChannelId: isSet(object.maxPortChannelId) ? globalThis.Number(object.maxPortChannelId) : 0,
      maxNotificationEndpoints: isSet(object.maxNotificationEndpoints)
        ? globalThis.Number(object.maxNotificationEndpoints)
        : 0,
      maxNotificationSettings: isSet(object.maxNotificationSettings)
        ? globalThis.Number(object.maxNotificationSettings)
        : 0,
      maxBgpLoopbacks: isSet(object.maxBgpLoopbacks) ? globalThis.Number(object.maxBgpLoopbacks) : 0,
      maxDhcpRelaysPerFabric: isSet(object.maxDhcpRelaysPerFabric)
        ? globalThis.Number(object.maxDhcpRelaysPerFabric)
        : 0,
      maxPortChannelsPerNode: isSet(object.maxPortChannelsPerNode)
        ? globalThis.Number(object.maxPortChannelsPerNode)
        : 0,
      maxFabrics: isSet(object.maxFabrics) ? globalThis.Number(object.maxFabrics) : 0,
      maxVlansPerNode: isSet(object.maxVlansPerNode) ? globalThis.Number(object.maxVlansPerNode) : 0,
      maxServers: isSet(object.maxServers) ? globalThis.Number(object.maxServers) : 0,
      maxPortConnections: isSet(object.maxPortConnections) ? globalThis.Number(object.maxPortConnections) : 0,
      maxSwitches: isSet(object.maxSwitches) ? globalThis.Number(object.maxSwitches) : 0,
      maxTiers: isSet(object.maxTiers) ? globalThis.Number(object.maxTiers) : 0,
      maxSwitchGroupsPerTier: isSet(object.maxSwitchGroupsPerTier)
        ? globalThis.Number(object.maxSwitchGroupsPerTier)
        : 0,
      maxServerGroupsPerTier: isSet(object.maxServerGroupsPerTier)
        ? globalThis.Number(object.maxServerGroupsPerTier)
        : 0,
      maxPanelsPerDashboard: isSet(object.maxPanelsPerDashboard) ? globalThis.Number(object.maxPanelsPerDashboard) : 0,
      verified: isSet(object.verified) ? VerifiedScaleLimits.fromJSON(object.verified) : undefined,
    };
  },

  toJSON(message: GetLimitsResponse): unknown {
    const obj: any = {};
    if (message.maxSpines !== 0) {
      obj.maxSpines = Math.round(message.maxSpines);
    }
    if (message.maxLeaves !== 0) {
      obj.maxLeaves = Math.round(message.maxLeaves);
    }
    if (message.maxPortIndex !== 0) {
      obj.maxPortIndex = Math.round(message.maxPortIndex);
    }
    if (message.maxAnnotations !== 0) {
      obj.maxAnnotations = Math.round(message.maxAnnotations);
    }
    if (message.minUserVlanId !== 0) {
      obj.minUserVlanId = Math.round(message.minUserVlanId);
    }
    if (message.maxUserVlanId !== 0) {
      obj.maxUserVlanId = Math.round(message.maxUserVlanId);
    }
    if (message.minUserVni !== 0) {
      obj.minUserVni = Math.round(message.minUserVni);
    }
    if (message.maxUserVni !== 0) {
      obj.maxUserVni = Math.round(message.maxUserVni);
    }
    if (message.minIpv4Mask !== 0) {
      obj.minIpv4Mask = Math.round(message.minIpv4Mask);
    }
    if (message.minIpv6Mask !== 0) {
      obj.minIpv6Mask = Math.round(message.minIpv6Mask);
    }
    if (message.maxBreakoutsPerPort !== 0) {
      obj.maxBreakoutsPerPort = Math.round(message.maxBreakoutsPerPort);
    }
    if (message.maxBreakoutsPerNode !== 0) {
      obj.maxBreakoutsPerNode = Math.round(message.maxBreakoutsPerNode);
    }
    if (message.maxVnisPerFabric !== 0) {
      obj.maxVnisPerFabric = Math.round(message.maxVnisPerFabric);
    }
    if (message.maxVrfsPerFabric !== 0) {
      obj.maxVrfsPerFabric = Math.round(message.maxVrfsPerFabric);
    }
    if (message.maxVlanMembers !== 0) {
      obj.maxVlanMembers = Math.round(message.maxVlanMembers);
    }
    if (message.maxInterfacesPerVrf !== 0) {
      obj.maxInterfacesPerVrf = Math.round(message.maxInterfacesPerVrf);
    }
    if (message.maxSubInfPerPort !== 0) {
      obj.maxSubInfPerPort = Math.round(message.maxSubInfPerPort);
    }
    if (message.maxSubInfPerNode !== 0) {
      obj.maxSubInfPerNode = Math.round(message.maxSubInfPerNode);
    }
    if (message.maxStaticRoutesPerGroup !== 0) {
      obj.maxStaticRoutesPerGroup = Math.round(message.maxStaticRoutesPerGroup);
    }
    if (message.maxStaticRoutesPerVrf !== 0) {
      obj.maxStaticRoutesPerVrf = Math.round(message.maxStaticRoutesPerVrf);
    }
    if (message.maxRouteGroupsPerFabric !== 0) {
      obj.maxRouteGroupsPerFabric = Math.round(message.maxRouteGroupsPerFabric);
    }
    if (message.maxDhcpRelaysPerVrf !== 0) {
      obj.maxDhcpRelaysPerVrf = Math.round(message.maxDhcpRelaysPerVrf);
    }
    if (message.maxPortChannelsPerFabric !== 0) {
      obj.maxPortChannelsPerFabric = Math.round(message.maxPortChannelsPerFabric);
    }
    if (message.maxLoopbacksPerNode !== 0) {
      obj.maxLoopbacksPerNode = Math.round(message.maxLoopbacksPerNode);
    }
    if (message.maxPrefixesPerList !== 0) {
      obj.maxPrefixesPerList = Math.round(message.maxPrefixesPerList);
    }
    if (message.maxBgpPeersPerVrf !== 0) {
      obj.maxBgpPeersPerVrf = Math.round(message.maxBgpPeersPerVrf);
    }
    if (message.maxBgpPolicies !== 0) {
      obj.maxBgpPolicies = Math.round(message.maxBgpPolicies);
    }
    if (message.maxPrefixLists !== 0) {
      obj.maxPrefixLists = Math.round(message.maxPrefixLists);
    }
    if (message.maxEndpoints !== 0) {
      obj.maxEndpoints = Math.round(message.maxEndpoints);
    }
    if (message.minLoopbackId !== 0) {
      obj.minLoopbackId = Math.round(message.minLoopbackId);
    }
    if (message.maxLoopbackId !== 0) {
      obj.maxLoopbackId = Math.round(message.maxLoopbackId);
    }
    if (message.minPortChannelId !== 0) {
      obj.minPortChannelId = Math.round(message.minPortChannelId);
    }
    if (message.maxPortChannelId !== 0) {
      obj.maxPortChannelId = Math.round(message.maxPortChannelId);
    }
    if (message.maxNotificationEndpoints !== 0) {
      obj.maxNotificationEndpoints = Math.round(message.maxNotificationEndpoints);
    }
    if (message.maxNotificationSettings !== 0) {
      obj.maxNotificationSettings = Math.round(message.maxNotificationSettings);
    }
    if (message.maxBgpLoopbacks !== 0) {
      obj.maxBgpLoopbacks = Math.round(message.maxBgpLoopbacks);
    }
    if (message.maxDhcpRelaysPerFabric !== 0) {
      obj.maxDhcpRelaysPerFabric = Math.round(message.maxDhcpRelaysPerFabric);
    }
    if (message.maxPortChannelsPerNode !== 0) {
      obj.maxPortChannelsPerNode = Math.round(message.maxPortChannelsPerNode);
    }
    if (message.maxFabrics !== 0) {
      obj.maxFabrics = Math.round(message.maxFabrics);
    }
    if (message.maxVlansPerNode !== 0) {
      obj.maxVlansPerNode = Math.round(message.maxVlansPerNode);
    }
    if (message.maxServers !== 0) {
      obj.maxServers = Math.round(message.maxServers);
    }
    if (message.maxPortConnections !== 0) {
      obj.maxPortConnections = Math.round(message.maxPortConnections);
    }
    if (message.maxSwitches !== 0) {
      obj.maxSwitches = Math.round(message.maxSwitches);
    }
    if (message.maxTiers !== 0) {
      obj.maxTiers = Math.round(message.maxTiers);
    }
    if (message.maxSwitchGroupsPerTier !== 0) {
      obj.maxSwitchGroupsPerTier = Math.round(message.maxSwitchGroupsPerTier);
    }
    if (message.maxServerGroupsPerTier !== 0) {
      obj.maxServerGroupsPerTier = Math.round(message.maxServerGroupsPerTier);
    }
    if (message.maxPanelsPerDashboard !== 0) {
      obj.maxPanelsPerDashboard = Math.round(message.maxPanelsPerDashboard);
    }
    if (message.verified !== undefined) {
      obj.verified = VerifiedScaleLimits.toJSON(message.verified);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLimitsResponse>, I>>(base?: I): GetLimitsResponse {
    return GetLimitsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLimitsResponse>, I>>(object: I): GetLimitsResponse {
    const message = createBaseGetLimitsResponse();
    message.maxSpines = object.maxSpines ?? 0;
    message.maxLeaves = object.maxLeaves ?? 0;
    message.maxPortIndex = object.maxPortIndex ?? 0;
    message.maxAnnotations = object.maxAnnotations ?? 0;
    message.minUserVlanId = object.minUserVlanId ?? 0;
    message.maxUserVlanId = object.maxUserVlanId ?? 0;
    message.minUserVni = object.minUserVni ?? 0;
    message.maxUserVni = object.maxUserVni ?? 0;
    message.minIpv4Mask = object.minIpv4Mask ?? 0;
    message.minIpv6Mask = object.minIpv6Mask ?? 0;
    message.maxBreakoutsPerPort = object.maxBreakoutsPerPort ?? 0;
    message.maxBreakoutsPerNode = object.maxBreakoutsPerNode ?? 0;
    message.maxVnisPerFabric = object.maxVnisPerFabric ?? 0;
    message.maxVrfsPerFabric = object.maxVrfsPerFabric ?? 0;
    message.maxVlanMembers = object.maxVlanMembers ?? 0;
    message.maxInterfacesPerVrf = object.maxInterfacesPerVrf ?? 0;
    message.maxSubInfPerPort = object.maxSubInfPerPort ?? 0;
    message.maxSubInfPerNode = object.maxSubInfPerNode ?? 0;
    message.maxStaticRoutesPerGroup = object.maxStaticRoutesPerGroup ?? 0;
    message.maxStaticRoutesPerVrf = object.maxStaticRoutesPerVrf ?? 0;
    message.maxRouteGroupsPerFabric = object.maxRouteGroupsPerFabric ?? 0;
    message.maxDhcpRelaysPerVrf = object.maxDhcpRelaysPerVrf ?? 0;
    message.maxPortChannelsPerFabric = object.maxPortChannelsPerFabric ?? 0;
    message.maxLoopbacksPerNode = object.maxLoopbacksPerNode ?? 0;
    message.maxPrefixesPerList = object.maxPrefixesPerList ?? 0;
    message.maxBgpPeersPerVrf = object.maxBgpPeersPerVrf ?? 0;
    message.maxBgpPolicies = object.maxBgpPolicies ?? 0;
    message.maxPrefixLists = object.maxPrefixLists ?? 0;
    message.maxEndpoints = object.maxEndpoints ?? 0;
    message.minLoopbackId = object.minLoopbackId ?? 0;
    message.maxLoopbackId = object.maxLoopbackId ?? 0;
    message.minPortChannelId = object.minPortChannelId ?? 0;
    message.maxPortChannelId = object.maxPortChannelId ?? 0;
    message.maxNotificationEndpoints = object.maxNotificationEndpoints ?? 0;
    message.maxNotificationSettings = object.maxNotificationSettings ?? 0;
    message.maxBgpLoopbacks = object.maxBgpLoopbacks ?? 0;
    message.maxDhcpRelaysPerFabric = object.maxDhcpRelaysPerFabric ?? 0;
    message.maxPortChannelsPerNode = object.maxPortChannelsPerNode ?? 0;
    message.maxFabrics = object.maxFabrics ?? 0;
    message.maxVlansPerNode = object.maxVlansPerNode ?? 0;
    message.maxServers = object.maxServers ?? 0;
    message.maxPortConnections = object.maxPortConnections ?? 0;
    message.maxSwitches = object.maxSwitches ?? 0;
    message.maxTiers = object.maxTiers ?? 0;
    message.maxSwitchGroupsPerTier = object.maxSwitchGroupsPerTier ?? 0;
    message.maxServerGroupsPerTier = object.maxServerGroupsPerTier ?? 0;
    message.maxPanelsPerDashboard = object.maxPanelsPerDashboard ?? 0;
    message.verified = (object.verified !== undefined && object.verified !== null)
      ? VerifiedScaleLimits.fromPartial(object.verified)
      : undefined;
    return message;
  },
};

function createBaseVerifiedScaleLimits(): VerifiedScaleLimits {
  return {
    maxVlans: 0,
    maxType2Routes: 0,
    maxVrfs: 0,
    maxSvis: 0,
    maxIpv4Routes: 0,
    maxIpv6Routes: 0,
    maxStaticRoutes: 0,
    maxBgpPolicies: 0,
    maxDhcpRelayVlans: 0,
    maxSwitches: 0,
    maxServers: 0,
    maxPortConnections: 0,
    maxNetworkPorts: 0,
    maxBgpPeersPerSwitch: 0,
  };
}

export const VerifiedScaleLimits: MessageFns<VerifiedScaleLimits> = {
  encode(message: VerifiedScaleLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxVlans !== 0) {
      writer.uint32(8).uint32(message.maxVlans);
    }
    if (message.maxType2Routes !== 0) {
      writer.uint32(16).uint32(message.maxType2Routes);
    }
    if (message.maxVrfs !== 0) {
      writer.uint32(24).uint32(message.maxVrfs);
    }
    if (message.maxSvis !== 0) {
      writer.uint32(32).uint32(message.maxSvis);
    }
    if (message.maxIpv4Routes !== 0) {
      writer.uint32(40).uint32(message.maxIpv4Routes);
    }
    if (message.maxIpv6Routes !== 0) {
      writer.uint32(48).uint32(message.maxIpv6Routes);
    }
    if (message.maxStaticRoutes !== 0) {
      writer.uint32(56).uint32(message.maxStaticRoutes);
    }
    if (message.maxBgpPolicies !== 0) {
      writer.uint32(64).uint32(message.maxBgpPolicies);
    }
    if (message.maxDhcpRelayVlans !== 0) {
      writer.uint32(72).uint32(message.maxDhcpRelayVlans);
    }
    if (message.maxSwitches !== 0) {
      writer.uint32(80).uint32(message.maxSwitches);
    }
    if (message.maxServers !== 0) {
      writer.uint32(88).uint32(message.maxServers);
    }
    if (message.maxPortConnections !== 0) {
      writer.uint32(96).uint32(message.maxPortConnections);
    }
    if (message.maxNetworkPorts !== 0) {
      writer.uint32(104).uint32(message.maxNetworkPorts);
    }
    if (message.maxBgpPeersPerSwitch !== 0) {
      writer.uint32(112).uint32(message.maxBgpPeersPerSwitch);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifiedScaleLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifiedScaleLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.maxVlans = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.maxType2Routes = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxVrfs = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxSvis = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxIpv4Routes = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxIpv6Routes = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxStaticRoutes = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.maxBgpPolicies = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.maxDhcpRelayVlans = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.maxSwitches = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.maxServers = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.maxPortConnections = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.maxNetworkPorts = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.maxBgpPeersPerSwitch = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifiedScaleLimits {
    return {
      maxVlans: isSet(object.maxVlans) ? globalThis.Number(object.maxVlans) : 0,
      maxType2Routes: isSet(object.maxType2Routes) ? globalThis.Number(object.maxType2Routes) : 0,
      maxVrfs: isSet(object.maxVrfs) ? globalThis.Number(object.maxVrfs) : 0,
      maxSvis: isSet(object.maxSvis) ? globalThis.Number(object.maxSvis) : 0,
      maxIpv4Routes: isSet(object.maxIpv4Routes) ? globalThis.Number(object.maxIpv4Routes) : 0,
      maxIpv6Routes: isSet(object.maxIpv6Routes) ? globalThis.Number(object.maxIpv6Routes) : 0,
      maxStaticRoutes: isSet(object.maxStaticRoutes) ? globalThis.Number(object.maxStaticRoutes) : 0,
      maxBgpPolicies: isSet(object.maxBgpPolicies) ? globalThis.Number(object.maxBgpPolicies) : 0,
      maxDhcpRelayVlans: isSet(object.maxDhcpRelayVlans) ? globalThis.Number(object.maxDhcpRelayVlans) : 0,
      maxSwitches: isSet(object.maxSwitches) ? globalThis.Number(object.maxSwitches) : 0,
      maxServers: isSet(object.maxServers) ? globalThis.Number(object.maxServers) : 0,
      maxPortConnections: isSet(object.maxPortConnections) ? globalThis.Number(object.maxPortConnections) : 0,
      maxNetworkPorts: isSet(object.maxNetworkPorts) ? globalThis.Number(object.maxNetworkPorts) : 0,
      maxBgpPeersPerSwitch: isSet(object.maxBgpPeersPerSwitch) ? globalThis.Number(object.maxBgpPeersPerSwitch) : 0,
    };
  },

  toJSON(message: VerifiedScaleLimits): unknown {
    const obj: any = {};
    if (message.maxVlans !== 0) {
      obj.maxVlans = Math.round(message.maxVlans);
    }
    if (message.maxType2Routes !== 0) {
      obj.maxType2Routes = Math.round(message.maxType2Routes);
    }
    if (message.maxVrfs !== 0) {
      obj.maxVrfs = Math.round(message.maxVrfs);
    }
    if (message.maxSvis !== 0) {
      obj.maxSvis = Math.round(message.maxSvis);
    }
    if (message.maxIpv4Routes !== 0) {
      obj.maxIpv4Routes = Math.round(message.maxIpv4Routes);
    }
    if (message.maxIpv6Routes !== 0) {
      obj.maxIpv6Routes = Math.round(message.maxIpv6Routes);
    }
    if (message.maxStaticRoutes !== 0) {
      obj.maxStaticRoutes = Math.round(message.maxStaticRoutes);
    }
    if (message.maxBgpPolicies !== 0) {
      obj.maxBgpPolicies = Math.round(message.maxBgpPolicies);
    }
    if (message.maxDhcpRelayVlans !== 0) {
      obj.maxDhcpRelayVlans = Math.round(message.maxDhcpRelayVlans);
    }
    if (message.maxSwitches !== 0) {
      obj.maxSwitches = Math.round(message.maxSwitches);
    }
    if (message.maxServers !== 0) {
      obj.maxServers = Math.round(message.maxServers);
    }
    if (message.maxPortConnections !== 0) {
      obj.maxPortConnections = Math.round(message.maxPortConnections);
    }
    if (message.maxNetworkPorts !== 0) {
      obj.maxNetworkPorts = Math.round(message.maxNetworkPorts);
    }
    if (message.maxBgpPeersPerSwitch !== 0) {
      obj.maxBgpPeersPerSwitch = Math.round(message.maxBgpPeersPerSwitch);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifiedScaleLimits>, I>>(base?: I): VerifiedScaleLimits {
    return VerifiedScaleLimits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifiedScaleLimits>, I>>(object: I): VerifiedScaleLimits {
    const message = createBaseVerifiedScaleLimits();
    message.maxVlans = object.maxVlans ?? 0;
    message.maxType2Routes = object.maxType2Routes ?? 0;
    message.maxVrfs = object.maxVrfs ?? 0;
    message.maxSvis = object.maxSvis ?? 0;
    message.maxIpv4Routes = object.maxIpv4Routes ?? 0;
    message.maxIpv6Routes = object.maxIpv6Routes ?? 0;
    message.maxStaticRoutes = object.maxStaticRoutes ?? 0;
    message.maxBgpPolicies = object.maxBgpPolicies ?? 0;
    message.maxDhcpRelayVlans = object.maxDhcpRelayVlans ?? 0;
    message.maxSwitches = object.maxSwitches ?? 0;
    message.maxServers = object.maxServers ?? 0;
    message.maxPortConnections = object.maxPortConnections ?? 0;
    message.maxNetworkPorts = object.maxNetworkPorts ?? 0;
    message.maxBgpPeersPerSwitch = object.maxBgpPeersPerSwitch ?? 0;
    return message;
  },
};

function createBaseSyncPortStateRequest(): SyncPortStateRequest {
  return { fabricId: "", nodeId: "", name: "", enabled: false };
}

export const SyncPortStateRequest: MessageFns<SyncPortStateRequest> = {
  encode(message: SyncPortStateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SyncPortStateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyncPortStateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SyncPortStateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: SyncPortStateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SyncPortStateRequest>, I>>(base?: I): SyncPortStateRequest {
    return SyncPortStateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SyncPortStateRequest>, I>>(object: I): SyncPortStateRequest {
    const message = createBaseSyncPortStateRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseSyncPortStateResponse(): SyncPortStateResponse {
  return { fabricId: "", nodeId: "", name: "", enabled: false };
}

export const SyncPortStateResponse: MessageFns<SyncPortStateResponse> = {
  encode(message: SyncPortStateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SyncPortStateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyncPortStateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SyncPortStateResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: SyncPortStateResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SyncPortStateResponse>, I>>(base?: I): SyncPortStateResponse {
    return SyncPortStateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SyncPortStateResponse>, I>>(object: I): SyncPortStateResponse {
    const message = createBaseSyncPortStateResponse();
    message.fabricId = object.fabricId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseGetIpmConfigsRequest(): GetIpmConfigsRequest {
  return { candidate: "", fabricId: "", ids: [], names: [] };
}

export const GetIpmConfigsRequest: MessageFns<GetIpmConfigsRequest> = {
  encode(message: GetIpmConfigsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIpmConfigsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIpmConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIpmConfigsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetIpmConfigsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetIpmConfigsRequest>, I>>(base?: I): GetIpmConfigsRequest {
    return GetIpmConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetIpmConfigsRequest>, I>>(object: I): GetIpmConfigsRequest {
    const message = createBaseGetIpmConfigsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetDscpConfigsRequest(): GetDscpConfigsRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], defaultOnly: false };
}

export const GetDscpConfigsRequest: MessageFns<GetDscpConfigsRequest> = {
  encode(message: GetDscpConfigsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    if (message.defaultOnly !== false) {
      writer.uint32(40).bool(message.defaultOnly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDscpConfigsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDscpConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.defaultOnly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDscpConfigsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      defaultOnly: isSet(object.defaultOnly) ? globalThis.Boolean(object.defaultOnly) : false,
    };
  },

  toJSON(message: GetDscpConfigsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.defaultOnly !== false) {
      obj.defaultOnly = message.defaultOnly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDscpConfigsRequest>, I>>(base?: I): GetDscpConfigsRequest {
    return GetDscpConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDscpConfigsRequest>, I>>(object: I): GetDscpConfigsRequest {
    const message = createBaseGetDscpConfigsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.defaultOnly = object.defaultOnly ?? false;
    return message;
  },
};

function createBaseGetPacketMirroringsRequest(): GetPacketMirroringsRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], defaultOnly: false };
}

export const GetPacketMirroringsRequest: MessageFns<GetPacketMirroringsRequest> = {
  encode(message: GetPacketMirroringsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    if (message.defaultOnly !== false) {
      writer.uint32(40).bool(message.defaultOnly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPacketMirroringsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPacketMirroringsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.defaultOnly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPacketMirroringsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      defaultOnly: isSet(object.defaultOnly) ? globalThis.Boolean(object.defaultOnly) : false,
    };
  },

  toJSON(message: GetPacketMirroringsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.defaultOnly !== false) {
      obj.defaultOnly = message.defaultOnly;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPacketMirroringsRequest>, I>>(base?: I): GetPacketMirroringsRequest {
    return GetPacketMirroringsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPacketMirroringsRequest>, I>>(object: I): GetPacketMirroringsRequest {
    const message = createBaseGetPacketMirroringsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.defaultOnly = object.defaultOnly ?? false;
    return message;
  },
};

function createBaseGetIpSlaConfigsRequest(): GetIpSlaConfigsRequest {
  return { candidate: "", fabricId: "", ids: [], names: [], prefixes: [] };
}

export const GetIpSlaConfigsRequest: MessageFns<GetIpSlaConfigsRequest> = {
  encode(message: GetIpSlaConfigsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.prefixes) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIpSlaConfigsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIpSlaConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.prefixes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIpSlaConfigsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      prefixes: globalThis.Array.isArray(object?.prefixes) ? object.prefixes.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetIpSlaConfigsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.prefixes?.length) {
      obj.prefixes = message.prefixes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetIpSlaConfigsRequest>, I>>(base?: I): GetIpSlaConfigsRequest {
    return GetIpSlaConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetIpSlaConfigsRequest>, I>>(object: I): GetIpSlaConfigsRequest {
    const message = createBaseGetIpSlaConfigsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.prefixes = object.prefixes?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetArsConfigsRequest(): GetArsConfigsRequest {
  return { candidate: "", fabricId: "", ids: [], names: [] };
}

export const GetArsConfigsRequest: MessageFns<GetArsConfigsRequest> = {
  encode(message: GetArsConfigsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== "") {
      writer.uint32(10).string(message.candidate);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetArsConfigsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetArsConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetArsConfigsRequest {
    return {
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetArsConfigsRequest): unknown {
    const obj: any = {};
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetArsConfigsRequest>, I>>(base?: I): GetArsConfigsRequest {
    return GetArsConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetArsConfigsRequest>, I>>(object: I): GetArsConfigsRequest {
    const message = createBaseGetArsConfigsRequest();
    message.candidate = object.candidate ?? "";
    message.fabricId = object.fabricId ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseExportFabricConfigurationRequest(): ExportFabricConfigurationRequest {
  return { fabricId: "", candidate: "", password: "" };
}

export const ExportFabricConfigurationRequest: MessageFns<ExportFabricConfigurationRequest> = {
  encode(message: ExportFabricConfigurationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportFabricConfigurationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportFabricConfigurationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportFabricConfigurationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: ExportFabricConfigurationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportFabricConfigurationRequest>, I>>(
    base?: I,
  ): ExportFabricConfigurationRequest {
    return ExportFabricConfigurationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportFabricConfigurationRequest>, I>>(
    object: I,
  ): ExportFabricConfigurationRequest {
    const message = createBaseExportFabricConfigurationRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseExportedFabricConfiguration(): ExportedFabricConfiguration {
  return {
    fabricId: "",
    renameAs: "",
    schema: "",
    createdAt: undefined,
    fabric: undefined,
    connections: [],
    portBreakouts: [],
    nodes: [],
    perVlanStps: [],
    networkPorts: [],
    loopbacks: [],
    vrfs: [],
    portChannels: [],
    vnis: [],
    staticRoutes: [],
    dhcpRelays: [],
    subInterfaces: [],
    bgpPolicies: [],
    bgpPeers: [],
    ipmConfigs: [],
    dscpConfigs: [],
    packetMirrorings: [],
    serverMgmtPorts: [],
    ipSlaConfigs: [],
    arsConfigs: [],
    background: false,
    password: "",
    passwordHash: "",
  };
}

export const ExportedFabricConfiguration: MessageFns<ExportedFabricConfiguration> = {
  encode(message: ExportedFabricConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.renameAs !== "") {
      writer.uint32(202).string(message.renameAs);
    }
    if (message.schema !== "") {
      writer.uint32(18).string(message.schema);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.fabric !== undefined) {
      Fabric.encode(message.fabric, writer.uint32(34).fork()).join();
    }
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.portBreakouts) {
      PortBreakout.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.nodes) {
      Node.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.perVlanStps) {
      PerVlanStp.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.networkPorts) {
      NetworkPort.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.loopbacks) {
      Loopback.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.vrfs) {
      Vrf.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.portChannels) {
      PortChannel.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.vnis) {
      Vni.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.staticRoutes) {
      StaticRoutes.encode(v!, writer.uint32(114).fork()).join();
    }
    for (const v of message.dhcpRelays) {
      DhcpRelay.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.subInterfaces) {
      SubInterface.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.bgpPolicies) {
      BgpPolicy.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.bgpPeers) {
      BgpPeer.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.ipmConfigs) {
      IpmConfig.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.dscpConfigs) {
      DscpConfig.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.packetMirrorings) {
      PacketMirroring.encode(v!, writer.uint32(170).fork()).join();
    }
    for (const v of message.serverMgmtPorts) {
      ServerMgmtPort.encode(v!, writer.uint32(186).fork()).join();
    }
    for (const v of message.ipSlaConfigs) {
      IpSlaConfig.encode(v!, writer.uint32(194).fork()).join();
    }
    for (const v of message.arsConfigs) {
      ArsConfig.encode(v!, writer.uint32(210).fork()).join();
    }
    if (message.background !== false) {
      writer.uint32(216).bool(message.background);
    }
    if (message.password !== "") {
      writer.uint32(226).string(message.password);
    }
    if (message.passwordHash !== "") {
      writer.uint32(234).string(message.passwordHash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportedFabricConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportedFabricConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.renameAs = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.schema = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabric = Fabric.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.portBreakouts.push(PortBreakout.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nodes.push(Node.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.perVlanStps.push(PerVlanStp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.networkPorts.push(NetworkPort.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.loopbacks.push(Loopback.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.vrfs.push(Vrf.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.portChannels.push(PortChannel.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.vnis.push(Vni.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.staticRoutes.push(StaticRoutes.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.dhcpRelays.push(DhcpRelay.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.subInterfaces.push(SubInterface.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.bgpPolicies.push(BgpPolicy.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.bgpPeers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.ipmConfigs.push(IpmConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.dscpConfigs.push(DscpConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.packetMirrorings.push(PacketMirroring.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.serverMgmtPorts.push(ServerMgmtPort.decode(reader, reader.uint32()));
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.ipSlaConfigs.push(IpSlaConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.arsConfigs.push(ArsConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.background = reader.bool();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.passwordHash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportedFabricConfiguration {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      renameAs: isSet(object.renameAs) ? globalThis.String(object.renameAs) : "",
      schema: isSet(object.schema) ? globalThis.String(object.schema) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      fabric: isSet(object.fabric) ? Fabric.fromJSON(object.fabric) : undefined,
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
      portBreakouts: globalThis.Array.isArray(object?.portBreakouts)
        ? object.portBreakouts.map((e: any) => PortBreakout.fromJSON(e))
        : [],
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => Node.fromJSON(e)) : [],
      perVlanStps: globalThis.Array.isArray(object?.perVlanStps)
        ? object.perVlanStps.map((e: any) => PerVlanStp.fromJSON(e))
        : [],
      networkPorts: globalThis.Array.isArray(object?.networkPorts)
        ? object.networkPorts.map((e: any) => NetworkPort.fromJSON(e))
        : [],
      loopbacks: globalThis.Array.isArray(object?.loopbacks)
        ? object.loopbacks.map((e: any) => Loopback.fromJSON(e))
        : [],
      vrfs: globalThis.Array.isArray(object?.vrfs) ? object.vrfs.map((e: any) => Vrf.fromJSON(e)) : [],
      portChannels: globalThis.Array.isArray(object?.portChannels)
        ? object.portChannels.map((e: any) => PortChannel.fromJSON(e))
        : [],
      vnis: globalThis.Array.isArray(object?.vnis)
        ? object.vnis.map((e: any) => Vni.fromJSON(e))
        : [],
      staticRoutes: globalThis.Array.isArray(object?.staticRoutes)
        ? object.staticRoutes.map((e: any) => StaticRoutes.fromJSON(e))
        : [],
      dhcpRelays: globalThis.Array.isArray(object?.dhcpRelays)
        ? object.dhcpRelays.map((e: any) => DhcpRelay.fromJSON(e))
        : [],
      subInterfaces: globalThis.Array.isArray(object?.subInterfaces)
        ? object.subInterfaces.map((e: any) => SubInterface.fromJSON(e))
        : [],
      bgpPolicies: globalThis.Array.isArray(object?.bgpPolicies)
        ? object.bgpPolicies.map((e: any) => BgpPolicy.fromJSON(e))
        : [],
      bgpPeers: globalThis.Array.isArray(object?.bgpPeers) ? object.bgpPeers.map((e: any) => BgpPeer.fromJSON(e)) : [],
      ipmConfigs: globalThis.Array.isArray(object?.ipmConfigs)
        ? object.ipmConfigs.map((e: any) => IpmConfig.fromJSON(e))
        : [],
      dscpConfigs: globalThis.Array.isArray(object?.dscpConfigs)
        ? object.dscpConfigs.map((e: any) => DscpConfig.fromJSON(e))
        : [],
      packetMirrorings: globalThis.Array.isArray(object?.packetMirrorings)
        ? object.packetMirrorings.map((e: any) => PacketMirroring.fromJSON(e))
        : [],
      serverMgmtPorts: globalThis.Array.isArray(object?.serverMgmtPorts)
        ? object.serverMgmtPorts.map((e: any) => ServerMgmtPort.fromJSON(e))
        : [],
      ipSlaConfigs: globalThis.Array.isArray(object?.ipSlaConfigs)
        ? object.ipSlaConfigs.map((e: any) => IpSlaConfig.fromJSON(e))
        : [],
      arsConfigs: globalThis.Array.isArray(object?.arsConfigs)
        ? object.arsConfigs.map((e: any) => ArsConfig.fromJSON(e))
        : [],
      background: isSet(object.background) ? globalThis.Boolean(object.background) : false,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      passwordHash: isSet(object.passwordHash) ? globalThis.String(object.passwordHash) : "",
    };
  },

  toJSON(message: ExportedFabricConfiguration): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.renameAs !== "") {
      obj.renameAs = message.renameAs;
    }
    if (message.schema !== "") {
      obj.schema = message.schema;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.fabric !== undefined) {
      obj.fabric = Fabric.toJSON(message.fabric);
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    if (message.portBreakouts?.length) {
      obj.portBreakouts = message.portBreakouts.map((e) => PortBreakout.toJSON(e));
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => Node.toJSON(e));
    }
    if (message.perVlanStps?.length) {
      obj.perVlanStps = message.perVlanStps.map((e) => PerVlanStp.toJSON(e));
    }
    if (message.networkPorts?.length) {
      obj.networkPorts = message.networkPorts.map((e) => NetworkPort.toJSON(e));
    }
    if (message.loopbacks?.length) {
      obj.loopbacks = message.loopbacks.map((e) => Loopback.toJSON(e));
    }
    if (message.vrfs?.length) {
      obj.vrfs = message.vrfs.map((e) => Vrf.toJSON(e));
    }
    if (message.portChannels?.length) {
      obj.portChannels = message.portChannels.map((e) => PortChannel.toJSON(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => Vni.toJSON(e));
    }
    if (message.staticRoutes?.length) {
      obj.staticRoutes = message.staticRoutes.map((e) => StaticRoutes.toJSON(e));
    }
    if (message.dhcpRelays?.length) {
      obj.dhcpRelays = message.dhcpRelays.map((e) => DhcpRelay.toJSON(e));
    }
    if (message.subInterfaces?.length) {
      obj.subInterfaces = message.subInterfaces.map((e) => SubInterface.toJSON(e));
    }
    if (message.bgpPolicies?.length) {
      obj.bgpPolicies = message.bgpPolicies.map((e) => BgpPolicy.toJSON(e));
    }
    if (message.bgpPeers?.length) {
      obj.bgpPeers = message.bgpPeers.map((e) => BgpPeer.toJSON(e));
    }
    if (message.ipmConfigs?.length) {
      obj.ipmConfigs = message.ipmConfigs.map((e) => IpmConfig.toJSON(e));
    }
    if (message.dscpConfigs?.length) {
      obj.dscpConfigs = message.dscpConfigs.map((e) => DscpConfig.toJSON(e));
    }
    if (message.packetMirrorings?.length) {
      obj.packetMirrorings = message.packetMirrorings.map((e) => PacketMirroring.toJSON(e));
    }
    if (message.serverMgmtPorts?.length) {
      obj.serverMgmtPorts = message.serverMgmtPorts.map((e) => ServerMgmtPort.toJSON(e));
    }
    if (message.ipSlaConfigs?.length) {
      obj.ipSlaConfigs = message.ipSlaConfigs.map((e) => IpSlaConfig.toJSON(e));
    }
    if (message.arsConfigs?.length) {
      obj.arsConfigs = message.arsConfigs.map((e) => ArsConfig.toJSON(e));
    }
    if (message.background !== false) {
      obj.background = message.background;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.passwordHash !== "") {
      obj.passwordHash = message.passwordHash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportedFabricConfiguration>, I>>(base?: I): ExportedFabricConfiguration {
    return ExportedFabricConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportedFabricConfiguration>, I>>(object: I): ExportedFabricConfiguration {
    const message = createBaseExportedFabricConfiguration();
    message.fabricId = object.fabricId ?? "";
    message.renameAs = object.renameAs ?? "";
    message.schema = object.schema ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.fabric = (object.fabric !== undefined && object.fabric !== null)
      ? Fabric.fromPartial(object.fabric)
      : undefined;
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    message.portBreakouts = object.portBreakouts?.map((e) => PortBreakout.fromPartial(e)) || [];
    message.nodes = object.nodes?.map((e) => Node.fromPartial(e)) || [];
    message.perVlanStps = object.perVlanStps?.map((e) => PerVlanStp.fromPartial(e)) || [];
    message.networkPorts = object.networkPorts?.map((e) => NetworkPort.fromPartial(e)) || [];
    message.loopbacks = object.loopbacks?.map((e) => Loopback.fromPartial(e)) || [];
    message.vrfs = object.vrfs?.map((e) => Vrf.fromPartial(e)) || [];
    message.portChannels = object.portChannels?.map((e) => PortChannel.fromPartial(e)) || [];
    message.vnis = object.vnis?.map((e) => Vni.fromPartial(e)) || [];
    message.staticRoutes = object.staticRoutes?.map((e) => StaticRoutes.fromPartial(e)) || [];
    message.dhcpRelays = object.dhcpRelays?.map((e) => DhcpRelay.fromPartial(e)) || [];
    message.subInterfaces = object.subInterfaces?.map((e) => SubInterface.fromPartial(e)) || [];
    message.bgpPolicies = object.bgpPolicies?.map((e) => BgpPolicy.fromPartial(e)) || [];
    message.bgpPeers = object.bgpPeers?.map((e) => BgpPeer.fromPartial(e)) || [];
    message.ipmConfigs = object.ipmConfigs?.map((e) => IpmConfig.fromPartial(e)) || [];
    message.dscpConfigs = object.dscpConfigs?.map((e) => DscpConfig.fromPartial(e)) || [];
    message.packetMirrorings = object.packetMirrorings?.map((e) => PacketMirroring.fromPartial(e)) || [];
    message.serverMgmtPorts = object.serverMgmtPorts?.map((e) => ServerMgmtPort.fromPartial(e)) || [];
    message.ipSlaConfigs = object.ipSlaConfigs?.map((e) => IpSlaConfig.fromPartial(e)) || [];
    message.arsConfigs = object.arsConfigs?.map((e) => ArsConfig.fromPartial(e)) || [];
    message.background = object.background ?? false;
    message.password = object.password ?? "";
    message.passwordHash = object.passwordHash ?? "";
    return message;
  },
};

function createBaseImportFabricResponse(): ImportFabricResponse {
  return { config: undefined, taskId: "", taskStatus: 0 };
}

export const ImportFabricResponse: MessageFns<ImportFabricResponse> = {
  encode(message: ImportFabricResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      FabricConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.taskId !== "") {
      writer.uint32(18).string(message.taskId);
    }
    if (message.taskStatus !== 0) {
      writer.uint32(24).int32(message.taskStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportFabricResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportFabricResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = FabricConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.taskStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportFabricResponse {
    return {
      config: isSet(object.config) ? FabricConfig.fromJSON(object.config) : undefined,
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "",
      taskStatus: isSet(object.taskStatus) ? taskStatusTypeFromJSON(object.taskStatus) : 0,
    };
  },

  toJSON(message: ImportFabricResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = FabricConfig.toJSON(message.config);
    }
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    if (message.taskStatus !== 0) {
      obj.taskStatus = taskStatusTypeToJSON(message.taskStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImportFabricResponse>, I>>(base?: I): ImportFabricResponse {
    return ImportFabricResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImportFabricResponse>, I>>(object: I): ImportFabricResponse {
    const message = createBaseImportFabricResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? FabricConfig.fromPartial(object.config)
      : undefined;
    message.taskId = object.taskId ?? "";
    message.taskStatus = object.taskStatus ?? 0;
    return message;
  },
};

function createBaseGetDciConfigsRequest(): GetDciConfigsRequest {
  return { dciId: "", fabricIds: [], names: [], candidate: "" };
}

export const GetDciConfigsRequest: MessageFns<GetDciConfigsRequest> = {
  encode(message: GetDciConfigsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    for (const v of message.fabricIds) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(26).string(v!);
    }
    if (message.candidate !== "") {
      writer.uint32(34).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciConfigsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciConfigsRequest {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      fabricIds: globalThis.Array.isArray(object?.fabricIds)
        ? object.fabricIds.map((e: any) => globalThis.String(e))
        : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetDciConfigsRequest): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.fabricIds?.length) {
      obj.fabricIds = message.fabricIds;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciConfigsRequest>, I>>(base?: I): GetDciConfigsRequest {
    return GetDciConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciConfigsRequest>, I>>(object: I): GetDciConfigsRequest {
    const message = createBaseGetDciConfigsRequest();
    message.dciId = object.dciId ?? "";
    message.fabricIds = object.fabricIds?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetDciConfigsInternalRequest(): GetDciConfigsInternalRequest {
  return { request: undefined, orgId: "" };
}

export const GetDciConfigsInternalRequest: MessageFns<GetDciConfigsInternalRequest> = {
  encode(message: GetDciConfigsInternalRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.request !== undefined) {
      GetDciConfigsRequest.encode(message.request, writer.uint32(10).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciConfigsInternalRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciConfigsInternalRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request = GetDciConfigsRequest.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciConfigsInternalRequest {
    return {
      request: isSet(object.request) ? GetDciConfigsRequest.fromJSON(object.request) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
    };
  },

  toJSON(message: GetDciConfigsInternalRequest): unknown {
    const obj: any = {};
    if (message.request !== undefined) {
      obj.request = GetDciConfigsRequest.toJSON(message.request);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciConfigsInternalRequest>, I>>(base?: I): GetDciConfigsInternalRequest {
    return GetDciConfigsInternalRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciConfigsInternalRequest>, I>>(object: I): GetDciConfigsInternalRequest {
    const message = createBaseGetDciConfigsInternalRequest();
    message.request = (object.request !== undefined && object.request !== null)
      ? GetDciConfigsRequest.fromPartial(object.request)
      : undefined;
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseGetDciConfigsResponse(): GetDciConfigsResponse {
  return { configs: [] };
}

export const GetDciConfigsResponse: MessageFns<GetDciConfigsResponse> = {
  encode(message: GetDciConfigsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.configs) {
      DciConfig.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciConfigsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciConfigsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.configs.push(DciConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciConfigsResponse {
    return {
      configs: globalThis.Array.isArray(object?.configs) ? object.configs.map((e: any) => DciConfig.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetDciConfigsResponse): unknown {
    const obj: any = {};
    if (message.configs?.length) {
      obj.configs = message.configs.map((e) => DciConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciConfigsResponse>, I>>(base?: I): GetDciConfigsResponse {
    return GetDciConfigsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciConfigsResponse>, I>>(object: I): GetDciConfigsResponse {
    const message = createBaseGetDciConfigsResponse();
    message.configs = object.configs?.map((e) => DciConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDciCandidate(): DciCandidate {
  return {
    dciId: "",
    name: "",
    active: false,
    txnId: "0",
    revisionId: "0",
    createdBy: "",
    createdAt: undefined,
    modifiedBy: "",
    modifiedAt: undefined,
    reviews: [],
    events: [],
  };
}

export const DciCandidate: MessageFns<DciCandidate> = {
  encode(message: DciCandidate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.active !== false) {
      writer.uint32(24).bool(message.active);
    }
    if (message.txnId !== "0") {
      writer.uint32(32).int64(message.txnId);
    }
    if (message.revisionId !== "0") {
      writer.uint32(40).int64(message.revisionId);
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.modifiedBy !== "") {
      writer.uint32(66).string(message.modifiedBy);
    }
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(74).fork()).join();
    }
    for (const v of message.reviews) {
      CandidateReview.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.events) {
      ActivityEvent.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DciCandidate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDciCandidate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.txnId = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.modifiedBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.reviews.push(CandidateReview.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.events.push(ActivityEvent.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DciCandidate {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "0",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      modifiedBy: isSet(object.modifiedBy) ? globalThis.String(object.modifiedBy) : "",
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      reviews: globalThis.Array.isArray(object?.reviews)
        ? object.reviews.map((e: any) => CandidateReview.fromJSON(e))
        : [],
      events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => ActivityEvent.fromJSON(e)) : [],
    };
  },

  toJSON(message: DciCandidate): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.txnId !== "0") {
      obj.txnId = message.txnId;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.modifiedBy !== "") {
      obj.modifiedBy = message.modifiedBy;
    }
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.reviews?.length) {
      obj.reviews = message.reviews.map((e) => CandidateReview.toJSON(e));
    }
    if (message.events?.length) {
      obj.events = message.events.map((e) => ActivityEvent.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DciCandidate>, I>>(base?: I): DciCandidate {
    return DciCandidate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DciCandidate>, I>>(object: I): DciCandidate {
    const message = createBaseDciCandidate();
    message.dciId = object.dciId ?? "";
    message.name = object.name ?? "";
    message.active = object.active ?? false;
    message.txnId = object.txnId ?? "0";
    message.revisionId = object.revisionId ?? "0";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.modifiedBy = object.modifiedBy ?? "";
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.reviews = object.reviews?.map((e) => CandidateReview.fromPartial(e)) || [];
    message.events = object.events?.map((e) => ActivityEvent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDciCandidatesRequest(): GetDciCandidatesRequest {
  return {
    dciId: "",
    name: "",
    txnId: "0",
    needInactive: false,
    needReviews: false,
    needEvents: false,
    startTime: undefined,
    endTime: undefined,
    pagination: undefined,
  };
}

export const GetDciCandidatesRequest: MessageFns<GetDciCandidatesRequest> = {
  encode(message: GetDciCandidatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.txnId !== "0") {
      writer.uint32(24).int64(message.txnId);
    }
    if (message.needInactive !== false) {
      writer.uint32(32).bool(message.needInactive);
    }
    if (message.needReviews !== false) {
      writer.uint32(40).bool(message.needReviews);
    }
    if (message.needEvents !== false) {
      writer.uint32(48).bool(message.needEvents);
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(58).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(66).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciCandidatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciCandidatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.txnId = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.needInactive = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.needReviews = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.needEvents = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciCandidatesRequest {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "0",
      needInactive: isSet(object.needInactive) ? globalThis.Boolean(object.needInactive) : false,
      needReviews: isSet(object.needReviews) ? globalThis.Boolean(object.needReviews) : false,
      needEvents: isSet(object.needEvents) ? globalThis.Boolean(object.needEvents) : false,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetDciCandidatesRequest): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.txnId !== "0") {
      obj.txnId = message.txnId;
    }
    if (message.needInactive !== false) {
      obj.needInactive = message.needInactive;
    }
    if (message.needReviews !== false) {
      obj.needReviews = message.needReviews;
    }
    if (message.needEvents !== false) {
      obj.needEvents = message.needEvents;
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciCandidatesRequest>, I>>(base?: I): GetDciCandidatesRequest {
    return GetDciCandidatesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciCandidatesRequest>, I>>(object: I): GetDciCandidatesRequest {
    const message = createBaseGetDciCandidatesRequest();
    message.dciId = object.dciId ?? "";
    message.name = object.name ?? "";
    message.txnId = object.txnId ?? "0";
    message.needInactive = object.needInactive ?? false;
    message.needReviews = object.needReviews ?? false;
    message.needEvents = object.needEvents ?? false;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetDciCandidatesResponse(): GetDciCandidatesResponse {
  return { candidates: [], cursor: "", pagination: undefined };
}

export const GetDciCandidatesResponse: MessageFns<GetDciCandidatesResponse> = {
  encode(message: GetDciCandidatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.candidates) {
      DciCandidate.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciCandidatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciCandidatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidates.push(DciCandidate.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciCandidatesResponse {
    return {
      candidates: globalThis.Array.isArray(object?.candidates)
        ? object.candidates.map((e: any) => DciCandidate.fromJSON(e))
        : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetDciCandidatesResponse): unknown {
    const obj: any = {};
    if (message.candidates?.length) {
      obj.candidates = message.candidates.map((e) => DciCandidate.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciCandidatesResponse>, I>>(base?: I): GetDciCandidatesResponse {
    return GetDciCandidatesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciCandidatesResponse>, I>>(object: I): GetDciCandidatesResponse {
    const message = createBaseGetDciCandidatesResponse();
    message.candidates = object.candidates?.map((e) => DciCandidate.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseCommitDciCandidateRequest(): CommitDciCandidateRequest {
  return { dciId: "", name: "", comments: "", revisionId: "0" };
}

export const CommitDciCandidateRequest: MessageFns<CommitDciCandidateRequest> = {
  encode(message: CommitDciCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.comments !== "") {
      writer.uint32(26).string(message.comments);
    }
    if (message.revisionId !== "0") {
      writer.uint32(32).int64(message.revisionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommitDciCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitDciCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommitDciCandidateRequest {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
    };
  },

  toJSON(message: CommitDciCandidateRequest): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommitDciCandidateRequest>, I>>(base?: I): CommitDciCandidateRequest {
    return CommitDciCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommitDciCandidateRequest>, I>>(object: I): CommitDciCandidateRequest {
    const message = createBaseCommitDciCandidateRequest();
    message.dciId = object.dciId ?? "";
    message.name = object.name ?? "";
    message.comments = object.comments ?? "";
    message.revisionId = object.revisionId ?? "0";
    return message;
  },
};

function createBaseCommitDciCandidateResponse(): CommitDciCandidateResponse {
  return { dciId: "", committed: false };
}

export const CommitDciCandidateResponse: MessageFns<CommitDciCandidateResponse> = {
  encode(message: CommitDciCandidateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.committed !== false) {
      writer.uint32(16).bool(message.committed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommitDciCandidateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommitDciCandidateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.committed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommitDciCandidateResponse {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      committed: isSet(object.committed) ? globalThis.Boolean(object.committed) : false,
    };
  },

  toJSON(message: CommitDciCandidateResponse): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.committed !== false) {
      obj.committed = message.committed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommitDciCandidateResponse>, I>>(base?: I): CommitDciCandidateResponse {
    return CommitDciCandidateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommitDciCandidateResponse>, I>>(object: I): CommitDciCandidateResponse {
    const message = createBaseCommitDciCandidateResponse();
    message.dciId = object.dciId ?? "";
    message.committed = object.committed ?? false;
    return message;
  },
};

function createBaseRevertDciCandidateRequest(): RevertDciCandidateRequest {
  return { dciId: "", name: "", comments: "", revisionId: "0" };
}

export const RevertDciCandidateRequest: MessageFns<RevertDciCandidateRequest> = {
  encode(message: RevertDciCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.comments !== "") {
      writer.uint32(26).string(message.comments);
    }
    if (message.revisionId !== "0") {
      writer.uint32(32).int64(message.revisionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevertDciCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevertDciCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevertDciCandidateRequest {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
    };
  },

  toJSON(message: RevertDciCandidateRequest): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevertDciCandidateRequest>, I>>(base?: I): RevertDciCandidateRequest {
    return RevertDciCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevertDciCandidateRequest>, I>>(object: I): RevertDciCandidateRequest {
    const message = createBaseRevertDciCandidateRequest();
    message.dciId = object.dciId ?? "";
    message.name = object.name ?? "";
    message.comments = object.comments ?? "";
    message.revisionId = object.revisionId ?? "0";
    return message;
  },
};

function createBaseReviewDciCandidateRequest(): ReviewDciCandidateRequest {
  return { dciId: "", name: "", comments: "" };
}

export const ReviewDciCandidateRequest: MessageFns<ReviewDciCandidateRequest> = {
  encode(message: ReviewDciCandidateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.comments !== "") {
      writer.uint32(26).string(message.comments);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewDciCandidateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewDciCandidateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewDciCandidateRequest {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
    };
  },

  toJSON(message: ReviewDciCandidateRequest): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewDciCandidateRequest>, I>>(base?: I): ReviewDciCandidateRequest {
    return ReviewDciCandidateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewDciCandidateRequest>, I>>(object: I): ReviewDciCandidateRequest {
    const message = createBaseReviewDciCandidateRequest();
    message.dciId = object.dciId ?? "";
    message.name = object.name ?? "";
    message.comments = object.comments ?? "";
    return message;
  },
};

function createBaseGetFabricMultisitesRequest(): GetFabricMultisitesRequest {
  return { fabricId: "", candidate: "", multisiteIds: [], names: [] };
}

export const GetFabricMultisitesRequest: MessageFns<GetFabricMultisitesRequest> = {
  encode(message: GetFabricMultisitesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    for (const v of message.multisiteIds) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.names) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricMultisitesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricMultisitesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.multisiteIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricMultisitesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      multisiteIds: globalThis.Array.isArray(object?.multisiteIds)
        ? object.multisiteIds.map((e: any) => globalThis.String(e))
        : [],
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetFabricMultisitesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.multisiteIds?.length) {
      obj.multisiteIds = message.multisiteIds;
    }
    if (message.names?.length) {
      obj.names = message.names;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricMultisitesRequest>, I>>(base?: I): GetFabricMultisitesRequest {
    return GetFabricMultisitesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricMultisitesRequest>, I>>(object: I): GetFabricMultisitesRequest {
    const message = createBaseGetFabricMultisitesRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.multisiteIds = object.multisiteIds?.map((e) => e) || [];
    message.names = object.names?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetFabricMultisitesResponse(): GetFabricMultisitesResponse {
  return { multisites: [] };
}

export const GetFabricMultisitesResponse: MessageFns<GetFabricMultisitesResponse> = {
  encode(message: GetFabricMultisitesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.multisites) {
      FabricMultisite.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricMultisitesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricMultisitesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.multisites.push(FabricMultisite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricMultisitesResponse {
    return {
      multisites: globalThis.Array.isArray(object?.multisites)
        ? object.multisites.map((e: any) => FabricMultisite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetFabricMultisitesResponse): unknown {
    const obj: any = {};
    if (message.multisites?.length) {
      obj.multisites = message.multisites.map((e) => FabricMultisite.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricMultisitesResponse>, I>>(base?: I): GetFabricMultisitesResponse {
    return GetFabricMultisitesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricMultisitesResponse>, I>>(object: I): GetFabricMultisitesResponse {
    const message = createBaseGetFabricMultisitesResponse();
    message.multisites = object.multisites?.map((e) => FabricMultisite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRunCommandRequest(): RunCommandRequest {
  return { deviceId: "", command: undefined, outputStream: 0, ttl: 0, persist: undefined };
}

export const RunCommandRequest: MessageFns<RunCommandRequest> = {
  encode(message: RunCommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.command !== undefined) {
      Command.encode(message.command, writer.uint32(18).fork()).join();
    }
    if (message.outputStream !== 0) {
      writer.uint32(24).uint32(message.outputStream);
    }
    if (message.ttl !== 0) {
      writer.uint32(32).uint32(message.ttl);
    }
    if (message.persist !== undefined) {
      writer.uint32(40).bool(message.persist);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunCommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.command = Command.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.outputStream = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ttl = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.persist = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCommandRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      command: isSet(object.command) ? Command.fromJSON(object.command) : undefined,
      outputStream: isSet(object.outputStream) ? globalThis.Number(object.outputStream) : 0,
      ttl: isSet(object.ttl) ? globalThis.Number(object.ttl) : 0,
      persist: isSet(object.persist) ? globalThis.Boolean(object.persist) : undefined,
    };
  },

  toJSON(message: RunCommandRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.command !== undefined) {
      obj.command = Command.toJSON(message.command);
    }
    if (message.outputStream !== 0) {
      obj.outputStream = Math.round(message.outputStream);
    }
    if (message.ttl !== 0) {
      obj.ttl = Math.round(message.ttl);
    }
    if (message.persist !== undefined) {
      obj.persist = message.persist;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCommandRequest>, I>>(base?: I): RunCommandRequest {
    return RunCommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCommandRequest>, I>>(object: I): RunCommandRequest {
    const message = createBaseRunCommandRequest();
    message.deviceId = object.deviceId ?? "";
    message.command = (object.command !== undefined && object.command !== null)
      ? Command.fromPartial(object.command)
      : undefined;
    message.outputStream = object.outputStream ?? 0;
    message.ttl = object.ttl ?? 0;
    message.persist = object.persist ?? undefined;
    return message;
  },
};

function createBaseRunCommandResponse(): RunCommandResponse {
  return { sessionId: "" };
}

export const RunCommandResponse: MessageFns<RunCommandResponse> = {
  encode(message: RunCommandResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== "") {
      writer.uint32(10).string(message.sessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunCommandResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCommandResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCommandResponse {
    return { sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "" };
  },

  toJSON(message: RunCommandResponse): unknown {
    const obj: any = {};
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCommandResponse>, I>>(base?: I): RunCommandResponse {
    return RunCommandResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCommandResponse>, I>>(object: I): RunCommandResponse {
    const message = createBaseRunCommandResponse();
    message.sessionId = object.sessionId ?? "";
    return message;
  },
};

function createBaseStopCommandRequest(): StopCommandRequest {
  return { deviceId: "", sessionId: "" };
}

export const StopCommandRequest: MessageFns<StopCommandRequest> = {
  encode(message: StopCommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.sessionId !== "") {
      writer.uint32(18).string(message.sessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopCommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopCommandRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
    };
  },

  toJSON(message: StopCommandRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopCommandRequest>, I>>(base?: I): StopCommandRequest {
    return StopCommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopCommandRequest>, I>>(object: I): StopCommandRequest {
    const message = createBaseStopCommandRequest();
    message.deviceId = object.deviceId ?? "";
    message.sessionId = object.sessionId ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
